// --- V2.5.3 ---

import React, { useState, useEffect, useCallback, useMemo, useRef, useLayoutEffect } from 'react';
import { initializeApp } from 'firebase/app';
import {
    getFirestore, doc, setDoc, onSnapshot, serverTimestamp, collection,
    query, orderBy, getDocs, enableIndexedDbPersistence, Timestamp, addDoc,
    where, updateDoc, arrayUnion, arrayRemove, writeBatch, documentId,
    runTransaction, deleteDoc, getDoc, limit
} from 'firebase/firestore';
import {
    getAuth,
    signInAnonymously,
    onAuthStateChanged,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    signOut,
    linkWithCredential,
    EmailAuthProvider
} from 'firebase/auth';
import { BrowserRouter, Routes, Route, NavLink, Navigate, useParams, useLocation } from 'react-router-dom';


import AdminPanel from './AdminPanel';


// --- Configuração do Firebase ---
const firebaseConfig = {
    apiKey: "AIzaSyD_bC8SH9mWFXGi0Qvpe-f9H6mTLwUrTCw",
    authDomain: "meu-mu-online-c454c.firebaseapp.com",
    projectId: "meu-mu-online-c454c",
    storageBucket: "meu-mu-online-c454c.appspot.com",
    messagingSenderId: "561986095283",
    appId: "1:561986095283:web:07b038000b13071c64c8c6"
};

// --- Inicialização do Firebase ---
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const auth = getAuth(app);


// --- ATIVAÇÃO DA PERSISTÊNCIA OFFLINE ---
enableIndexedDbPersistence(db)
  .catch((err) => {
      if (err.code === 'failed-precondition') {
          console.warn("Persistência do Firestore falhou: múltiplas abas abertas.");
      } else if (err.code === 'unimplemented') {
          console.warn("Persistência do Firestore não suportada neste navegador.");
      }
  });


// --- Ícones (Componentes React) ---
const AttackIcon = () => <span role="img" aria-label="attack" className="mr-1" >⚔️</span>;
const DefenseIcon = () => <span role="img" aria-label="defense" className="mr-1">🛡️</span>;
const HealthIcon = () => <span role="img" aria-label="health" className="mr-1">❤️</span>;
const ManaIcon = () => <span role="img" aria-label="mana" className="mr-1">💙</span>;
const StaminaIcon = () => <span role="img" aria-label="stamina" className="text-yellow-500">⚡</span>;
const LockIcon = () => <span role="img" aria-label="locked" className="ml-1 text-red-500">🔒</span>;
const RefreshIcon = () => <span role="img" aria-label="refresh" className="text-white">🔄</span>;
const CoinIcon = () => <img src="/images/items/gold01.png" alt="Ouro" className="w-6 h-6 object-contain" draggable={false} />;
const HomeIcon = () => <img src="/images/home.png" alt="Home" className="w-5 h-5 object-contain" draggable={false} />;
const RankingIcon = ({ className = 'w-5 h-5' }) => <img src="/images/medal01.png" alt="Ranking" className={`${className} object-contain`} draggable={false} />;
const LogoutIcon = () => <span role="img" aria-label="logout" className="text-white"></span>;
const PotionIcon = ({ className = 'w-12 h-14' }) => <img src="/images/items/potion01.png" alt="Poção HP" className={`${className} object-contain`} draggable={false} />;
const ManaPotionIcon = ({ className = 'w-12 h-14' }) => <img src="/images/items/potion02.png" alt="Poção Mana" className={`${className} object-contain`} draggable={false} />;
const JewelIcon = () => <img src="/images/items/jewel01.png" alt="Joia da Benção" className="w-12 h-14 object-contain" draggable={false} />;
const SoulJewelIcon = () => <img src="/images/items/jewel02.png" alt="Joia da Alma" className="w-14 h-14 object-contain" draggable={false} />;
const SwordIcon = () => <img src="/images/items/sword01.png" alt="Espada" className="w-10 h-10 object-contain" draggable={false} />;
const ShieldIcon = () => <img src="/images/items/shield01.png" alt="Escudo" className="w-10 h-10 object-contain" draggable={false} />;
const StaminaPotionIcon = ({ className = 'w-12 h-14' }) => <img src="/images/items/potion03.png" alt="Poção Stamina" className={`${className} object-contain`} draggable={false} />;
const StaffIcon = () => <img src="/images/items/staff01.png" alt="Cajado" className="w-10 h-10 object-contain" draggable={false} />;
const BowIcon = () => <img src="/images/items/bow01.png" alt="Arco" className="w-10 h-10 object-contain" draggable={false} />;
const PetIcon = () => <img src="/images/items/pet01.png" alt="Montaria" className="w-8 h-8 object-contain" draggable={false} />;
const MarketIcon = ({ className = 'w-5 h-5' }) => <img src="/images/market01.png" alt="Mercado" className={`${className} object-contain`} draggable={false} />;
const FriendsIcon = () => <img src="/images/friends01.png" alt="Amigos" className="w-5 h-5 object-contain" draggable={false} />;
const ChatIcon = () => <span role="img" aria-label="chat" className="text-white">💬</span>;
const ScrollIcon = () => <img src="/images/items/scroll01.png" alt="Pergaminho" className="w-10 h-10 object-contain" draggable={false} />;
const RecipeIcon = () => <img src="/images/items/recipe01.png" alt="Receita" className="w-10 h-10 object-contain" draggable={false} />;
const SaveIcon = () => <span role="img" aria-label="save" className="text-white"></span>;
const InvasionIcon = ({ className = 'w-5 h-5' }) => <img src="/images/invasion.png" alt="Invasões" className={`${className} object-contain`} draggable={false} />;
const MissionsIcon = ({ className = 'w-5 h-5' }) => <img src="/images/missions.png" alt="Missões" className={`${className} object-contain`} draggable={false} />; 


// Ícones para ASAS 
const WingIcon = () => <img src="/images/items/wings01.png" alt="Asa da Honra" className="w-12 h-12 object-contain" draggable={false} />;
const WingIconElf = () => <img src="/images/items/wings02.png" alt="Asa da Eternidade" className="w-12 h-12 object-contain" draggable={false} />;
const WingIconMage = () => <img src="/images/items/wings03.png" alt="Asa Sagrada" className="w-12 h-12 object-contain" draggable={false} />;


// Ícones para Guerreiro 1 
const HelmetIcon = () => <img src="/images/items/helm01.png" alt="Capacete de Ouro" className="w-10 h-10 object-contain" draggable={false} />;
const ArmorIcon = () => <img src="/images/items/armor01.png" alt="Armadura de Ouro" className="w-12 h-12 object-contain" draggable={false} />;
const PantsIcon = () => <img src="/images/items/pants01.png" alt="Calças de Ouro" className="w-12 h-12 object-contain" draggable={false} />;
const GlovesIcon = () => <img src="/images/items/gloves01.png" alt="Luvas de Ouro" className="w-12 h-10 object-contain" draggable={false} />;
const BootsIcon = () => <img src="/images/items/boots01.png" alt="Botas de Ouro" className="w-10 h-12 object-contain" draggable={false} />;


// Ícones para Guerreiro 2 
const WarriorHelmetIcon = () => <img src="/images/items/helm02.png" alt="Elmo de Ferro" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorArmorIcon = () => <img src="/images/items/armor02.png" alt="Armadura de Ferro" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorPantsIcon = () => <img src="/images/items/pants02.png" alt="Calças de Ferro" className="w-12 h-12 object-contain" draggable={false} />;
const WarriorGlovesIcon = () => <img src="/images/items/gloves02.png" alt="Luvas de Ferro" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorBootsIcon = () => <img src="/images/items/boots02.png" alt="Botas de Ferro" className="w-10 h-12 object-contain" draggable={false} />;

// Ícones para Guerreiro 3 
const WarriorHelmetTreeIcon = () => <img src="/images/items/helm03.png" alt="Elmo da Escuridão" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorArmorTreeIcon = () => <img src="/images/items/armor03.png" alt="Armadura da Escuridão" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorPantsTreeIcon = () => <img src="/images/items/pants03.png" alt="Calças da Escuridão" className="w-12 h-12 object-contain" draggable={false} />;
const WarriorGlovesTreeIcon = () => <img src="/images/items/gloves03.png" alt="Luvas da Escuridão" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorBootsTreeIcon = () => <img src="/images/items/boots03.png" alt="Botas da Escuridão" className="w-10 h-12 object-contain" draggable={false} />;

// Ícones para Guerreiro 4 
const WarriorHelmetFourIcon = () => <img src="/images/items/helm04.png" alt="Elmo do Dragão" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorArmorFourIcon = () => <img src="/images/items/armor04.png" alt="Armadura do Dragão" className="w-12 h-10 object-contain" draggable={false} />;
const WarriorPantsFourIcon = () => <img src="/images/items/pants04.png" alt="Calças do Dragão" className="w-12 h-12 object-contain" draggable={false} />;
const WarriorGlovesFourIcon = () => <img src="/images/items/gloves04.png" alt="Luvas do Dragão" className="w-10 h-10 object-contain" draggable={false} />;
const WarriorBootsFourIcon = () => <img src="/images/items/boots04.png" alt="Botas do Dragão" className="w-10 h-12 object-contain" draggable={false} />;

// Kit da Elfa 1
const ElfHelmetIcon = () => <img src="/images/items/helm05.png" alt="Elmo da Natureza" className="w-10 h-10 object-contain" draggable={false} />;
const ElfArmorIcon = () => <img src="/images/items/armor05.png" alt="Armadura da Natureza" className="w-10 h-10 object-contain" draggable={false} />;
const ElfPantsIcon = () => <img src="/images/items/pants05.png" alt="Calças da Natureza" className="w-12 h-12 object-contain" draggable={false} />;
const ElfGlovesIcon = () => <img src="/images/items/gloves05.png" alt="Luvas da Natureza" className="w-10 h-10 object-contain" draggable={false} />;
const ElfBootsIcon = () => <img src="/images/items/boots05.png" alt="Botas da Natureza" className="w-10 h-12 object-contain" draggable={false} />;

// Kit da Elfa 2
const ElfHelmetIconTwo = () => <img src="/images/items/helm06.png" alt="Elmo do Guardião" className="w-10 h-10 object-contain" draggable={false} />;
const ElfArmorIconTwo = () => <img src="/images/items/armor06.png" alt="Armadura do Guardião" className="w-10 h-12 object-contain" draggable={false} />;
const ElfPantsIconTwo = () => <img src="/images/items/pants06.png" alt="Calças do Guardião" className="w-10 h-12 object-contain" draggable={false} />;
const ElfGlovesIconTwo = () => <img src="/images/items/gloves06.png" alt="Luvas do Guardião" className="w-10 h-10 object-contain" draggable={false} />;
const ElfBootsIconTwo = () => <img src="/images/items/boots06.png" alt="Botas do Guardião" className="w-10 h-12 object-contain" draggable={false} />;

// Kit do Mago 1
const MageHelmetIcon = () => <img src="/images/items/helm07.png" alt="Elmo da Luz" className="w-10 h-10 object-contain" draggable={false} />;
const MageArmorIcon = () => <img src="/images/items/armor07.png" alt="Armadura da Luz" className="w-10 h-10 object-contain" draggable={false} />;
const MagePantsIcon = () => <img src="/images/items/pants07.png" alt="Calças da Luz" className="w-12 h-12 object-contain" draggable={false} />;
const MageGlovesIcon = () => <img src="/images/items/gloves07.png" alt="Luvas da Luz" className="w-10 h-10 object-contain" draggable={false} />;
const MageBootsIcon = () => <img src="/images/items/boots07.png" alt="Botas da Luz" className="w-10 h-12 object-contain" draggable={false} />;



// --- Constantes do Jogo ---
const ITEM_TYPES = {
    Sword: { icon: <SwordIcon />, name: 'Espada', slot: 'hand', class: 'Guerreiro' },
    Shield: { icon: <ShieldIcon />, name: 'Escudo', slot: 'hand' },
    Staff: { icon: <StaffIcon />, name: 'Cajado', slot: 'hand', class: 'Mago' },
    Bow: { icon: <BowIcon />, name: 'Arco', slot: 'hand', class: 'Elfo' },
    Pet: { icon: <PetIcon/>, name: 'Pet/Montaria', slot: 'Pet' },
    VelocidadeScroll: { icon: <ScrollIcon />, name: 'Pergaminho da Velocidade', slot: 'consumable', class: 'Guerreiro', skillId: 'ataque_veloz' },
    FogoScroll: { icon: <ScrollIcon />, name: 'Pergaminho do Fogo', slot: 'consumable', class: 'Mago', skillId: 'explosao_de_fogo' },
    MisticoScroll: { icon: <ScrollIcon />, name: 'Pergaminho Místico', slot: 'consumable', class: 'Elfo', skillId: 'tiro_mistico' },
    Potion: { icon: <PotionIcon />, name: 'Poção de Vida', slot: 'consumable' },
    ManaPotion: { icon: <ManaPotionIcon />, name: 'Poção de Mana', slot: 'consumable' },
    StaminaPotion: { icon: <StaminaPotionIcon />, name: 'Poção de Stamina', slot: 'consumable' },
    Blessing: { icon: <JewelIcon />, name: 'Joia da Benção', slot: 'consumable' },
    Soul: { icon: <SoulJewelIcon />, name: 'Joia da Alma', slot: 'consumable' },

// Ícones para RECEITAS
    AsaRecipe: { icon: <RecipeIcon />, name: 'Receita: Asa da Honra', slot: 'consumable', recipeId: 'asa_lvl1' },
    AsaRecipeElf: { icon: <RecipeIcon />, name: 'Receita: Asa da Eternidade', slot: 'consumable', recipeId: 'asa_lvl2' },
    AsaRecipeMage: { icon: <RecipeIcon />, name: 'Receita: Asa Sagrada', slot: 'consumable', recipeId: 'asa_lvl3' },

// Ícones para ASAS 
    Wing: { icon: <WingIcon/>, name: 'Asa da Honra', slot: 'Wing', class: 'Guerreiro' },
    WingElf: { icon: <WingIconElf/>, name: 'Asa da Eternidade', slot: 'Wing', class: 'Elfo' },
    WingMage: { icon: <WingIconMage/>, name: 'Asa Sagrada', slot: 'Wing', class: 'Mago' },

 // Kit do Guerreiro 1
    Helmet: { icon: <HelmetIcon />, name: 'Elmo de Ouro', slot: 'Helmet' },
    Armor: { icon: <ArmorIcon />, name: 'Armadura de Ouro', slot: 'Armor' },
    Pants: { icon: <PantsIcon />, name: 'Calças de Ouro', slot: 'Pants' },
    Boots: { icon: <BootsIcon />, name: 'Botas de Ouro', slot: 'Boots' },
    Gloves: { icon: <GlovesIcon />, name: 'Luvas de Ouro', slot: 'Gloves' },

    // Kit do Guerreiro 2
    WarriorHelmet: { icon: <WarriorHelmetIcon />, name: 'Elmo de Ferro', slot: 'Helmet', class: 'Guerreiro' },
    WarriorArmor: { icon: <WarriorArmorIcon />, name: 'Peitoral de Ferro', slot: 'Armor', class: 'Guerreiro' },
    WarriorPants: { icon: <WarriorPantsIcon />, name: 'Calças de Ferro', slot: 'Pants', class: 'Guerreiro' },
    WarriorGloves: { icon: <WarriorGlovesIcon />, name: 'Luvas de Ferro', slot: 'Gloves', class: 'Guerreiro' },
    WarriorBoots: { icon: <WarriorBootsIcon />, name: 'Botas de Ferro', slot: 'Boots', class: 'Guerreiro' },

    // Kit do Guerreiro 3
    WarriorHelmetTree: { icon: <WarriorHelmetTreeIcon />, name: 'Elmo da Escuridão', slot: 'Helmet', class: 'Guerreiro' },
    WarriorArmorTree: { icon: <WarriorArmorTreeIcon />, name: 'Peitoral da Escuridão', slot: 'Armor', class: 'Guerreiro' },
    WarriorPantsTree: { icon: <WarriorPantsTreeIcon />, name: 'Calças da Escuridão', slot: 'Pants', class: 'Guerreiro' },
    WarriorGlovesTree: { icon: <WarriorGlovesTreeIcon />, name: 'Luvas da Escuridão', slot: 'Gloves', class: 'Guerreiro' },
    WarriorBootsTree: { icon: <WarriorBootsTreeIcon />, name: 'Botas da Escuridão', slot: 'Boots', class: 'Guerreiro' },

    // Kit do Guerreiro 4
    WarriorHelmetFour: { icon: <WarriorHelmetFourIcon />, name: 'Elmo do Dragão', slot: 'Helmet', class: 'Guerreiro' },
    WarriorArmorFour: { icon: <WarriorArmorFourIcon />, name: 'Peitoral do Dragão', slot: 'Armor', class: 'Guerreiro' },
    WarriorPantsFour: { icon: <WarriorPantsFourIcon />, name: 'Calças do Dragão', slot: 'Pants', class: 'Guerreiro' },
    WarriorGlovesFour: { icon: <WarriorGlovesFourIcon />, name: 'Luvas do Dragão', slot: 'Gloves', class: 'Guerreiro' },
    WarriorBootsFour: { icon: <WarriorBootsFourIcon />, name: 'Botas do Dragão', slot: 'Boots', class: 'Guerreiro' },

    // Kit da Elfa 1
    ElfHelmet: { icon: <ElfHelmetIcon />, name: 'Elmo da Natureza', slot: 'Helmet', class: 'Elfo' },
    ElfArmor: { icon: <ElfArmorIcon />, name: 'Armadura da Natureza', slot: 'Armor', class: 'Elfo' },
    ElfPants: { icon: <ElfPantsIcon />, name: 'Calças da Natureza', slot: 'Pants', class: 'Elfo' },
    ElfGloves: { icon: <ElfGlovesIcon />, name: 'Luvas da Natureza', slot: 'Gloves', class: 'Elfo' },
    ElfBoots: { icon: <ElfBootsIcon />, name: 'Botas da Natureza', slot: 'Boots', class: 'Elfo' },

    // Kit da Elfa 2
    ElfHelmetTwo: { icon: <ElfHelmetIconTwo />, name: 'Elmo do Guardião', slot: 'Helmet', class: 'Elfo' },
    ElfArmorTwo: { icon: <ElfArmorIconTwo />, name: 'Armadura do Guardião', slot: 'Armor', class: 'Elfo' },
    ElfPantsTwo: { icon: <ElfPantsIconTwo />, name: 'Calças do Guardião', slot: 'Pants', class: 'Elfo' },
    ElfGlovesTwo: { icon: <ElfGlovesIconTwo />, name: 'Luvas do Guardião', slot: 'Gloves', class: 'Elfo' },
    ElfBootsTwo: { icon: <ElfBootsIconTwo />, name: 'Botas do Guardião', slot: 'Boots', class: 'Elfo' },

    // Kit do Mago 1
    MageHelmet: { icon: <MageHelmetIcon />, name: 'Elmo da Luz', slot: 'Helmet', class: 'Mago' },
    MageArmor: { icon: <MageArmorIcon />, name: 'Armadura da Luz', slot: 'Armor', class: 'Mago' },
    MagePants: { icon: <MagePantsIcon />, name: 'Calças da Luz', slot: 'Pants', class: 'Mago' },
    MageGloves: { icon: <MageGlovesIcon />, name: 'Luvas da Luz', slot: 'Gloves', class: 'Mago' },
    MageBoots: { icon: <MageBootsIcon />, name: 'Botas da Luz', slot: 'Boots', class: 'Mago' },
};

// --- Constantes de Habilidades ---
const SKILLS = {
    'ataque_veloz': {
        name: 'Ataque Veloz',
        description: 'Avança em um ataque veloz e ataca duas vezes o oponente. Chance de 20% de dano duplo.',
        class: 'Guerreiro',
        manaCost: 20,
        cooldown: 2, // 2 rounds
        requiredLevel: 10,
    },
    'explosao_de_fogo': {
        name: 'Explosão de Fogo',
        description: 'Dispara uma bola de fogo que queima o oponente, causando 10% da vida máxima dele como dano por 3 turnos.',
        class: 'Mago',
        manaCost: 10,
        cooldown: 1, // 1 round
        requiredLevel: 10,
        effect: { id: 'burn', duration: 3, damagePercent: 0.10 } // Efeito aplicado ao monstro
    },
    'tiro_mistico': {
        name: 'Tiro Místico',
        description: 'Atira com precisão nos pontos fracos do inimigo, aumentando a chance de dano crítico em 10% neste ataque.',
        class: 'Elfo',
        manaCost: 15,
        cooldown: 1, // 1 round
        requiredLevel: 10,
        effect: { id: 'crit_boost', chance: 0.10 } // Efeito aplicado ao jogador por um turno
    }
};

// --- Constantes de Missões ---
const MISSION_TYPES = {
    KILL_MONSTER: 'KILL_MONSTER',
    CRAFT_ITEM: 'CRAFT_ITEM',
    ADD_FRIEND: 'ADD_FRIEND',
    BUY_MARKET: 'BUY_MARKET',
    // Adicione outros tipos de missão aqui no futuro
};

const MISSIONS = {
    'lorencia_scout': {
        id: 'lorencia_scout',
        name: "Patrulha de Loren",
        description: "As aranhas se espalharam por Loren. Cace 10 delas para ajudar a manter a cidade segura.",
        type: MISSION_TYPES.KILL_MONSTER,
        requiredLevel: 1,
        objective: {
            monsterName: 'Spider',
            targetCount: 10,
        },
        rewards: {
            exp: 250,
            gold: 1000,
            items: [
                { type: 'Potion', quantity: 5 }
            ]
        }
    },
    'first_friend': {
        id: 'first_friend',
        name: "Jornada a Dois",
        description: "A aventura é melhor compartilhada. Adicione seu primeiro amigo para receber uma recompensa.",
        type: MISSION_TYPES.ADD_FRIEND,
        requiredLevel: 5,
        objective: {
            targetCount: 1,
        },
        rewards: {
            exp: 300,
            jewels: [
                { type: 'Blessing', quantity: 1 }
            ]
        }
    },
    'market_deal': {
        id: 'market_deal',
        name: "O Bom Negócio",
        description: "O mercado é o centro de toda a economia. Compre seu primeiro item na loja de outro jogador.",
        type: MISSION_TYPES.BUY_MARKET,
        requiredLevel: 6,
        objective: {
            targetCount: 1,
        },
        rewards: {
            exp: 400,
            gold: 10000,
        }
    },
    'first_craft': {
        id: 'first_craft',
        name: "Mãos à Obra",
        description: "Aprenda a arte da criação. Crafte qualquer asa na Oficina para aprimorar seu poder.",
        type: MISSION_TYPES.CRAFT_ITEM,
        requiredLevel: 15,
        objective: {
            recipeId: 'asa_lvl1',
            targetCount: 1,
        },
        rewards: {
            exp: 2000,
            jewels: [
                { type: 'Soul', quantity: 5 },
                { type: 'Blessing', quantity: 5 }
            ]
        }
    },
    'venore_scout': {
        id: 'venore_scout',
        name: "Patrulha de Venore",
        description: "Os chain scorpions se espalharam por Venore. Cace 20 deles para ajudar a manter a cidade segura.",
        type: MISSION_TYPES.KILL_MONSTER,
        requiredLevel: 20,
        objective: {
            monsterName: 'Chain Scorpion',
            targetCount: 20,
        },
        rewards: {
            exp: 3000,
            gold: 15000,
            items: [
                { type: 'Potion', quantity: 10 }
            ]
        }
    }
    // Adicione novas missões aqui
};



// Constante de CRAFT de itens
const CRAFTING_RECIPES = {

    'asa_lvl1': {
        name: 'Asa da Honra',
        result_base: { type: 'Wing', name: 'Asa da Honra' },
        result_qualities: [
            { quality: 'Comum', chance: 0.50 },   // 50% de chance
            { quality: 'Raro', chance: 0.15 },    // 15% de chance
            { quality: 'Épico', chance: 0.05 },   // 5% de chance
            { quality: 'Lendário', chance: 0.01 } // 1% de chance
        ],
        materials: [
            { type: 'Blessing', quantity: 10 },
            // Futuramente: { type: 'Sword', name: 'Espada Lendária', quantity: 1 }
        ],
        goldCost: 10000,
        successChance: 0.50 // 50%
    },

    'asa_lvl2': {
        name: 'Asa da Eternidade',
        result_base: { type: 'WingElf', name: 'Asa da Eternidade' },
        result_qualities: [
            { quality: 'Comum', chance: 0.50 },   // 50% de chance
            { quality: 'Raro', chance: 0.15 },    // 15% de chance
            { quality: 'Épico', chance: 0.05 },   // 5% de chance
            { quality: 'Lendário', chance: 0.01 } // 1% de chance
        ],
        materials: [
            { type: 'Blessing', quantity: 10 },
        ],
        goldCost: 10000,
        successChance: 0.50 // 50%
    },

    'asa_lvl3': {
        name: 'Asa Sagrada',
        result_base: { type: 'WingMage', name: 'Asa Sagrada' },
        result_qualities: [
            { quality: 'Comum', chance: 0.50 },   // 50% de chance
            { quality: 'Raro', chance: 0.15 },    // 15% de chance
            { quality: 'Épico', chance: 0.05 },   // 5% de chance
            { quality: 'Lendário', chance: 0.01 } // 1% de chance
        ],
        materials: [
            { type: 'Blessing', quantity: 10 },
        ],
        goldCost: 10000,
        successChance: 0.50 // 50%
    },

    // Adicione outras receitas aqui no futuro
    // 'pocao_vida_forte': { ... }

};

// --- NOVO: Constantes de Invasão ---
const INVASIONS = {
    dragon_invasion: {
        id: 'dragon_invasion',
        name: "Invasão do Dragão Vermelho",
        requiredLevel: 10,
        description: "Hordas de dragões vermelhos ameaçam as terras de Loren. Ajude a contê-los e seja recompensado.",
        image: '/images/invasions/dragon.jpg', // Crie esta imagem na pasta public/images/invasions
        durations: [
            { time: 10, label: "10 Min", staminaCost: 20, rewards: { exp: 100, items: 1, jewels: 0.10, maxJewels: 1, goldDropChance: 0.05, goldDropRange: [1000, 5000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 30, label: "30 Min", staminaCost: 30, rewards: { exp: 350, items: 2, jewels: 0.25, maxJewels: 1, goldDropChance: 0.05, goldDropRange: [1000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 60, label: "1 Hora", staminaCost: 40, rewards: { exp: 700, items: 3, jewels: 0.50, maxJewels: 2, goldDropChance: 0.05, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 120, label: "2 Horas", staminaCost: 50, rewards: { exp: 1450, items: 3, jewels: 0.90, maxJewels: 2, goldDropChance: 0.05, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
        ],
    },
    golden_invasion: {
        id: 'golden_invasion',
        name: "Invasão Dourada",
        requiredLevel: 25,
        description: "Criaturas douradas raras apareceram em Venore! Derrotá-las garante grandes quantidades de experiência e joias.",
        image: '/images/invasions/golden.jpg', // Crie esta imagem na pasta public/images/invasions
        durations: [
            { time: 60, label: "1 Hora", staminaCost: 40, rewards: { exp: 800, items: 2, jewels: 0.5, maxJewels: 2, goldDropChance: 0.05, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 120, label: "2 Horas", staminaCost: 50, rewards: { exp: 1700, items: 2, jewels: 0.7, maxJewels: 3, goldDropChance: 0.05, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 360, label: "6 Horas", staminaCost: 60, rewards: { exp: 5000, items: 3, jewels: 0.9, maxJewels: 4, goldDropChance: 0.05, goldDropRange: [10000, 15000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 720, label: "12 Horas", staminaCost: 70, rewards: { exp: 9000, items: 4, jewels: 1.0, maxJewels: 4, goldDropChance: 0.05, goldDropRange: [10000, 15000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
        ],
    },
    undead_invasion: {
        id: 'undead_invasion',
        name: "Invasão dos Mortos-Vivos",
        requiredLevel: 50,
        description: "Um exército de mortos-vivos avança sobre Dungeon. Eles carregam itens raros e poderosos.",
        image: '/images/invasions/undead.jpg', // Crie esta imagem na pasta public/images/invasions
        durations: [
            { time: 60, label: "1 Hora", staminaCost: 50, rewards: { exp: 900, items: 2, jewels: 0.6, maxJewels: 2, goldDropChance: 0.10, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 120, label: "2 Horas", staminaCost: 60, rewards: { exp: 1900, items: 3, jewels: 0.8, maxJewels: 3, goldDropChance: 0.10, goldDropRange: [5000, 10000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 360, label: "6 Horas", staminaCost: 70, rewards: { exp: 5500, items: 4, jewels: 1.0, maxJewels: 4, goldDropChance: 0.10, goldDropRange: [15000, 20000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
            { time: 720, label: "12 Horas", staminaCost: 80, rewards: { exp: 9500, items: 6, jewels: 1.0, maxJewels: 5, goldDropChance: 0.10, goldDropRange: [15000, 20000], itemQualityChances: { Lendário: 0.01, Épico: 0.05, Raro: 0.20 } } },
        ],
    }
};


// --- NOVO: Constantes de Renderização de Equipamento ---
const EQUIPMENT_RENDER_IMAGES = {
    Helmet: '/images/character/render/helm01.png',
    Armor: '/images/character/render/armor01.png',
    Pants: '/images/character/render/pants01.png',
    Gloves: '/images/character/render/gloves01.png',
    Boots: '/images/character/render/boots01.png',
    Wing: '/images/character/render/wings01.png',
    Shield: '/images/character/render/shield01.png',
    Sword: '/images/character/render/sword01.png',
    // Adicione outras armas aqui conforme necessário
};


const CLASS_BASE_STATS = {
    Guerreiro: { strength: 20, agility: 10, health: 50, mana: 20 },
    Mago: { strength: 5, agility: 5, health: 40, mana: 50 },
    Elfo: { strength: 10, agility: 20, health: 45, mana: 30 }
};

const STAT_DEFINITIONS = { strength: 'Força', agility: 'Agilidade', health: 'Vida', mana: 'Mana' };
const STAT_ORDER = ['strength', 'agility', 'health', 'mana'];
const EQUIPMENT_ORDER = {
    Pet: { name: 'Pet', icon: <PetIcon /> },
    Helmet: { name: 'Elmo', icon: <HelmetIcon /> },
    Wing: { name: 'Asa', icon: <WingIcon /> },
    leftHand: { name: 'Mão Esq.', icon: <SwordIcon /> },
    Armor: { name: 'Armadura', icon: <ArmorIcon /> },
    rightHand: { name: 'Mão Dir.', icon: <ShieldIcon /> },
    Gloves: { name: 'Luvas', icon: <GlovesIcon /> },
    Pants: { name: 'Calças', icon: <PantsIcon /> },
    Boots: { name: 'Botas', icon: <BootsIcon /> },
};


// --- Constantes de Drop dos Bosses ---
const ATAQUE_VELOZ_SCROLL_DROP_CHANCE = 10; // 10% de chance para o scroll 'Ataque Veloz'
const EXPLOSAO_DE_FOGO_SCROLL_DROP_CHANCE = 10; // 10% de chance para o scroll 'Explosão de Fogo'
const TIRO_MISTICO_SCROLL_DROP_CHANCE = 10; // 10% de chance para o scroll 'Tiro Místico'
const ASA_RECIPE_DROP_CHANCE = 2; // Chance de 2% para a receita da Asa da Honra
const ASA_ELF_RECIPE_DROP_CHANCE = 2; // Chance de 2% para a receita da Asa da Honra
const ASA_MAGE_RECIPE_DROP_CHANCE = 2; // Chance de 2% para a receita da Asa da Honra


const BULL_FIGHTER_DROPS = [
    { name: 'Joia da Benção', chance: 5 },
    { name: 'Pergaminho da Velocidade', chance: ATAQUE_VELOZ_SCROLL_DROP_CHANCE, type: 'VelocidadeScroll' },
    { name: 'Pergaminho do Fogo', chance: EXPLOSAO_DE_FOGO_SCROLL_DROP_CHANCE, type: 'FogoScroll' },
    { name: 'Pergaminho Místico', chance: TIRO_MISTICO_SCROLL_DROP_CHANCE, type: 'MisticoScroll' },
    { name: 'Receita: Asa da Honra', chance: ASA_RECIPE_DROP_CHANCE, type: 'AsaRecipe' },
    { name: 'Receita: Asa da Eternidade', chance: ASA_ELF_RECIPE_DROP_CHANCE, type: 'AsaRecipeElf' },
    { name: 'Receita: Asa Sagrada', chance: ASA_MAGE_RECIPE_DROP_CHANCE, type: 'AsaRecipeMage' }
];
const FOREST_MONSTER_DROPS = [
    { name: 'Joia da Benção', chance: 5 },
    { name: 'Joia da Alma', chance: 1 },
    { name: 'Receita: Asa da Honra', chance: ASA_RECIPE_DROP_CHANCE, type: 'AsaRecipe' },
    { name: 'Receita: Asa da Eternidade', chance: ASA_ELF_RECIPE_DROP_CHANCE, type: 'AsaRecipeElf' },
    { name: 'Receita: Asa Sagrada', chance: ASA_MAGE_RECIPE_DROP_CHANCE, type: 'AsaRecipeMage' }
];
const GORGON_DROPS = [
    { name: 'Joia da Benção', chance: 5 },
    { name: 'Joia da Alma', chance: 1 },
    { name: 'Joia da Vida', chance: 1 },
    { name: 'Receita: Asa da Honra', chance: ASA_RECIPE_DROP_CHANCE, type: 'AsaRecipe' },
    { name: 'Receita: Asa da Eternidade', chance: ASA_ELF_RECIPE_DROP_CHANCE, type: 'AsaRecipeElf' },
    { name: 'Receita: Asa Sagrada', chance: ASA_MAGE_RECIPE_DROP_CHANCE, type: 'AsaRecipeMage' }
];


const MAPS = {
lorencia: {
    name: 'Loren',
    minLevel: 1,
    backgroundImage: '/images/lorencia-full.png',
    monsters: [
        // Aranhas (Spiders) foram movidas para a parte inferior e central do mapa.
        { name: 'Spider', level: 2, hp: 40, attack: 2, defense: 1, exp: 12, gold: 8, x: '58%', y: '70%' },
        { name: 'Spider', level: 2, hp: 40, attack: 2, defense: 1, exp: 12, gold: 8, x: '70%', y: '85%' },
        { name: 'Spider', level: 3, hp: 50, attack: 4, defense: 2, exp: 17, gold: 12, x: '85%', y: '75%' },
        { name: 'Spider', level: 3, hp: 50, attack: 4, defense: 2, exp: 17, gold: 12, x: '75%', y: '70%' },


        // Dragões (Budge Dragons) foram espalhados pelas estradas e campos abertos.
        { name: 'Budge Dragon', level: 5, hp: 65, attack: 15, defense: 7, exp: 25, gold: 15, x: '50%', y: '40%' },
        { name: 'Budge Dragon', level: 5, hp: 65, attack: 15, defense: 7, exp: 25, gold: 15, x: '68%', y: '35%' },
        { name: 'Budge Dragon', level: 5, hp: 65, attack: 15, defense: 7, exp: 25, gold: 15, x: '45%', y: '65%' },
        { name: 'Budge Dragon', level: 6, hp: 75, attack: 18, defense: 9, exp: 30, gold: 18, x: '60%', y: '55%' },

        // O Chefe (Bull Fighter) foi mantido em uma posição de destaque no canto superior direito.
        { name: 'Bull Fighter', level: 10, hp: 120, attack: 20, defense: 12, exp: 40, gold: 22, isMapBoss: true, specialDrops: BULL_FIGHTER_DROPS, legendaryDropChance: 1, x: '90%', y: '20%' },
    ]
},
    noria: {
        name: 'Venore',
        minLevel: 20,
        backgroundImage: '/images/noria-full.png',
        monsters: [
            { name: 'Goblin de Elite', level: 22, hp: 250, attack: 30, defense: 20, exp: 100, gold: 50 },
            { name: 'Goblin de Elite', level: 22, hp: 250, attack: 30, defense: 20, exp: 100, gold: 50 },
            { name: 'Goblin de Elite', level: 22, hp: 250, attack: 30, defense: 20, exp: 100, gold: 50 },
            { name: 'Goblin de Elite', level: 23, hp: 280, attack: 32, defense: 23, exp: 120, gold: 60 },

            { name: 'Chain Scorpion', level: 25, hp: 300, attack: 35, defense: 25, exp: 130, gold: 65 },
            { name: 'Chain Scorpion', level: 25, hp: 300, attack: 35, defense: 25, exp: 130, gold: 65 },
            { name: 'Chain Scorpion', level: 28, hp: 350, attack: 36, defense: 27, exp: 160, gold: 80 },

            { name: 'Forest Monster', level: 30, hp: 400, attack: 40, defense: 30, exp: 200, gold: 90, isMapBoss: true, specialDrops: FOREST_MONSTER_DROPS, legendaryDropChance: 2 },
            { name: 'Forest Monster', level: 30, hp: 400, attack: 40, defense: 30, exp: 200, gold: 90, isMapBoss: true, specialDrops: FOREST_MONSTER_DROPS, legendaryDropChance: 2 },
        ]
    },
    dungeon: {
        name: 'Dungeon',
        minLevel: 40,
        backgroundImage: '/images/dungeon-full.png', 
        monsters: [
            { name: 'Esqueleto Guerreiro', level: 42, hp: 600, attack: 40, defense: 40, exp: 350, gold: 150 },
            { name: 'Esqueleto Guerreiro', level: 42, hp: 600, attack: 40, defense: 40, exp: 350, gold: 150 },
            { name: 'Esqueleto Guerreiro', level: 43, hp: 650, attack: 44, defense: 43, exp: 400, gold: 170 },

            { name: 'Hell Hound', level: 45, hp: 750, attack: 50, defense: 45, exp: 450, gold: 200 },
            { name: 'Hell Hound', level: 45, hp: 750, attack: 50, defense: 45, exp: 450, gold: 200 },
            { name: 'Hell Hound', level: 47, hp: 850, attack: 56, defense: 49, exp: 520, gold: 250 },

            { name: 'Gorgon', level: 50, hp: 1000, attack: 60, defense: 55, exp: 600, gold: 300, isMapBoss: true, specialDrops: GORGON_DROPS, legendaryDropChance: 3 },
            { name: 'Gorgon', level: 50, hp: 1000, attack: 60, defense: 55, exp: 600, gold: 300, isMapBoss: true, specialDrops: GORGON_DROPS, legendaryDropChance: 3 },
            { name: 'Gorgon', level: 50, hp: 1000, attack: 60, defense: 55, exp: 600, gold: 300, isMapBoss: true, specialDrops: GORGON_DROPS, legendaryDropChance: 3 },
        ]
    }
};

// --- NOVO: Constantes para Limites de Spawn e Zonas Seguras ---
const MAP_SPAWN_BOUNDS = {
    lorencia: { minX: 40, maxX: 92, minY: 10, maxY: 92 }, 
    noria:    { minX: 10, maxX: 92, minY: 10, maxY: 92 }, 
    dungeon:  { minX: 10, maxX: 90, minY: 10, maxY: 90 },
};

const MAP_NO_SPAWN_ZONES = {
    lorencia: [
        // Coordenadas aproximadas da cidade de Lorencia para criar uma zona segura
        { x1: 0, y1: 0, x2: 48, y2: 70 }, 
        { x1: 34, y1: 0, x2: 66, y2: 20 }
    ],
    noria: [
        /// Coordenadas aproximadas da cidade de Noria para criar uma zona segura
        { x1: 0, y1: 0, x2: 38, y2: 45 },
        { x1: 34, y1: 0, x2: 66, y2: 20 }
    ],
    dungeon: [
        /// Coordenadas logo
        { x1: 34, y1: 0, x2: 66, y2: 20 }
    ]
};

const MAX_UPGRADE_LEVEL = 9;
const MAX_STAMINA = 100;
const CHEST_SIZE = 30;
const INVENTORY_LIMIT = 9;
const SHOP_REFRESH_INTERVAL = 2 * 60 * 1000;
const SHOP_LISTING_DURATION_HOURS = 24;
const MAX_PLAYER_SHOPS = 3;
const EXP_MULTIPLIER = 10;
const GOLD_MULTIPLIER = 10;
const ARMOR_STAT_DIVISOR = 7.25;
const WEAPON_STAT_DIVISOR = 4.05;
const PLAYER_MISS_CHANCE = 0.05;
const MONSTER_MISS_CHANCE = 0.05;
const CHAT_MIN_LEVEL = 3;
const SELL_PRICE_MULTIPLIER = 1; // Multiplicador de preço de venda
const MARKET_MIN_LEVEL = 6; // Nível mínimo para acessar o mercado
const MARKET_MAX_ITEM_PRICE = 10000000; // Limite de preço por item


// --- Constantes de Batalha (Crítico) ---
const PLAYER_CRITICAL_CHANCE = 0.05;
const MONSTER_CRITICAL_CHANCE = 0.05;
const CRITICAL_DAMAGE_MULTIPLIER = 2.0;

// --- Constantes de Balanceamento de Batalha ---
const BATTLE_BALANCE_LEVEL_DIFFERENCE_FACTOR = 0.1; // Aumenta o dano do monstro em 10% para cada nível acima do jogador.
const BATTLE_BALANCE_MIN_DAMAGE_PERCENT = 0.1; // Garante que o monstro sempre cause pelo menos 10% do seu dano de ataque final, ignorando defesa.
const BATTLE_BALANCE_DEFENSE_EFFECTIVENESS = 0.9; // A defesa do jogador tem 90% de eficácia na mitigação de dano.

// --- Constantes de Opcionais de Itens ---
const ITEM_OPTION_CHANCE_1 = 0.05; // 5% Chance para 1 opcional (Raro, Épico, Lendário)
const ITEM_OPTION_CHANCE_2 = 0.01; // 1% Chance para 2 opcionais (Épico, Lendário)

const ATTACK_OPTIONS = [
    { id: 'double_damage', text: '+2% de Chance de Dano Duplo', value: 0.02 },
    { id: 'critical_chance', text: '+10% de Chance de Dano Crítico', value: 0.10 }
];
const DEFENSE_OPTIONS = [
    { id: 'full_defense', text: '+10% de Chance de Defesa', value: 0.10 },
    { id: 'hp_increase', text: '+5% de HP Máximo', value: 0.05 },
    { id: 'mana_increase', text: '+5% de Mana Máxima', value: 0.05 }
];


// --- Constantes de Divisores de Stats ---
const STRENGTH_TO_ATTACK_DIVISOR = 2;
const AGILITY_TO_DEFENSE_DIVISOR = 1;
const AGILITY_TO_ATTACK_DIVISOR = 1.5; // NOVO
const MANA_TO_ATTACK_DIVISOR = 2; // NOVO
const HEALTH_STAT_TO_HP_DIVISOR = 1.5;
const MANA_STAT_TO_MP_DIVISOR = 1.5;

// --- Constantes de Regeneração ---
const STAMINA_REGEN_RATE = 10000;
const STAMINA_REGEN_AMOUNT = 1;
const HP_REGEN_RATE = 15000;
const HP_REGEN_AMOUNT = 2;
const MANA_REGEN_RATE = 5000;
const MANA_REGEN_AMOUNT = 1;

// --- Multiplicadores de Regeneração ---
const HP_REGEN_MULTIPLIER = 1;
const MANA_REGEN_MULTIPLIER = 1;
const STAMINA_REGEN_MULTIPLIER = 1;


// --- Funções Auxiliares ---

// NOVA FUNÇÃO para abreviar a exibição de ouro
const formatGold = (amount) => {
    if (amount === null || amount === undefined) return '0';
    const num = Number(amount);

    if (num >= 1000000000) { // Bilhões (Bi)
        return (num / 1000000000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + ' Bi';
    }
    if (num >= 1000000) { // Milhões (Mi)
        return (num / 1000000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + ' Mi';
    }
    if (num >= 1000) { // Mil
        return (num / 1000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + ' mil';
    }
    return num.toLocaleString('pt-BR');
};

const calculateMonsterDamageMultiplier = (playerLevel) => {
    const multiplier = 1 + (playerLevel - 1) * 0.030;
    return multiplier;
};
const calculateSellPrice = (item) => {
    if (!item) return 0;

    // --- NOVA LÓGICA PARA PERGAMINHOS E RECEITAS ---
    if (item.skillId) { // Se for um pergaminho de habilidade
        return 1000; // Retorna um valor de venda fixo
    }
    if (item.recipeId) { // Se for uma receita
        return 5000; // Retorna um valor de venda fixo (geralmente mais raro)
    }

    // --- LÓGICA ORIGINAL PARA EQUIPAMENTOS ---
    if (typeof item.level !== 'number') return 0;

    let price = item.level * 5;
    if (item.quality === 'Raro') price *= 2;
    if (item.quality === 'Épico') price *= 4;
    if (item.quality === 'Lendário') price *= 8;
    price += (item.upgradeLevel || 0) * price * 0.5;
    return Math.floor(price * SELL_PRICE_MULTIPLIER);
};
const calculateStaminaPotionCost = (playerLevel) => { const precoBase = 750; const aumentoFixo = 250; const precoCalculado = precoBase + (aumentoFixo * (playerLevel - 1)); return precoCalculado;};
const calculateLifePotionCost = (playerLevel) => { const baseCost = 50; const cost = baseCost + (baseCost * 1 * (playerLevel - 1)); return cost; };
const calculateManaPotionCost = (playerLevel) => { const baseCost = 60; const cost = baseCost + (baseCost * 1 * (playerLevel - 1)); return cost; };
const getUpgradedStats = (item) => { const upgradedStats = { ...item.stats }; const upgradeBonus = 1 + (item.upgradeLevel || 0) * 0.2; if (upgradedStats.attack > 0) { upgradedStats.attack = Math.floor(item.stats.attack * upgradeBonus); } if (upgradedStats.defense > 0) { upgradedStats.defense = Math.floor(item.stats.defense * upgradeBonus); } return upgradedStats;};
// Gera o ID do chat privado de forma consistente
const getPrivateChatId = (uid1, uid2) => {
    if (!uid1 || !uid2) return null;
    return [uid1, uid2].sort().join('_');
}

const generateRandomItem = (playerLevel, isBoss = false, legendaryChance = 0, itemQualityChances = null) => {

    const itemTypeKeys = Object.keys(ITEM_TYPES).filter(key => {
        const itemDef = ITEM_TYPES[key];
        // --- ALTERAÇÃO AQUI: Adicionado '&& itemDef.slot !== 'Wing'' ---
        // Esta linha garante que apenas itens equipáveis (e que não sejam Asas) sejam gerados aleatoriamente.
        return !itemDef.skillId && !itemDef.recipeId && itemDef.slot !== 'consumable' && itemDef.slot !== 'Wing' && itemDef.slot !== 'Pet';
    });

    const randomTypeKey = itemTypeKeys[Math.floor(Math.random() * itemTypeKeys.length)];
    const itemLevel = Math.max(1, playerLevel + Math.floor(Math.random() * 5) - 2);

    const qualityRoll = Math.random();
    let qualityName = "Comum";
    let qualityColor = 'border-stone-600';
    let statBonus = 1;

    // NOVA LÓGICA: Usa as chances de qualidade da invasão, se fornecidas
    if (itemQualityChances) {
        let cumulativeChance = 0;
        // A ordem de verificação (do melhor para o pior) é importante
        if (itemQualityChances.Lendário && qualityRoll < (cumulativeChance += itemQualityChances.Lendário)) {
            qualityName = "Lendário"; statBonus = 4; qualityColor = 'border-yellow-500';
        } else if (itemQualityChances.Épico && qualityRoll < (cumulativeChance += itemQualityChances.Épico)) {
            qualityName = "Épico"; statBonus = 2.5; qualityColor = 'border-purple-500';
        } else if (itemQualityChances.Raro && qualityRoll < (cumulativeChance += itemQualityChances.Raro)) {
            qualityName = "Raro"; statBonus = 1.5; qualityColor = 'border-blue-500';
        }
    // LÓGICA ANTIGA: Fallback para drops normais de monstros
    } else {
        if (isBoss && legendaryChance > 0 && qualityRoll <= legendaryChance) {
            qualityName = "Lendário"; statBonus = 4; qualityColor = 'border-yellow-500';
        }
        else if (qualityRoll > 0.8) { qualityName = "Épico"; statBonus = 2.5; qualityColor = 'border-purple-500'; }
        else if (qualityRoll > 0.6) { qualityName = "Raro"; statBonus = 1.5; qualityColor = 'border-blue-500'; }
    }

    const baseStat = itemLevel * statBonus;
    const isWeapon = ITEM_TYPES[randomTypeKey]?.slot === 'hand';
    const isArmor = ['Helmet', 'Armor', 'Pants', 'Boots', 'Gloves'].includes(ITEM_TYPES[randomTypeKey]?.slot);

    const item = {
        id: Date.now() + Math.random(),
        name: `${ITEM_TYPES[randomTypeKey].name} ${qualityName}`,
        type: randomTypeKey,
        level: itemLevel,
        upgradeLevel: 0,
        stats: {
            attack: isWeapon && randomTypeKey !== 'Shield' ? Math.floor(baseStat / WEAPON_STAT_DIVISOR) : 0,
            defense: isArmor || randomTypeKey === 'Shield' ? Math.floor(baseStat / ARMOR_STAT_DIVISOR) : 0,
        },
        quality: qualityName,
        qualityColor: qualityColor,
        options: []
    };

    let optionsToAdd = 0;
    const optionPool = isWeapon ? ATTACK_OPTIONS : DEFENSE_OPTIONS;

    if (qualityName === 'Lendário' || qualityName === 'Épico') {
        const roll = Math.random();
        if (roll < ITEM_OPTION_CHANCE_2) {
            optionsToAdd = 2;
        } else if (roll < ITEM_OPTION_CHANCE_1) {
            optionsToAdd = 1;
        }
    } else if (qualityName === 'Raro') {
        const roll = Math.random();
        if (roll < ITEM_OPTION_CHANCE_1) {
            optionsToAdd = 1;
        }
    }


    const availableOptions = [...optionPool];
    for (let i = 0; i < optionsToAdd && availableOptions.length > 0; i++) {
        const randomIndex = Math.floor(Math.random() * availableOptions.length);
        item.options.push(availableOptions[randomIndex]);
        availableOptions.splice(randomIndex, 1);
    }

    item.price = calculateSellPrice(item) * 5 + 50;
    return item;
};


const generateNewShop = (playerLevel) => {
    const shopItems = [];
    const numItems = 5 + Math.floor(Math.random() * 3);
    for (let i = 0; i < numItems; i++) {
        let newItem;
        do {
            newItem = generateRandomItem(playerLevel, false); // Garante que não gera item de boss (lendário)
        } while (newItem.quality === 'Lendário' || ITEM_TYPES[newItem.type]?.recipeId);
        shopItems.push(newItem);
    }
    return shopItems;
};
const initializeMapState = () => {
    const initialState = {};
    for (const mapId in MAPS) {
        // Se o mapa tiver limites de spawn definidos, gera posições aleatórias
        if (MAP_SPAWN_BOUNDS[mapId]) {
            initialState[mapId] = generateRandomMonsters(mapId);
        } else {
            // Mantém o comportamento antigo para mapas futuros sem spawn aleatório
            initialState[mapId] = MAPS[mapId].monsters.map((m, index) => ({ ...m, id: `${mapId}-${index}-${Date.now()}`, currentHp: m.hp }));
        }
    }
    return initialState;
};


// --- Componentes ---

const SaveProgressModal = ({ isOpen, onClose, onSaveSuccess }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSave = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        const currentUser = auth.currentUser;
        if (!currentUser || !currentUser.isAnonymous) {
            setError("Apenas contas anônimas podem ser salvas.");
            setIsLoading(false);
            return;
        }

        try {
            // Cria a credencial de e-mail e senha
            const credential = EmailAuthProvider.credential(email, password);
            // Vincula a nova credencial à conta anônima existente
            await linkWithCredential(currentUser, credential);
            
            // Sucesso! A conta agora é permanente.
            onSaveSuccess();
            onClose();

        } catch (err) {
            // Trata erros comuns, como e-mail já em uso
            if (err.code === 'auth/email-already-in-use') {
                setError("Este e-mail já está em uso por outra conta.");
            } else if (err.code === 'auth/weak-password') {
                setError("A senha deve ter pelo menos 6 caracteres.");
            } else {
                setError("Ocorreu um erro ao salvar seu progresso. Tente novamente.");
            }
            console.error("Erro ao vincular conta:", err);
        } finally {
            setIsLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[100] p-4">
            <div className="mu-panel p-8 rounded-lg text-center w-full max-w-sm relative">
                <button onClick={onClose} className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold z-10">&times;</button>
                <h1 className="text-3xl font-bold mb-4 mu-title">Salvar Progresso</h1>
                <p className="text-stone-300 mb-6">Crie uma conta para não perder seu personagem. Seu progresso atual será mantido.</p>
                <form onSubmit={handleSave}>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        className="mu-input w-full p-3 mb-4"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Palavra-passe (mín. 6 caracteres)"
                        required
                        className="mu-input w-full p-3 mb-4"
                    />
                    <button type="submit" className="mu-button w-full py-3" disabled={isLoading}>
                        {isLoading ? 'Salvando...' : 'Criar Conta e Salvar'}
                    </button>
                </form>
                {error && <p className="text-red-500 mt-4">{error}</p>}
            </div>
        </div>
    );
};


// COLE ESTE NOVO COMPONENTE APÓS O SaveProgressModal
const ConfirmationModal = ({ modalState, setModalState }) => {
    if (!modalState.isOpen) return null;

    const handleConfirm = () => {
        if (modalState.onConfirm) {
            modalState.onConfirm();
        }
        setModalState({ isOpen: false }); // Reseta o estado
    };

    const handleCancel = () => {
        setModalState({ isOpen: false }); // Apenas fecha o modal
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[100] p-4">
            <div className="mu-panel confirm-modal p-8 rounded-lg text-center w-full max-w-sm relative">
                <h1 className="text-2xl font-bold mb-4 mu-title">{modalState.title || 'Confirmar Ação'}</h1>
                <p className="text-stone-300 mb-6">{modalState.message || 'Você tem certeza?'}</p>
<div className="flex justify-center gap-4">
    <button onClick={handleConfirm} className="mu-button mu-button-green w-32">Confirmar</button>
    <button onClick={handleCancel} className="mu-button mu-button-red w-32">Cancelar</button>
</div>
            </div>
        </div>
    );
};


const InvasionTooltipContent = ({ invasion, endTime }) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        // Inicia um timer que atualiza o tempo a cada segundo
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        // Limpa o timer quando o componente é removido (quando o tooltip some)
        return () => clearInterval(timer);
    }, []);

    const totalSeconds = Math.floor((endTime - currentTime) / 1000);
    
    // Garante que não exiba tempo negativo
    if (totalSeconds < 0) {
        return (
            <div>
                <p className="font-bold text-yellow-300">{invasion.name}</p>
                <p>Tempo Restante: Concluído!</p>
            </div>
        );
    }

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const timeLeft = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

    return (
        <div>
            <p className="font-bold text-yellow-300">{invasion.name}</p>
            <p>Tempo Restante: {timeLeft}</p>
        </div>
    );
};

const Header = ({ handleLogout, user, onlinePlayers, setFriendsModalOpen, friendRequestCount, unreadMessageCount, setSaveProgressModalOpen, characterData, showTooltip, hideTooltip, isSyncing, marketNotificationCount, saveData, isModalContext }) => {

    const isMarketLocked = characterData && characterData.level < MARKET_MIN_LEVEL;
    const totalNotifications = (friendRequestCount || 0) + (unreadMessageCount || 0);
    const isPlayerBusy = characterData?.currentInvasion && new Date() < characterData.currentInvasion.endTime?.toDate();


    return (
        <header className="bg-stone-900/80 p-2 shadow-lg flex justify-between items-center sticky top-0 z-50 border-b border-stone-700/50">
            {/* Links de Navegação (Agora sem o Ranking) */}
            <nav className="flex space-x-2">
    {!isModalContext && (
        <NavLink to="/" className={({ isActive }) => `mu-button-nav ${isActive && !isPlayerBusy ? 'mu-button-nav-active' : ''}`}> <HomeIcon /> <span className="hidden sm:inline ml-2">Início</span> </NavLink>
    )}
    
    <div onMouseEnter={(e) => (isMarketLocked) && showTooltip(<div><p>{ `Requer Nível ${MARKET_MIN_LEVEL} para acessar o Mercado`}</p></div>, e)} onMouseLeave={hideTooltip} className="relative">
                    <NavLink to={isModalContext ? "/mercado?context=modal" : "/mercado"} onClick={() => { if(!isMarketLocked) saveData(characterData); }}
        className={({ isActive }) => `mu-button-nav ${isActive && !isMarketLocked ? 'mu-button-nav-active' : ''} ${isMarketLocked ? 'text-stone-500 cursor-not-allowed' : ''}`}>
                        <MarketIcon />
                        <span className="hidden sm:inline ml-2">Mercado</span>
                        {(isMarketLocked) && <LockIcon />}
                    </NavLink>
    {marketNotificationCount > 0 && !isMarketLocked && (
        <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-stone-800">
            {marketNotificationCount}
        </span>
    )}
                </div>

<div
    onMouseEnter={(e) => {
        if (isPlayerBusy && characterData.currentInvasion) {
            const invasion = INVASIONS[characterData.currentInvasion.id];
            const endTime = characterData.currentInvasion.endTime.toDate();
            // Agora passamos o componente para o tooltip
            showTooltip(<InvasionTooltipContent invasion={invasion} endTime={endTime} />, e);
        }
    }}
    onMouseLeave={hideTooltip}
>
    <NavLink 
    	to={isModalContext ? "/invasoes?context=modal" : "/invasoes"} 
        className={({ isActive }) => `mu-button-nav ${isActive ? 'mu-button-nav-active' : ''} ${isPlayerBusy ? 'animated-border border-yellow-400' : ''}`}
    > 
        <InvasionIcon /> 
        <span className="hidden sm:inline ml-2">
            {isPlayerBusy ? 'Invasões' : 'Invasões'}
        </span> 
    </NavLink>
</div>
<div className="relative">
<NavLink 
    to={isModalContext ? "/missoes?context=modal" : "/missoes"} 
    className={({ isActive }) => `mu-button-nav ${isActive ? 'mu-button-nav-active' : ''}`}
> 
    <MissionsIcon /> 
    <span className="hidden sm:inline ml-2">Missões</span> 
</NavLink>
</div>
            </nav>

            {/* Contador de Jogadores Online e Status de Sincronização */}
            <div className="absolute left-1/2 -translate-x-1/2 text-center font-bold pointer-events-none mu-text-shadow">
                {isSyncing ? (
                    <span className="text-yellow-400 animate-pulse">Sincronizando...</span>
                ) : (
                    <span className="text-green-400 pulsing-online">
                        {onlinePlayers} {onlinePlayers === 1 ? 'jogador online' : 'jogadores online'}
                    </span>
                )}
            </div>

            {/* Informações do Usuário (Agora com o Ranking) */}
            {user && (
                <div className="flex items-center space-x-4">
<NavLink to={isModalContext ? "/ranking?context=modal" : "/ranking"} className={({ isActive }) => `mu-button-nav ${isActive && !isPlayerBusy ? 'mu-button-nav-active' : ''}`}> <RankingIcon /> <span className="hidden sm:inline ml-2">Ranking</span> </NavLink>                    {user.isAnonymous && (
                        <button onClick={() => setSaveProgressModalOpen(true)} className="mu-button-nav animated-border border-yellow-400">
                            <SaveIcon /> <span className="hidden sm:inline ml-2">Salvar Progresso</span>
                        </button>
                    )}
                    {!user.isAnonymous && (
                        <>
                            <button onClick={() => setFriendsModalOpen(true)} className="mu-button-nav relative">
                                <FriendsIcon /> <span className="hidden sm:inline ml-2">Amigos</span>
                                {totalNotifications > 0 && (
                                    <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-stone-800">
                                        {totalNotifications}
                                    </span>
                                )}
                            </button>
                        </>
                    )}


{/* ADICIONE ESTE BLOCO */}
{characterData?.isAdmin && (
    <NavLink to="/admin" className="mu-button-nav bg-yellow-800/50 hover:bg-yellow-700/50">
        <span role="img" aria-label="admin">👑</span>
        <span className="hidden sm:inline ml-2">Admin</span>
    </NavLink>
)}

                    <button onClick={() => handleLogout()} className="mu-button-nav bg-red-800/50 hover:bg-red-700/50"> <LogoutIcon /> <span className="ml-1">Sair</span> </button>
                </div>
            )}
        </header>
    );
};
const RankingPage = () => {
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const playersPerPage = 20;

    useEffect(() => {
        const fetchPlayers = async () => {
            setLoading(true);
            try {
                const q = query(collection(db, "characters"), orderBy("level", "desc"), orderBy("experience", "desc"));
                const querySnapshot = await getDocs(q);
                const playersList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setPlayers(playersList);
            } catch (error) {
                console.error("Erro ao carregar o ranking. Verifique suas Regras de Segurança do Firestore:", error);
            }
            setLoading(false);
        };
        fetchPlayers();
    }, []);

    const indexOfLastPlayer = currentPage * playersPerPage;
    const indexOfFirstPlayer = indexOfLastPlayer - playersPerPage;
    const currentPlayers = players.slice(indexOfFirstPlayer, indexOfLastPlayer);
    const totalPages = Math.ceil(players.length / playersPerPage);

    const paginate = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    if (loading) {
        return <div className="text-white text-center p-10">Carregando Ranking...</div>;
    }

    return (
        <div className="text-white p-4 md:p-8">
            <h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow flex items-center justify-center">
    <RankingIcon className="w-16 h-16" />
    <span className="ml-3">Ranking de Jogadores</span>
</h1>
            <div className="mu-panel p-2 md:p-6 overflow-x-auto">
                <table className="w-full text-left min-w-max">
                    <thead className="border-b-2 border-stone-600">
                        <tr>
                            <th className="p-3">Pos.</th>
                            <th className="p-3">Nome</th>
                            <th className="p-3">Classe</th>
                            <th className="p-3">Nível</th>
                            <th className="p-3 text-red-500">Mortes</th>
                            <th className="p-3">XP</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentPlayers.length > 0 ? (
                            currentPlayers.map((player, index) => (
                                <tr key={player.id} className="border-b border-stone-700 hover:bg-stone-700/30">
                                    <td className="p-3 font-bold">#{indexOfFirstPlayer + index + 1}</td>
                                    {/* --- ATUALIZAÇÃO: Adicionado NavLink para o perfil --- */}
                                    <td className="p-3 text-stone-300">
                                        <NavLink to={`/profile/${player.id}`} className="hover:text-yellow-400 hover:underline">
                                            {player.name}
                                        </NavLink>
                                    </td>
                                    <td className="p-3 text-cyan-400">{player.class || 'N/A'}</td>
                                    <td className="p-3">{player.level}</td>
                                    <td className="p-3 text-red-400">{player.deaths || 0}</td>
                                    <td className="p-3 text-stone-400">{player.experience.toLocaleString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center p-5 text-stone-500">Nenhum jogador encontrado. (Verifique as Regras de Segurança do Firestore)</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {totalPages > 1 && (
                <div className="flex justify-center items-center mt-6 space-x-2">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="mu-button"> Anterior </button>
                    <span className="text-lg"> Página {currentPage} de {totalPages} </span>
                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages} className="mu-button"> Próxima </button>
                </div>
            )}
        </div>
    );
};


const Tooltip = ({ content, position }) => {
    const tooltipRef = useRef(null);
    const [style, setStyle] = useState({
        opacity: 0,
        position: 'fixed',
        top: '-9999px',
        left: '-9999px',
        transition: 'opacity 0.1s ease-in-out',
    });

    useLayoutEffect(() => {
        if (tooltipRef.current && content) {
            const { offsetWidth, offsetHeight } = tooltipRef.current;
            const { innerWidth, innerHeight } = window;

            let newX = position.x;
            let newY = position.y;
            const margin = 15;

            if (newX + offsetWidth + margin > innerWidth) {
                newX = position.x - offsetWidth - margin;
            } else {
                newX = position.x + margin;
            }

            if (newY + offsetHeight + margin > innerHeight) {
                newY = position.y - offsetHeight - margin;
            } else {
                newY = position.y + margin;
            }

            if (newX < 0) newX = margin;
            if (newY < 0) newY = margin;

            setStyle(prevStyle => ({
                ...prevStyle,
                top: `${newY}px`,
                left: `${newX}px`,
                opacity: 1,
            }));
        }
    }, [content, position]);

    if (!content) return null;

    return (
        <div
            ref={tooltipRef}
            style={style}
		className="z-[101] p-2 bg-stone-900 border border-stone-600 rounded-md shadow-lg text-sm text-white ignore-map-click"
       		onClick={(e) => e.stopPropagation()} 

        >
            {content}
        </div>
    );
};



// --- NOVO COMPONENTE: MODAL DE ATUALIZAÇÃO ---
const UpdateModal = ({ update, onClose }) => {
    if (!update) return null;

    // Formata a data para um formato mais completo
    const formattedDate = new Date(update.createdAt.seconds * 1000).toLocaleDateString('pt-BR', {
        day: '2-digit', month: 'long', year: 'numeric'
    });

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[100] p-4">
            <div className="mu-panel p-6 w-full max-w-2xl text-white relative max-h-[80vh] flex flex-col">
                {/* Cabeçalho do Modal */}
                <div className="flex justify-between items-center mb-4 pb-3 border-b border-stone-600 flex-shrink-0">
                    <div>
                        <h2 className="text-2xl font-bold mu-title">{update.title}</h2>
                        <p className="text-sm text-stone-400">Publicado em: {formattedDate}</p>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Conteúdo do Modal (com scroll) */}
                <div className="flex-grow overflow-y-auto pr-2 space-y-2">
                    {/* Processa o conteúdo para transformar '*' em itens de lista */}
                    {update.content.split('\n').map((line, index) => {
                        if (line.trim().startsWith('*')) {
                            return <p key={index} className="pl-4"><span className="text-yellow-400 mr-2">•</span>{line.trim().substring(1).trim()}</p>;
                        }
                        return <p key={index}>{line}</p>;
                    })}
                </div>
            </div>
        </div>
    );
};




// --- NOVO COMPONENTE: HOME PAGE (ATUALIZADO) ---
const HomePage = () => {
    // Estado para armazenar os top players e o status de carregamento
    const [topPlayers, setTopPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [latestUpdates, setLatestUpdates] = useState([]); // <-- NOVO ESTADO
    const [selectedUpdate, setSelectedUpdate] = useState(null); // <-- ADICIONE ESTA LINHA


    // useEffect para buscar os dados do ranking quando o componente é montado
    useEffect(() => {
        const fetchTopPlayers = async () => {
            try {
                // Certifique-se de que 'db' está acessível aqui (passado via props ou contexto, ou globalmente)
                // Para este exemplo, assumimos que 'db' é acessível globalmente como no seu App.js.
                if (typeof db === 'undefined') {
                    console.error("Firestore 'db' não está definido no escopo de HomePage.");
                    setLoading(false);
                    return;
                }

                // Cria a consulta para buscar os 5 melhores jogadores
                const q = query(
                    collection(db, "characters"),
                    orderBy("level", "desc"),
                    orderBy("experience", "desc"),
                    limit(5)
                );
                const querySnapshot = await getDocs(q);
                const playersList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setTopPlayers(playersList);
            } catch (error) {
                console.error("Erro ao carregar o ranking para a Home Page:", error);
            }
            setLoading(false);
        };

        // NOVA FUNÇÃO PARA BUSCAR UPDATES
        const fetchUpdates = async () => {
            try {
                const q = query(
                    collection(db, "updates"),
                    orderBy("createdAt", "desc"),
                    limit(5) // Pega apenas os 5 mais recentes
                );
                const querySnapshot = await getDocs(q);
                const updatesList = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setLatestUpdates(updatesList);
            } catch (error) {
                console.error("Erro ao carregar as atualizações:", error);
            }
        };

        fetchTopPlayers();
        fetchUpdates(); // Chame a nova função
    }, []);



    return (
        <div className="min-h-screen text-white flex flex-col">

            {/* --- ATUALIZAÇÃO 1: Vídeo de Fundo --- */}
            <video
                autoPlay
                loop
                muted
                poster="/images/bg-home.jpg" // Imagem de fallback enquanto o vídeo carrega
                className="fixed top-1/2 left-1/2 min-w-full min-h-full -translate-x-1/2 -translate-y-1/2 object-cover z-[-2]"
            >
                <source src="/videos/wowo-home-video-bg.mp4" type="video/mp4" />
                Seu navegador não suporta a tag de vídeo.
            </video>

            {/* Fundo borrado que cobre toda a tela - APAGAR COMENTÁRIO PARA ATIVAR 
            <div className="home-background-blurry"></div>
	    */}

            {/* Overlay escuro sobre o fundo borrado */}
            <div className="home-overlay"></div>

            {/* Header da Home com novo layout */}
            <header className="home-header">
                {/* Container para a logo no topo */}
                <div className="flex justify-center pt-6">
                    {/* Tamanho da logo aumentado */}
                    <img src="/images/wowo-logo-home.png" alt="Logo MU ONLINE" className="logo-home w-80"/>
                </div>

                {/* Nova barra de navegação na parte inferior do header */}
                <div className="home-nav-bar">
                    <nav className="home-nav">
                        <NavLink to="/" className="home-nav-link">HOME</NavLink>
                        <button type="button" className="home-nav-link">GUIDES</button>
                        <NavLink to="/ranking" className="home-nav-link">RANKINGS</NavLink>
                        <button type="button" className="home-nav-link">FORUM</button>
                        <button type="button" className="home-nav-link">SUPPORT</button>
                    </nav>
                </div>
            </header>

            {/* Conteúdo Principal (sem alterações) */}
            <main className="home-main-content">
                <aside className="home-left-column">
                    <div className="home-panel">
                        <h2 className="home-panel-title">NEWS</h2>
                        <div className="home-news-item">
                            <img src="/images/news/update.jpg" alt="Update" className="home-news-image" />
                            <div className="home-news-text">
                                <h3>New Update Released!</h3>
                                <p>August 07, 2025</p>
                            </div>
                        </div>
                        <div className="home-news-item">
                            <img src="/images/news/maintenance.jpg" alt="Maintenance" className="home-news-image" />
                            <div className="home-news-text">
                                <h3>Server Maintenance</h3>
                                <p>August 05, 2025</p>
                            </div>
                        </div>
                        <div className="home-news-item">
                            <img src="/images/news/welcome.jpg" alt="Welcome" className="home-news-image" />
                            <div className="home-news-text">
                                <h3>Welcome to new era MMORPG</h3>
                                <p>August 01, 2025</p>
                            </div>
                        </div>
                         <button type="button" className="read-more">Read more</button>
                    </div>
                </aside>

                <section className="home-center-column">
                    <div className="home-panel-center">
                        <h2 className="home-panel-title-center">LATEST ANNOUNCEMENTS</h2>
                        <ul>
                            <p>[07/08] - New update realeased! Check it here</p>
                            <p>[05/08] - Server maintence! Schedule at 08 pm</p>
                            <p>[01/08] - Welcome to new era of MMORPG Browser</p>
                            <p>[25/07] - Wait! Coming soon, new game browser</p>
                            <p>[01/07] - Information of our project game</p>
                        </ul>
                    </div>
 {/* CÓDIGO ATUALIZADO */}
<div className="home-panel-center">
    <h2 className="home-panel-title-center">LATEST UPDATES</h2>
    <ul>
        {latestUpdates.length > 0 ? (
// CÓDIGO ATUALIZADO
latestUpdates.map(update => {
    const date = update.createdAt ? new Date(update.createdAt.seconds * 1000) : null;
    const formattedDate = date ? `[${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}]` : '';

    return (
        <li key={update.id}
            onClick={() => setSelectedUpdate(update)} // <-- ADICIONE ESTA LINHA
            className="cursor-pointer hover:bg-stone-700/50 p-1 rounded transition-colors" // <-- ADICIONE ESTA LINHA
        >
           <span className="text-yellow-300">{formattedDate}</span> - {update.title}
        </li>
    );
})
        ) : (
            <li>Nenhuma atualização recente.</li>
        )}
    </ul>
</div>
                </section>

                <aside className="home-right-column">
                    <NavLink to="/login" className="play-now-button">PLAY NOW</NavLink>
                    <div className="home-panel-right">
                        <h2 className="home-panel-title-right">TOP PLAYERS</h2>
                        {loading ? (
                            <p className="text-center text-stone-400">Carregando ranking...</p>
                        ) : (
                            <ol className="top-players-list">
                                {topPlayers.map((player, index) => (
                                    <li key={player.id}>
                                        <span>{index + 1}°</span> {player.name} - <span>lvl {player.level}</span>
                                    </li>
                                ))}
                            </ol>
                        )}
                    </div>
                    <div className="home-panel-right">
                         <button type="button" className="home-account-button">DISCORD</button>
                    </div>
                </aside>
            </main>
        {/* ADICIONE ESTAS LINHAS ABAIXO */}
        {selectedUpdate && (
            <UpdateModal update={selectedUpdate} onClose={() => setSelectedUpdate(null)} />
        )}
        </div>
    );
};

const LoginScreen = () => {
    const [isLoginView, setIsLoginView] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleAuth = async (e) => {
        e.preventDefault();
        setError('');
        try {
            if (isLoginView) {
                await signInWithEmailAndPassword(auth, email, password);
            } else {
                await createUserWithEmailAndPassword(auth, email, password);
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="min-h-screen bg-stone-900 text-white flex flex-col items-center justify-center relative overflow-hidden pb-20">
            <div
                className="absolute inset-0 bg-cover bg-center filter blur-sm transform scale-105"
                style={{ backgroundImage: "url('/images/background.jpg')" }}
            ></div>
            <div className="absolute inset-0 bg-black opacity-60"></div>
            <img 
                src="/images/wowo-logo.png" 
                alt="Logo do Jogo" 
		id="logo"
                className="w-56 mx-auto mb-6 z-10" // Adicionado z-10 para garantir que fique sobre o fundo
            />
            <div className="relative z-10 mu-panel p-8 rounded-lg text-center w-full max-w-sm">
                <h1 className="text-4xl font-bold mb-6 mu-title">{isLoginView ? 'Login' : 'Registar'}</h1>
                <form onSubmit={handleAuth}>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                        className="mu-input w-full p-3 mb-4"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Palavra-passe"
                        required
                        className="mu-input w-full p-3 mb-4"
                    />
                    <button type="submit" className="mu-button w-full py-3">
                        {isLoginView ? 'Entrar' : 'Criar Conta'}
                    </button>
                </form>
                {error && <p className="text-red-500 mt-4">{error}</p>}
                <button onClick={() => setIsLoginView(!isLoginView)} className="mt-4 text-stone-300 hover:underline">
                    {isLoginView ? 'Não tem uma conta? Registe-se' : 'Já tem uma conta? Entre'}
                </button>
                <div className="my-4 border-t border-stone-700"></div>
                <button onClick={() => signInAnonymously(auth)} className="w-full mu-button bg-stone-600 hover:bg-stone-700 py-3">
                    Jogar como anônimo
                </button>
            </div>
        </div>
    );
};

const CharacterCreation = ({ onCharacterCreate }) => {
    const [name, setName] = useState('');
    const [selectedClass, setSelectedClass] = useState(null);
    const [error, setError] = useState('');
    const classes = [
        { name: 'Mago', description: 'Domina as artes arcanas com cajados, usando mana para ataques poderosos.', icon: '🪄' },
        { name: 'Guerreiro', description: 'Mestre da espada e escudo, focado em força bruta e defesa.', icon: '⚔️' },
        { name: 'Elfo', description: 'Arqueira ágil e precisa, especialista em ataques à distância com arcos.', icon: '🏹' }
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        if (!name.trim()) {
            setError('Por favor, digite um nome para seu herói.');
            return;
        }
        if (!selectedClass) {
            setError('Por favor, escolha uma classe.');
            return;
        }
        onCharacterCreate(name.trim(), selectedClass);
    };

    return (
        <div className="min-h-screen bg-stone-900 text-white flex items-center justify-center p-4" style={{ backgroundImage: "url('/images/background.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="mu-panel p-8 rounded-lg shadow-lg text-center w-full max-w-2xl">
                <h1 className="text-4xl font-bold mb-6 mu-title">Crie seu Herói</h1>
                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Digite o nome do personagem"
                        className="mu-input w-full p-3 mb-6 text-center text-lg"
                        maxLength="15"
                    />
                    <h2 className="text-2xl font-bold mb-4 text-stone-300 mu-title">Escolha sua Classe</h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                        {classes.map(c => (
                            <div
                                key={c.name}
                                onClick={() => setSelectedClass(c.name)}
                                className={`p-4 border-4 rounded-lg cursor-pointer transition-all duration-200 ${selectedClass === c.name ? 'border-yellow-400 bg-yellow-900/50' : 'border-stone-700 hover:border-yellow-600 bg-stone-800/50'}`}
                            >
                                <div className="text-5xl mb-2">{c.icon}</div>
                                <h3 className="text-xl font-bold">{c.name}</h3>
                                <p className="text-xs text-stone-400 mt-2">{c.description}</p>
                            </div>
                        ))}
                    </div>
                    {error && <p className="text-red-500 mb-4">{error}</p>}
                    <button type="submit" className="mu-button w-full py-3 text-xl">Comece sua Aventura</button>
                </form>
            </div>
        </div>
    );
};

const BattleScreen = ({ battleState, characterData, derivedStats, onAttack, onEndBattle, onUsePotion, onUseSkill }) => {

const potionCounts = useMemo(() => {
    const counts = {
        health: 0,
        mana: 0,
        stamina: 0
    };
    if (characterData?.inventory) {
        for (const item of characterData.inventory) {
            if (item.type === 'Potion') counts.health = item.quantity || 0;
            else if (item.type === 'ManaPotion') counts.mana = item.quantity || 0;
            else if (item.type === 'StaminaPotion') counts.stamina = item.quantity || 0;
        }
    }
    return counts;
}, [characterData?.inventory]);

    // The useMemo hook is moved to the top level of the component.
    const learnedSkillId = useMemo(() => characterData.learnedSkills?.find(id => SKILLS[id]?.class === characterData.class), [characterData.learnedSkills, characterData.class]);

    // The conditional check for an early return now happens *after* all hooks have been called.
    if (!battleState.active || !battleState.monster) return null;

    const { monster, battleLog, isBattleOver } = battleState;
    const player = characterData;
    const maxHp = derivedStats.maxHealth;
    const maxMana = derivedStats.maxMana;

    const PotionIconBattle = () => <span role="img" aria-label="potion" className="mr-1">❤️</span>;
    const ManaPotionIconBattle = () => <span role="img" aria-label="mana potion" className="mr-1">💙</span>;
    const StaminaPotionIconBattle = () => <span role="img" aria-label="stamina potion" className="mr-1">⚡</span>;

    // The logic that depends on the hook's result remains in place.
    const skill = learnedSkillId ? SKILLS[learnedSkillId] : null;
    const isSkillOnCooldown = skill ? battleState.skillCooldowns[learnedSkillId] > 0 : true;
    const skillCooldownTurns = skill ? battleState.skillCooldowns[learnedSkillId] : 0;
    const hasEnoughManaForSkill = skill ? player.currentMana >= skill.manaCost : false;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
            <div className="relative mu-panel p-6 w-full max-w-2xl text-white max-h-screen overflow-y-auto">
                {isBattleOver && (
                    <button
                        onClick={onEndBattle}
                        className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold z-10"
                        aria-label="Fechar Batalha"
                    >
                        &times;
                    </button>
                )}
                <div className="text-center mb-4">
                    <h2 className="text-3xl font-bold text-red-400 mu-monster-title">{monster.name}{monster.isMapBoss ? ' (Boss)' : ''}</h2>
<img
    src={`/images/monster/${monster.name.replace(/ /g, '')}.png`}
    onError={(e) => { e.target.onerror = null; e.target.src = '/images/monster/default.png'; }}
    alt={monster.name}
    className="h-52 w-44 object-contain mx-auto"
/>
                    <p>HP: {monster.currentHp} / {monster.hp}</p>
                    <div className="w-full bg-stone-700 rounded-full h-4 my-2 border border-stone-600">
                        <div className="bg-red-600 h-full rounded-full" style={{ width: `${(monster.currentHp / monster.hp) * 100}%` }}></div>
                    </div>
                </div>
                <div className="boxBattle h-40 bg-stone-900 rounded-md p-2 overflow-y-auto mb-4 text-sm border border-stone-700">
                    <div>
                        {battleLog.map((msg, index) => (
                            <p key={index} className={
                                msg.includes('deixou cair') || msg.includes('ganhou') ? 'text-yellow-400' :
                                msg.includes('alcançou') || msg.includes('aprendeu') ? 'text-yellow-400 font-bold' :
                                msg.includes('causando') ? 'text-green-400' :
                                msg.includes('CRÍTICO') ? 'text-yellow-500 font-bold' :
                                msg.includes('DUPLO') ? 'text-orange-400 font-bold' :
                                msg.includes('defendeu com sucesso') ? 'text-cyan-400' :
                                msg.includes('errou') ? 'text-yellow-400' :
                                msg.includes('recuperou') ? 'text-blue-400' :
                                msg.includes('queimadura') ? 'text-orange-500' :
                                'text-red-400'
                            }>{msg}</p>
                        ))}
                    </div>
                </div>

                <div className="text-center">
                    <p><HealthIcon/> SEU HP: {player.currentHp} / {maxHp}</p>
                    <div className="w-full bg-stone-700 rounded-full h-4 my-2 border border-stone-600">
                        <div className="bg-green-600 h-full rounded-full" style={{ width: `${(player.currentHp / maxHp) * 100}%` }}></div>
                    </div>
                    <p><ManaIcon/> Mana: {player.currentMana} / {maxMana}</p>
                    <div className="w-full bg-stone-700 rounded-full h-4 my-2 border border-stone-600">
                        <div className="bg-blue-600 h-full rounded-full" style={{ width: `${maxMana > 0 ? (player.currentMana / maxMana) * 100 : 0}%` }}></div>
                    </div>
                    <p><StaminaIcon/> Stamina: {player.stamina} / {MAX_STAMINA}</p>
                    <div className="w-full bg-stone-700 rounded-full h-4 my-2 border border-stone-600">
                        <div className="bg-yellow-500 h-full rounded-full" style={{ width: `${(player.stamina / MAX_STAMINA) * 100}%` }}></div>
                    </div>


                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                         <button onClick={() => onAttack('physical')} disabled={isBattleOver} className="mu-button bg-red-800/80 hover:bg-red-700/80">
                            Ataque Físico <br/> ({Math.floor(monster.level / 10) + 1} <StaminaIcon/>)
                        </button>
                        <button
                            onClick={() => onUseSkill(learnedSkillId)}
                            disabled={isBattleOver || !skill || isSkillOnCooldown || !hasEnoughManaForSkill}
                            className="mu-button bg-purple-800/80 hover:bg-purple-700/80 disabled:bg-stone-600"
                            title={skill?.description}
                        >
                            {skill ? (
                                <>
                                    {skill.name} <br/>
                                    ({isSkillOnCooldown ? `${skillCooldownTurns} turnos` : `${skill.manaCost}` }<ManaIcon/>)
                                </>
                            ) : "Sem Habilidade"}
                        </button>
                        <button onClick={onEndBattle} className="mu-button bg-stone-600/80 hover:bg-stone-500/80">
                            Encerrar Batalha
                        </button>
                    </div>

                    <div className="mt-4 pt-4 border-t border-stone-600">
                         <h4 className="text-center mb-2 font-bold text-stone-300">Consumíveis</h4>
                         <div className="flex justify-center gap-4 flex-wrap">
    <button
        onClick={() => onUsePotion('health')}
        disabled={isBattleOver || potionCounts.health === 0 || player.currentHp >= maxHp}
        className="mu-button-small bg-red-600/80"
    >
        <PotionIconBattle /> Usar ({potionCounts.health})
    </button>
    <button
        onClick={() => onUsePotion('mana')}
        disabled={isBattleOver || potionCounts.mana === 0 || player.currentMana >= maxMana}
        className="mu-button-small bg-blue-600/80"
    >
        <ManaPotionIconBattle /> Usar ({potionCounts.mana})
    </button>
    <button
        onClick={() => onUsePotion('stamina')}
        disabled={isBattleOver || potionCounts.stamina === 0 || player.stamina >= MAX_STAMINA}
        className="mu-button-small bg-yellow-500/80"
    >
        <StaminaPotionIconBattle /> Usar ({potionCounts.stamina})
    </button>
</div>
                    </div>
                </div>
            </div>
        </div>
    );
};
// --- NOVO COMPONENTE: VISUALIZADOR DE PERSONAGEM ---
const CharacterVisualizer = ({ equipment }) => {
    if (!equipment) return null;

    // Estilos CSS em linha para posicionar cada camada de equipamento.
    // Estes valores podem precisar de ajustes finos para que as imagens se alinhem perfeitamente.
    const layerStyles = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    };

    const styleConfig = {
        base:   { ...layerStyles, zIndex: 1, top: '0%', left: '0%', width: '100%', height: '100%' },
        wings:  { ...layerStyles, zIndex: 0, top: '5%', left: '-10%', width: '120%', height: '100%' },
        pants:  { ...layerStyles, zIndex: 2, top: '48%', left: '26%', width: '48%', height: '40%' },
        boots:  { ...layerStyles, zIndex: 3, top: '75%', left: '25%', width: '50%', height: '25%' },
        armor:  { ...layerStyles, zIndex: 4, top: '23%', left: '20%', width: '60%', height: '55%' },
        gloves: { ...layerStyles, zIndex: 5, top: '45%', left: '21%', width: '58%', height: '25%' },
        shield: { ...layerStyles, zIndex: 6, top: '30%', left: '5%', width: '40%', height: '40%' },
        helmet: { ...layerStyles, zIndex: 8, top: '3%', left: '29%', width: '42%', height: '25%' },
    };

    // Determina qual imagem de mão usar (espada, escudo, etc.)
    const getHandItem = (slot) => {
        const item = equipment[slot];
        if (!item) return null;
        return EQUIPMENT_RENDER_IMAGES[item.type] || null;
    };

    const shieldImage = getHandItem('rightHand') === EQUIPMENT_RENDER_IMAGES.Shield 
        ? getHandItem('rightHand') 
        : getHandItem('leftHand');

    // Adicionar lógica futura para armas
    // const weaponImage = ...;

    return (
        <div style={{ position: 'relative', width: '300px', height: '450px', margin: 'auto' }}>
            {/* Camada Base do Personagem (você precisa criar esta imagem) */}
            <img src="/images/character/render/base.png" alt="Base" style={styleConfig.base} />

            {/* Renderização Condicional de Itens Equipados */}
            {equipment.Wing && <img src={EQUIPMENT_RENDER_IMAGES.Wing} alt="Asas" style={styleConfig.wings} />}
            {equipment.Pants && <img src={EQUIPMENT_RENDER_IMAGES.Pants} alt="Calças" style={styleConfig.pants} />}
            {equipment.Boots && <img src={EQUIPMENT_RENDER_IMAGES.Boots} alt="Botas" style={styleConfig.boots} />}
            {equipment.Armor && <img src={EQUIPMENT_RENDER_IMAGES.Armor} alt="Armadura" style={styleConfig.armor} />}
            {equipment.Gloves && <img src={EQUIPMENT_RENDER_IMAGES.Gloves} alt="Luvas" style={styleConfig.gloves} />}
            {equipment.Helmet && <img src={EQUIPMENT_RENDER_IMAGES.Helmet} alt="Elmo" style={styleConfig.helmet} />}
            
            {/* Renderiza o escudo se equipado */}
            {shieldImage && <img src={shieldImage} alt="Escudo" style={styleConfig.shield} />}
            
        </div>
    );
};


// --- NOVO COMPONENTE: PÁGINA DE PERFIL ---
const ProfilePage = () => {
    const { userId } = useParams(); // Pega o ID do jogador da URL
    const [playerData, setPlayerData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPlayerData = async () => {
            if (!userId) return;
            setLoading(true);
            try {
                const playerDocRef = doc(db, 'characters', userId);
                const playerDocSnap = await getDoc(playerDocRef);

                if (playerDocSnap.exists()) {
                    setPlayerData(playerDocSnap.data());
                } else {
                    setError('Jogador não encontrado.');
                }
            } catch (err) {
                console.error("Erro ao buscar dados do jogador:", err);
                setError('Ocorreu um erro ao carregar o perfil.');
            }
            setLoading(false);
        };

        fetchPlayerData();
    }, [userId]);

    if (loading) {
        return <div className="text-white text-center p-10 text-2xl">Carregando Perfil...</div>;
    }

    if (error) {
        return <div className="text-red-500 text-center p-10 text-2xl">{error}</div>;
    }

    if (!playerData) {
        return null; // ou uma mensagem de "sem dados"
    }

    return (
        <div className="text-white p-4 md:p-8">
            <h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow">
                Perfil de {playerData.name}
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* Coluna do Personagem */}
                <div className="md:col-span-1 flex justify-center items-start">
                     <CharacterVisualizer equipment={playerData.equipment} />
                </div>

                {/* Coluna de Informações e Stats */}
                <div className="md:col-span-2 mu-panel p-6">
                    <h2 className="text-3xl font-bold mb-4 mu-title">{playerData.name}</h2>
                    <p className="text-xl text-cyan-400 mb-2">Classe: {playerData.class}</p>
                    <p className="text-xl text-yellow-300 mb-6">Nível: {playerData.level}</p>
                    
                    <div className="border-t border-stone-600 pt-4">
                        <h3 className="text-2xl font-bold mu-title mb-4">Atributos</h3>
                        <div className="grid grid-cols-2 gap-4 text-lg">
                            <p><strong>Força:</strong> {playerData.stats.strength}</p>
                            <p><strong>Agilidade:</strong> {playerData.stats.agility}</p>
                            <p><strong>Vida:</strong> {playerData.stats.health}</p>
                            <p><strong>Mana:</strong> {playerData.stats.mana}</p>
                            <p className="col-span-2 mt-2"><strong>Mortes:</strong> {playerData.deaths || 0}</p>
                        </div>
                    </div>
                     <div className="text-center mt-8">
                        <NavLink to="/ranking" className="mu-button">Voltar para o Ranking</NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};


// SKILLS MODAL
const SkillsModal = ({ isOpen, onClose, characterData }) => {
    if (!isOpen) return null;

    // AQUI ESTÁ A CORREÇÃO: Extrai 'learnedSkills' do characterData de forma segura.
    const learnedSkills = characterData?.learnedSkills || [];

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[80] p-4">
            <div className="mu-panel p-6 w-full max-w-2xl text-white relative max-h-[80vh] flex flex-col">
                {/* Cabeçalho do Modal */}
                <div className="flex justify-between items-center mb-4 pb-3 border-b border-stone-600">
                    <h2 className="text-2xl font-bold mu-title">Habilidades do Personagem</h2>
                    <button 
                        onClick={onClose} 
                        className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Conteúdo do Modal (com scroll) */}
                <div className="flex-grow overflow-y-auto pr-2 space-y-4">
                    {learnedSkills.length > 0 ? (
                        learnedSkills.map(skillId => {
                            const skill = SKILLS[skillId];
                            if (!skill) return null;

                            return (
                                <div key={skillId} className="bg-stone-900/60 p-4 rounded-md border-l-4 border-purple-500 flex items-start gap-4">
                                    {/* SUGESTÃO: Adicione um ícone para cada habilidade no futuro */}
                                    {/* <img src={skill.icon} alt={skill.name} className="w-16 h-16" /> */}
                                    
                                    <div>
                                        <p className="font-bold text-lg text-yellow-300">{skill.name}</p>
                                        <p className="text-sm text-stone-300 mt-1">{skill.description}</p>
                                        <div className="text-xs text-cyan-400 mt-3 flex flex-wrap gap-x-4 gap-y-1">
                                            <span><ManaIcon /> Custo: {skill.manaCost} Mana</span>
                                            <span><RefreshIcon /> Recarga: {skill.cooldown} turnos</span>
                                            <span className="text-green-400">Nível Mínimo: {skill.requiredLevel}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="text-center text-stone-400 h-full flex flex-col justify-center items-center">
                            <p className="text-lg">Nenhuma Habilidade Aprendida</p>
                            <p className="mt-2 text-sm max-w-md">
                                Habilidades são aprendidas através de pergaminhos mágicos. Explore o mundo e derrote inimigos poderosos para encontrá-los.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


// --- NOVO COMPONENTE: MODAL DE CRAFT ---
const CraftingModal = ({ isOpen, onClose, characterData, addMessage, saveData, setCharacterData, showTooltip, hideTooltip }) => {

    const [craftingItems, setCraftingItems] = useState([]);
    const [recipeDetails, setRecipeDetails] = useState(null);
    const [isCombining, setIsCombining] = useState(false);

    const handleItemMouseEnter = (item, e) => {
        if (!item || item.isStack) return; // Não mostra tooltip para itens empilháveis (como joias)

        const qualityTextColor = { 'Comum': 'text-white', 'Raro': 'text-blue-400', 'Épico': 'text-purple-400', 'Lendário': 'text-yellow-400' };
        const finalStats = getUpgradedStats(item);
        const displayName = item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '');
        const itemTypeDetails = ITEM_TYPES[item.type];

        const content = (
            <div>
                <p className={`font-bold ${qualityTextColor[item.quality] || 'text-white'}`}>{displayName}</p>
                {itemTypeDetails?.class && <p className="text-yellow-300">Classe: {itemTypeDetails.class}</p>}
                {item.level && <p className="text-stone-400">Nível: {item.level}</p>}
                {finalStats.attack > 0 && <p className="text-green-400">Ataque: +{finalStats.attack}</p>}
                {finalStats.defense > 0 && <p className="text-blue-400">Defesa: +{finalStats.defense}</p>}
                {item.options && item.options.length > 0 && (
                    <div className="mt-2 pt-2 border-t border-stone-500">
                        {item.options.map((opt, index) => (
                            <p key={index} className="text-cyan-300 text-xs italic">{opt.text}</p>
                        ))}
                    </div>
                )}
                {item.description && <p className="italic text-stone-300 mt-2">{item.description}</p>}
            </div>
        );
        showTooltip(content, e);
    };

    const availableItems = useMemo(() => {
        // 1. Junta todos os itens do inventário e do baú em uma única lista.
        const allPhysicalItems = [...(characterData.inventory || []), ...(characterData.chest || [])];
        
        // 2. Separa os itens que não podem ser empilhados (equipamentos).
        const nonStackableItems = allPhysicalItems.filter(item => !item.quantity && !item.isStack);
        
        // 3. Cria um mapa para somar as quantidades de todos os itens empilháveis.
        const stackableTotals = new Map();
        
        allPhysicalItems.forEach(item => {
            // Se o item for empilhável (tiver uma quantidade)
            if (item.quantity) {
                // Se já encontramos esse tipo de item antes, somamos a quantidade.
                if (stackableTotals.has(item.type)) {
                    const existingItem = stackableTotals.get(item.type);
                    existingItem.quantity += item.quantity;
                } else {
                    // Se for a primeira vez, adicionamos o item ao mapa.
                    // Usamos {...item} para criar uma cópia e não alterar o original.
                    stackableTotals.set(item.type, { ...item });
                }
            }
        });

        // 4. Retorna uma lista final com os equipamentos e as pilhas de joias somadas.
        return [...nonStackableItems, ...Array.from(stackableTotals.values())];

    }, [characterData.inventory, characterData.chest]);

    useEffect(() => {
        const recipeItem = craftingItems.find(item => item.recipeId);
        if (recipeItem && CRAFTING_RECIPES[recipeItem.recipeId]) {
            setRecipeDetails(CRAFTING_RECIPES[recipeItem.recipeId]);
        } else {
            setRecipeDetails(null);
        }
    }, [craftingItems]);

    const toggleItemInCraft = (item) => {
        if (item.isStack) {
            const isStackInCraft = craftingItems.some(i => i.isStack && i.type === item.type);
            
            if (isStackInCraft) {
                setCraftingItems(prev => prev.filter(i => i.type !== item.type));
            } else {
                if (!recipeDetails) {
                    addMessage("Adicione uma receita antes de adicionar os materiais.", "error");
                    return;
                }
                const requiredMaterial = recipeDetails.materials.find(m => m.type === item.type);
                if (!requiredMaterial) {
                    addMessage("Este material não é necessário para a receita atual.", "info");
                    return;
                }
                if (item.quantity < requiredMaterial.quantity) {
                    addMessage(`Você não tem ${item.name} suficiente. Necessário: ${requiredMaterial.quantity}.`, "error");
                    return;
                }
                
                const itemsToAdd = [];
                for (let i = 0; i < requiredMaterial.quantity; i++) {
                    itemsToAdd.push({ ...item, id: `${item.id}_${i}`, quantity: undefined });
                }
                setCraftingItems(prev => [...prev, ...itemsToAdd]);
            }
        } else {
            setCraftingItems(prev => {
                const isPresent = prev.some(i => i.id === item.id);
                if (isPresent) {
                    return prev.filter(i => i.id !== item.id);
                }
                if (prev.length >= 12) {
                    addMessage("A janela de combinação está cheia.", "error");
                    return prev;
                }
                return [...prev, item];
            });
        }
    };
    
    const handleCombine = async () => {
        if (!recipeDetails) {
            addMessage("Nenhuma receita válida na janela de combinação.", "error");
            return;
        }

        const materialsInCraft = craftingItems.filter(i => !i.recipeId);
        const materialCounts = materialsInCraft.reduce((acc, item) => {
            const itemType = item.type;
            // AQUI ESTÁ A CORREÇÃO: Usa item.quantity se existir, senão conta como 1.
            const count = item.quantity || 1;
            acc[itemType] = (acc[itemType] || 0) + count;
            return acc;
        }, {});

        const hasAllMaterials = recipeDetails.materials.every(req => {
            return (materialCounts[req.type] || 0) >= req.quantity;
        });

        if (!hasAllMaterials) {
            addMessage("Materiais insuficientes ou incorretos.", "error");
            return;
        }
        
        if ((characterData.gold || 0) < recipeDetails.goldCost) {
            addMessage(`Ouro insuficiente. Custo: ${formatGold(recipeDetails.goldCost)}`, "error");
            return;
        }

        setIsCombining(true);

        let newData = { ...characterData };
        
        // Deduz o custo em ouro
        newData.gold -= recipeDetails.goldCost;

        // Cria cópias do inventário e baú para modificação
        let newInventory = [...newData.inventory];
        let newChest = [...newData.chest];

        // Itera sobre os materiais REQUERIDOS pela receita para consumi-los
        recipeDetails.materials.forEach(requiredMaterial => {
            let quantityToConsume = requiredMaterial.quantity;
            const itemType = requiredMaterial.type;
            
            // Verifica se é um item empilhável (como joias)
            const isStackable = ['Blessing', 'Soul'].includes(itemType);

            if (isStackable) {
                // Tenta consumir do inventário primeiro
                const invIndex = newInventory.findIndex(i => i.type === itemType);
                if (invIndex > -1) {
                    newInventory[invIndex].quantity -= quantityToConsume;
                    if (newInventory[invIndex].quantity <= 0) {
                        newInventory.splice(invIndex, 1); // Remove a pilha se acabar
                    }
                } else {
                    // Se não estiver no inventário, tenta consumir do baú
                    const chestIndex = newChest.findIndex(c => c.type === itemType);
                    if (chestIndex > -1) {
                        newChest[chestIndex].quantity -= quantityToConsume;
                        if (newChest[chestIndex].quantity <= 0) {
                            newChest.splice(chestIndex, 1); // Remove a pilha se acabar
                        }
                    }
                }
            }
        });

        // Consome os itens não-empilháveis (como a receita)
        const nonStackableItemsUsed = craftingItems.filter(item => !item.isStack && !item.quantity);
        nonStackableItemsUsed.forEach(itemToRemove => {
            newInventory = newInventory.filter(i => i.id !== itemToRemove.id);
            newChest = newChest.filter(c => c.id !== itemToRemove.id);
        });

        // Atualiza os dados do personagem com o novo inventário e baú
        newData.inventory = newInventory;
        newData.chest = newChest;


    // Rola o dado para sucesso ou falha
    const roll = Math.random();
    if (roll <= recipeDetails.successChance) {
        // SUCESSO!
        if (newData.inventory.length < INVENTORY_LIMIT) {
            
            // --- NOVA LÓGICA PARA QUALIDADE ALEATÓRIA ---
            const resultBase = recipeDetails.result_base;
            const qualityOptions = recipeDetails.result_qualities;

            let chosenQuality = 'Comum'; // Qualidade padrão caso algo falhe
            const qualityRoll = Math.random();
            let cumulativeChance = 0;

            for (const option of qualityOptions) {
                cumulativeChance += option.chance;
                if (qualityRoll < cumulativeChance) {
                    chosenQuality = option.quality;
                    break; // Para de verificar assim que encontra a qualidade correspondente
                }
            }
            // --- FIM DA NOVA LÓGICA ---

            const resultItem = {
                ...resultBase,
                id: Date.now() + Math.random(),
                name: `${resultBase.name} ${chosenQuality}`,
                quality: chosenQuality, // Usa a qualidade sorteada
                stats: { attack: 50, defense: 30 },
                upgradeLevel: 0,
                // Associa a cor correta baseada na qualidade sorteada
                qualityColor: chosenQuality === 'Lendário' ? 'border-yellow-500' :
                              chosenQuality === 'Épico'   ? 'border-purple-500' :
                              chosenQuality === 'Raro'    ? 'border-blue-500'   : 'border-stone-600',
            };
        // --- ATUALIZAÇÃO DE MISSÕES: CRAFT_ITEM ---
        const recipeId = craftingItems.find(item => item.recipeId)?.recipeId;
        if (recipeId) {
            const craftMission = newData.missions?.find(m =>
                m.status === 'active' &&
                MISSIONS[m.id]?.type === MISSION_TYPES.CRAFT_ITEM &&
                MISSIONS[m.id]?.objective.recipeId === recipeId
            );

            if (craftMission) {
                newData.missions = newData.missions.map(m => {
                    if (m.id === craftMission.id) {
                        const newProgress = (m.progress || 0) + 1;
                        const missionInfo = MISSIONS[m.id];
                        let newStatus = m.status;

                        if (newProgress >= missionInfo.objective.targetCount) {
                            newStatus = 'completed';
                            // Usamos o addMessage do modal, que é passado como prop
                            addMessage(`Missão Concluída: ${missionInfo.name}!`, 'success');
                        }
                        return { ...m, progress: newProgress, status: newStatus };
                    }
                    return m;
                });
            }
        }
        // --- FIM DA ATUALIZAÇÃO DE MISSÕES ---


            newData.inventory.push(resultItem);
            addMessage(`Sucesso! Você criou: ${resultItem.name}!`, "success");
        } else {
            addMessage("A combinação teve sucesso, mas seu inventário está cheio! O item foi perdido.", "error");
        }
    } else {
        // FALHA!
        addMessage("A combinação falhou! Todos os materiais e a receita foram perdidos.", "error");
    }

        setCharacterData(newData);
        await saveData(newData);
        
        // --- ALTERAÇÃO AQUI ---
        setIsCombining(false);
        // Limpa a janela de craft para a próxima tentativa
        setCraftingItems([]); 
        // A linha `onClose()` foi removida para manter o modal aberto.
    };


    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-[60] p-4">
            <div className="mu-panel p-6 w-full max-w-4xl text-white relative">
                <button onClick={onClose} disabled={isCombining} className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold">&times;</button>
                <h2 className="text-2xl font-bold mb-4 mu-title">Oficina de Criação</h2>
                
                <div className="grid grid-cols-2 gap-4" style={{minHeight: '400px'}}>
                    <div className="bg-stone-900/80 p-4 rounded-md border border-stone-700 flex flex-col">
                         <h3 className="font-bold text-stone-400 mb-2 text-center">Itens Disponíveis</h3>
                         <div className="flex-grow bg-black/20 rounded p-2 overflow-y-auto grid grid-cols-5 gap-2 content-start">
                             {availableItems.map(item => {
                                 const isSelected = craftingItems.some(i => i.id === item.id || (i.isStack && i.type === item.type));
                                 return (
                                     <div key={item.id} onClick={() => toggleItemInCraft(item)} className={`relative mu-inventory-slot h-20 ${isSelected ? 'border-green-500' : (item.qualityColor || 'border-stone-700')}`}
					onMouseEnter={(e) => handleItemMouseEnter(item, e)}
					onMouseLeave={hideTooltip} >
                                         {item.type === 'AsaRecipe' ? <RecipeIcon/> : item.type === 'Blessing' ? <JewelIcon /> : item.type === 'Soul' ? <SoulJewelIcon /> : ITEM_TYPES[item.type]?.icon || <SwordIcon />}
                                         <span className="text-xs mt-1 text-center truncate w-full px-1">{item.name}</span>
                                         {item.quantity && (<span className="absolute top-1 right-1 bg-stone-900 bg-opacity-80 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center border border-stone-600">{item.quantity}</span>)}
                                         {isSelected && <div className="absolute inset-0 bg-green-500 opacity-40"></div>}
                                     </div>
                                 );
                             })}
                         </div>
                    </div>

                    <div className="bg-stone-900/80 p-4 rounded-md border border-stone-700 flex flex-col justify-between">
                        <div>
                            <h3 className="font-bold text-stone-400 mb-2 text-center">Janela de Combinação</h3>
                            <div className="w-full min-h-[200px] bg-black/30 border-2 border-dashed border-stone-600 rounded-md mb-4 p-2 grid grid-cols-4 gap-2 content-start">
                               {craftingItems.map(item => (
                                   <div key={item.id} onClick={() => toggleItemInCraft(item)} className={`relative mu-inventory-slot h-20 ${item.qualityColor || 'border-stone-700'}`}>
                                       {item.type === 'AsaRecipe' ? <RecipeIcon/> : item.type === 'Blessing' ? <JewelIcon /> : ITEM_TYPES[item.type]?.icon || <SwordIcon />}
                                   </div>
                               ))}
                            </div>
                            <div className="text-center text-sm space-y-1">
                                <p>Chance de Sucesso: <span className="text-yellow-400 font-bold">{recipeDetails ? `${recipeDetails.successChance * 100}%` : '--%'}</span></p>
                                <p>Custo: <span className="text-yellow-400 font-bold">{recipeDetails ? `${formatGold(recipeDetails.goldCost)} Ouro` : '--'}</span></p>
                            </div>
                        </div>
                        <button onClick={handleCombine} disabled={!recipeDetails || isCombining} className="mu-button w-full mt-4">
                            {isCombining ? 'Combinando...' : 'Combinar'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};





// --- INÍCIO DA NOVA FUNÇÃO REUTILIZÁVEL ---
// COLE ESTE BLOCO NO LUGAR DA SUA FUNÇÃO generateRandomMonsters ATUAL
const generateRandomMonsters = (mapId) => {
    const bounds = MAP_SPAWN_BOUNDS[mapId];
    if (!bounds) return [];

    const noSpawnZones = MAP_NO_SPAWN_ZONES[mapId] || [];
    const { minX, maxX, minY, maxY } = bounds;
    const minDistance = 10;
    const maxAttempts = 200;
    const placedMonsters = [];

    const isTooClose = (pos1, pos2) => {
        const dx = pos1.x - pos2.x;
        const dy = pos1.y - pos2.y;
        return Math.sqrt(dx * dx + dy * dy) < minDistance;
    };

    const isInNoSpawnZone = (x, y) => {
        for (const zone of noSpawnZones) {
            if (x >= zone.x1 && x <= zone.x2 && y >= zone.y1 && y <= zone.y2) {
                return true; // Está dentro de uma zona segura
            }
        }
        return false;
    };

    for (const monsterTemplate of MAPS[mapId].monsters) {
        let attempts = 0;
        let positionIsSafe = false;
        let safeX, safeY;

        while (!positionIsSafe && attempts < maxAttempts) {
            const newX = Math.floor(Math.random() * (maxX - minX + 1)) + minX;
            const newY = Math.floor(Math.random() * (maxY - minY + 1)) + minY;

            const isOverlapping = placedMonsters.some(placed =>
                isTooClose({ x: newX, y: newY }, { x: parseFloat(placed.x), y: parseFloat(placed.y) })
            );

            // Esta é a linha-chave que impede o spawn em zonas seguras (como a logo)
            if (!isOverlapping && !isInNoSpawnZone(newX, newY)) {
                positionIsSafe = true;
                safeX = newX;
                safeY = newY;
            }
            attempts++;
        }

        if (positionIsSafe) {
            placedMonsters.push({
                ...monsterTemplate,
                id: `${mapId}-${monsterTemplate.name}-${Date.now()}-${Math.random()}`,
                currentHp: monsterTemplate.hp,
                x: `${safeX}%`,
                y: `${safeY}%`,
            });
        }
    }
    return placedMonsters;
};



const NotificationContainer = ({ notifications, onRemove }) => {
    // Mapeamento para ícones especiais que não estão no ITEM_TYPES principal
    const iconMap = {
        Potion: <PotionIcon />,
        ManaPotion: <ManaPotionIcon />,
        Blessing: <JewelIcon />,
        Soul: <SoulJewelIcon />,
        Gold: <CoinIcon />,
        // Adicione outros consumíveis aqui se necessário
    };

    return (
        <div className="notification fixed bottom-4 left-4 z-[9999] w-80 space-y-3">
            {notifications.map(notification => {
                let iconToShow;
                let borderColor;

                // Se a notificação tiver um tipo de item, use o ícone do item
if (notification.itemType) {
    // Lógica explícita para garantir o ícone correto das joias
    if (notification.itemType === 'Blessing') {
        iconToShow = <JewelIcon />;
    } else if (notification.itemType === 'Soul') {
        iconToShow = <SoulJewelIcon />;
    } else {
        // Lógica de fallback para todos os outros itens
        iconToShow = iconMap[notification.itemType] || ITEM_TYPES[notification.itemType]?.icon;
    }
}

                // Se não for um drop de item, usa a lógica de ícone genérico
                if (!iconToShow) {
                    const typeInfo = {
                        success: { iconImg: '/images/success.png', border: 'border-green-500' },
                        error: { iconImg: '/images/error.png', border: 'border-red-500' },
                        info: { iconImg: '/images/info.png', border: 'border-blue-500' },
                    };
                    const fallback = typeInfo[notification.type] || typeInfo.info;
                    iconToShow = <img src={fallback.iconImg} alt="Ícone" className="mr-3 w-6 h-6 flex-shrink-0" />;
                    borderColor = fallback.border;
                } else {
                     // Define a borda com base no tipo da mensagem (verde para comum, azul/info para especial)
                    borderColor = notification.type === 'success' ? 'border-green-500' : 'border-blue-500';
                }

                return (
                    <div
                        key={notification.id}
                        className={`mu-notification ${borderColor} relative`}
                    >
                        {/* Garante que o ícone tenha um contêiner com tamanho fixo */}
                        <div className="mr-3 w-10 h-10 flex items-center justify-center flex-shrink-0">
                           {iconToShow}
                        </div>
                        <span className="pr-4">{notification.message}</span>
                        <button
                            onClick={() => onRemove(notification.id)}
                            className="absolute top-0 right-1 text-stone-400 hover:text-white font-bold text-2xl"
                            aria-label="Fechar notificação"
                            title="Fechar"
                        >
                            &times;
                        </button>
                    </div>
                );
            })}
        </div>
    );
};


// --- NOVO COMPONENTE: Tooltip de Monstro Estilo Bestiário ---
const MonsterTooltip = ({ monster, onBattle }) => {
    if (!monster) return null;

    return (
        <div className="monster-tooltip-container">
            <header className="monster-tooltip-header">
                <h1 className="monster-tooltip-name">{monster.name}</h1>
                {monster.isMapBoss && <span className="monster-tooltip-boss-indicator">(Boss)</span>}
            </header>

            <section className="monster-tooltip-body">
                <div className="monster-tooltip-stat">
                    <span>Nível:</span>
                    <span className="text-yellow-400">{monster.level}</span>
                </div>
                <div className="monster-tooltip-stat">
                    <span>HP:</span>
                    <span className="text-red-600">{monster.currentHp} / {monster.hp}</span>
                </div>

                {monster.isMapBoss && (
                    <div className="monster-tooltip-drops">
                        {monster.specialDrops?.map(drop => (
                            <p key={drop.name} className="text-cyan-300">- {drop.name}: {drop.chance}%</p>
                        ))}
                        {monster.legendaryDropChance > 0 && (
                             <p className="text-yellow-300">- Drop Lendário: {monster.legendaryDropChance}%</p>
                        )}
                    </div>
                )}
            </section>

            <footer className="monster-tooltip-footer">
                <button 
                    onClick={(e) => onBattle(e)}
                    className="mu-button w-full" /* Usando o botão principal para mais destaque */
                >
                    Batalhar
                </button>
            </footer>
        </div>
    );
};


// --- NOVO COMPONENTE: PAINEL DE INVENTÁRIO REUTILIZÁVEL ---
const InventoryPanel = ({
    characterData, derivedStats, equipmentOrder, handleDrop, handleDropOnEquipment,
    handleDragOver, handleDragLeave, unequipItem, handleDragStart, handleDragEnd,
    isUpgrading, isUpgradingWithSoul, upgradeItem, upgradeItemWithSoul, handleItemMouseEnter,
    hideTooltip, hoveredDropZone, inventoryWithConsumables, handleItemClick, handleItemRightClick,
    draggedItem, handleDropOnItem, handleSellAllClick, handleSellAllMouseEnter,
    handleTouchStart
}) => {
    return (
        // A estrutura agora é uma coluna flex que ocupa toda a altura disponível
        <div className="flex flex-col h-full">

            {/* Esta div crescerá e terá a barra de rolagem */}
            <div className="flex-grow overflow-y-auto pr-2">
                <div className="mb-8">
                    <h3 className="text-lg font-bold mb-2 text-stone-300 mu-title">Itens Equipados</h3>
                    <p className="hidden md:block text-xs text-stone-400 mb-4">Clique com o botão direito do mouse para desequipar um item. Ou arraste para equipar ou desequipar.</p>
                    <p className="block md:hidden text-xs text-stone-400 mb-4">Toque e mantenha pressionado o item que deseja desequipar.</p>
                    <div className="grid grid-cols-3 gap-2 text-center">
                        {Object.entries(equipmentOrder).map(([slot, slotInfo]) => {
                            const item = characterData.equipment[slot];
                            return (
                                <div
                                    key={slot}
                                    data-dropzone-id={slot}
                                    draggable={!!item}
                                    onDragStart={(e) => {
                                        if (item) {
                                            handleDragStart(e, item, slot);
                                        }
                                    }}
                                    onDragEnd={handleDragEnd}
                                    onDrop={(e) => handleDropOnEquipment(e, slot)}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onContextMenu={(e) => { e.preventDefault(); if (item) unequipItem(slot); }}
                                    onMouseEnter={(e) => item && handleItemMouseEnter(item, e)}
                                    onMouseLeave={hideTooltip}
                                    onClick={() => {
                                        if (isUpgrading && item) upgradeItem(item);
                                        if (isUpgradingWithSoul && item) upgradeItemWithSoul(item);
                                    }}
                                    className={`mu-inventory-slot h-20 ${item ? item.qualityColor : 'border-stone-800'} ${item && item.quality === 'Lendário' ? 'animated-border' : ''} ${isUpgrading || isUpgradingWithSoul ? 'cursor-crosshair' : ''} ${hoveredDropZone === slot ? 'bg-purple-900/50 border-stone-500' : ''}`}
                                >
                                    <div className={!item ? 'grayscale opacity-25' : ''}>
                                        {item ? ITEM_TYPES[item.type]?.icon : slotInfo.icon}
                                    </div>
                                    <span className={`text-xs mt-1 ${item ? 'text-white' : 'text-stone-500'}`}>
                                        {item ? `${item.name.split(' ')[0]} +${item.upgradeLevel || 0}` : slotInfo.name}
                                    </span>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <h3 className="text-lg font-bold mb-2 text-stone-300 mu-title">Inventário ({characterData.inventory.length} / {INVENTORY_LIMIT})</h3>
                <p className="hidden md:block text-xs text-stone-400 mb-4">Clique com o botão direito do mouse ou arraste para equipar ou desequipar um item. Arraste para guardar no baú ou vender.</p>
                <p className="block md:hidden text-xs text-stone-400 mb-4">Toque e mantenha pressionado o item que deseja equipar ou desequipar. Ou arraste para guardar no baú ou vender.</p>
                <div
                    data-dropzone-id="inventory"
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    className={`grid grid-cols-3 gap-2 rounded-md transition-colors ${hoveredDropZone === 'inventory' && draggedItem && draggedItem.source !== 'inventory' ? 'bg-purple-900/50' : ''}`}
                >
                    {inventoryWithConsumables.map(item => (
                        <div key={item.id} draggable={true} onDragStart={(e) => handleDragStart(e, item, 'inventory')} onDragEnd={handleDragEnd} onTouchStart={(e) => handleTouchStart(e, item, 'inventory')} className={`relative mu-inventory-slot h-24 ${item.qualityColor || 'border-stone-700'} ${item.quality === 'Lendário' ? 'animated-border' : ''} ${draggedItem?.item.id === item.id ? 'opacity-50' : ''}`} onClick={() => handleItemClick(item)} onContextMenu={(e) => handleItemRightClick(e, item)} onMouseEnter={(e) => handleItemMouseEnter(item, e)} onMouseLeave={hideTooltip} onDrop={(e) => { if (draggedItem?.source === 'inventory') { handleDropOnItem(e, item, 'inventory'); } }} onDragOver={(e) => { if (draggedItem?.source === 'inventory' && draggedItem?.item.id !== item.id) { e.preventDefault(); } }}>
                            {item.type === 'Potion' ? <PotionIcon /> :
                             item.type === 'ManaPotion' ? <ManaPotionIcon /> :
                             item.type === 'Blessing' ? <JewelIcon /> :
                             item.type === 'Soul' ? <SoulJewelIcon /> :
                             item.type === 'StaminaPotion' ? <StaminaPotionIcon /> :
                             item.recipeId ? <RecipeIcon /> :
                             item.type?.includes('Scroll') ? <ScrollIcon /> :
                             (ITEM_TYPES[item.type]?.icon || <span role="img" aria-label="desconhecido">?</span>)}
                            <span className="text-xs mt-1 text-center">{item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '')}</span>
                            {item.quantity && (<span className="absolute top-1 right-1 bg-stone-900 bg-opacity-80 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center border border-stone-600">{item.quantity}</span>)}
                        </div>
                    ))}
                </div>
            </div>

            {/* Esta é a div do rodapé, ela não cresce e fica na parte inferior */}
            <div className="flex flex-col gap-2 pt-4 flex-shrink-0">
                <div className="flex w-full gap-2">
                    <div data-dropzone-id="chest" onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`mu-drop-zone w-1/2 h-24 ${hoveredDropZone === 'chest' && draggedItem?.source === 'inventory' ? 'mu-drop-zone-hover-purple' : ''}`}>
                        <p className="text-stone-400 pointer-events-none text-sm">Guardar no Baú</p>
                    </div>
                    <div data-dropzone-id="sell" onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`mu-drop-zone w-1/2 h-24 ${hoveredDropZone === 'sell' ? 'mu-drop-zone-hover-red' : ''}`}>
                        <p className="text-red-300 pointer-events-none text-sm">Vender Item</p>
                    </div>
                </div>
                <button onClick={handleSellAllClick} onMouseEnter={handleSellAllMouseEnter} onMouseLeave={hideTooltip} className="w-full mu-button bg-red-800/80 hover:bg-red-700/80">Vender Todos os Itens</button>
            </div>
        </div>
    );
};




// COLE ESTE NOVO COMPONENTE APÓS O INVENTORYPANEL
const ChestPanel = ({
    characterData, handleMoveFromChest, handleItemMouseEnter, hideTooltip,
    handleDragStart, handleDragEnd, draggedItem, handleDropOnItem,
    handleDrop, handleDragOver, handleDragLeave, hoveredDropZone,
    handleSellAllFromChestClick, handleSellAllFromChestMouseEnter, handleTouchStart
}) => {
    return (
        <div className="flex flex-col h-full">
            {/* Área de rolagem para os itens do baú */}
            <div className="flex-grow overflow-y-auto pr-2">
                <h3 className="text-lg font-bold mb-2 text-stone-300 mu-title">Baú ({ (characterData.chest || []).length } / {CHEST_SIZE})</h3>
                <p className="text-xs text-stone-400 mb-4">Clique com o botão direito do mouse para mover para o inventário. Arraste para vender.</p>

                <div className="grid grid-cols-3 gap-2">
                    {(characterData.chest || []).map(item => (
                        <div
                            key={item.id}
                            draggable={true}
                            onDragStart={(e) => handleDragStart(e, item, 'chest')}
                            onDragEnd={handleDragEnd}
                            onTouchStart={(e) => handleTouchStart(e, item, 'chest')}
                            className={`relative mu-inventory-slot h-24 ${item.qualityColor || 'border-stone-700'} ${item.quality === 'Lendário' ? 'animated-border' : ''} ${draggedItem?.item.id === item.id ? 'opacity-50' : ''}`}
                            onContextMenu={(e) => handleMoveFromChest(e, item)}
                            onMouseEnter={(e) => handleItemMouseEnter(item, e)}
                            onMouseLeave={hideTooltip}
                            onDrop={(e) => {
                                if (draggedItem?.source === 'chest') { handleDropOnItem(e, item, 'chest'); }
                            }}
                            onDragOver={(e) => { if (draggedItem?.source === 'chest' && draggedItem?.item.id !== item.id) { e.preventDefault(); } }}
                        >
                            {
                                item.type === 'Potion' ? <PotionIcon /> :
                                item.type === 'ManaPotion' ? <ManaPotionIcon /> :
                                item.type === 'Blessing' ? <JewelIcon /> :
                                item.type === 'Soul' ? <SoulJewelIcon /> :
                                item.type === 'StaminaPotion' ? <StaminaPotionIcon /> :
                                item.recipeId ? <RecipeIcon /> :
                                item.type?.includes('Scroll') ? <ScrollIcon/> :
                                (ITEM_TYPES[item.type]?.icon || <span role="img" aria-label="desconhecido">?</span>)
                            }
                            <span className="text-xs mt-1 text-center">{item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '')}</span>
                            {item.quantity && (<span className="absolute top-1 right-1 bg-stone-900 bg-opacity-80 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center border border-stone-600">{item.quantity}</span>)}
                        </div>
                    ))}
                </div>
            </div>

            {/* Rodapé fixo para o baú */}
            <div className="flex-shrink-0 flex flex-col gap-2 pt-4">
                <div data-dropzone-id="sell" onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`mu-drop-zone h-24 ${hoveredDropZone === 'sell' && draggedItem?.source === 'chest' ? 'mu-drop-zone-hover-red' : ''}`}>
                    <p className="text-red-300 pointer-events-none">Arraste um item do baú aqui para vender</p>
                </div>
                <button
                    onClick={handleSellAllFromChestClick}
                    onMouseEnter={handleSellAllFromChestMouseEnter}
                    onMouseLeave={hideTooltip}
                    className="w-full mu-button bg-red-800/80 hover:bg-red-700/80"
                >
                    Vender Todos os Itens do Baú
                </button>
            </div>
        </div>
    );
};


// COLE ESTE NOVO COMPONENTE APÓS O ChestPanel
const CharacterPanel = ({
    characterData, derivedStats, characterImageSrc, remainingSkillPoints,
    pendingStats, totalPendingPoints, handleDecreasePendingStat,
    handleIncreasePendingStat, handleConfirmStats, handleCancelStats,
    setSkillsModalOpen
}) => {
    return (
        <>
            {/* Bloco de Código com a Imagem */}
            <div className="flex items-center mb-4 border-b-2 border-stone-700 pb-2">
                <img
                    src={characterImageSrc}
                    alt="Foto do Personagem"
                    className="w-20 h-20 rounded-md border-2 border-stone-600 mr-4 object-cover"
                />
                <div className="flex-grow flex justify-between items-center">
                    <div>
                        <h2 className="text-2xl font-bold text-stone-300 mu-title">{characterData.name}</h2>
                        <p className="text-cyan-400 font-semibold">{characterData.class}</p>
                    </div>
                    <span className="text-xl font-bold text-white bg-stone-900/50 px-3 py-1 rounded-lg border border-stone-600 whitespace-nowrap">Lvl {characterData.level}</span>
                </div>
            </div>
            <p>XP: {characterData.experience} / {characterData.level * 100}</p>
            <div className="w-full bg-stone-700 rounded-full h-2.5 my-2"><div className="bg-gradient-to-r from-purple-500 to-purple-700 h-2.5 rounded-full" style={{ width: `${(characterData.experience / (characterData.level * 100)) * 100}%` }}></div></div>

            {/* Gold and Status Bars */}
            <div className="mt-4 border-t-2 border-stone-700 pt-4 space-y-3">
                <div>
                    <p className="text-xl text-yellow-400 mu-text-shadow flex items-center justify-center gap-2"><CoinIcon /> {formatGold(characterData.gold)}</p>
                </div>
                <div>
                    <div className="flex justify-between text-sm font-semibold">
                        <span><HealthIcon /> Vida</span>
                        <span>{characterData.currentHp} / {derivedStats.maxHealth}</span>
                    </div>
                    <div className="w-full bg-stone-900/80 rounded-full h-4 border-2 border-stone-600 overflow-hidden">
                        <div className="bg-red-600 h-full" style={{ width: `${((characterData.currentHp || 0) / (derivedStats.maxHealth || 1)) * 100}%` }}></div>
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-sm font-semibold">
                        <span><ManaIcon /> Mana</span>
                        <span>{characterData.currentMana} / {derivedStats.maxMana}</span>
                    </div>
                    <div className="w-full bg-stone-900/80 rounded-full h-4 border-2 border-stone-600 overflow-hidden">
                        <div className="bg-blue-600 h-full" style={{ width: `${((characterData.currentMana || 0) / (derivedStats.maxMana || 1)) * 100}%` }}></div>
                    </div>
                </div>
                <div>
                    <div className="flex justify-between text-sm font-semibold">
                        <span><StaminaIcon /> Stamina</span>
                        <span>{characterData.stamina} / {MAX_STAMINA}</span>
                    </div>
                    <div className="w-full bg-stone-900/80 rounded-full h-4 border-2 border-stone-600 overflow-hidden">
                        <div className="bg-yellow-500 h-full" style={{ width: `${((characterData.stamina || 0) / MAX_STAMINA) * 100}%` }}></div>
                    </div>
                </div>
            </div>

            <div className="mt-4 flex-grow">
                <h3 className="text-xl font-bold text-stone-300 mb-2 mu-title">Atributos ({remainingSkillPoints} pontos)</h3>
                <div className="space-y-2">
                    {STAT_ORDER.map(stat => (
                        <div key={stat} className="flex justify-between items-center">
                            <span className="capitalize">{STAT_DEFINITIONS[stat]}: {characterData.stats[stat]}</span>
                            {characterData.skillPoints > 0 && (
                                <div className="flex items-center gap-2">
                                    <button onClick={() => handleDecreasePendingStat(stat)} disabled={pendingStats[stat] === 0} className="mu-stat-button minus">-</button>
                                    <span className="font-bold text-lg w-6 text-center text-yellow-300">{pendingStats[stat]}</span>
                                    <button onClick={() => handleIncreasePendingStat(stat)} disabled={remainingSkillPoints === 0} className="mu-stat-button plus">+</button>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                {totalPendingPoints > 0 && (
                    <div className="mt-4 flex gap-2">
                        <button onClick={handleConfirmStats} className="flex-1 mu-button bg-green-800/80 hover:bg-green-700/80">Confirmar ({totalPendingPoints})</button>
                        <button onClick={handleCancelStats} className="flex-1 mu-button bg-red-800/80 hover:bg-red-700/80">Cancelar</button>
                    </div>
                )}

                <div className="mt-6 pt-4 border-t border-stone-700">
                    <div className="flex justify-between items-center mb-2">
                        <h3 className="text-xl font-bold text-stone-300 mb-2 mu-title">Status Totais</h3>
                        <button
                            onClick={() => setSkillsModalOpen(true)}
                            className="mu-button-small bg-purple-800/80 hover:bg-purple-700/80"
                        > Habilidades
                        </button>
                    </div>
                    <div className="space-y-1">
                        <p><AttackIcon /> Ataque: {derivedStats.attack} {derivedStats.equipmentAttackBonus > 0 && (<span className="text-green-400">(+{derivedStats.equipmentAttackBonus})</span>)}</p>
                        <p><DefenseIcon /> Defesa: {derivedStats.defense} {derivedStats.equipmentDefenseBonus > 0 && (<span className="text-blue-400">(+{derivedStats.equipmentDefenseBonus})</span>)}</p>
                    </div>

                    <div className="mt-4 pt-2 border-t border-stone-700">
                        <h4 className="text-lg font-bold text-stone-300 mb-2 mu-title">Atributos de Combate</h4>
                        <div className="text-sm space-y-1 text-cyan-300">
                            <p>🎯 Chance de Acerto Crítico: <span className="text-white">{((PLAYER_CRITICAL_CHANCE + derivedStats.critical_chance) * 100).toFixed(0)}%</span></p>
                            <p>💥 Chance de Dano Duplo: <span className="text-white">{(derivedStats.double_damage * 100).toFixed(0)}%</span></p>
                            <p>🛡️ Chance de Defesa com Sucesso: <span className="text-white">{(derivedStats.full_defense * 100).toFixed(0)}%</span></p>

                            {(derivedStats.hp_increase > 0 || derivedStats.mana_increase > 0) && (
                                <div className="mt-2 pt-2 border-t border-stone-600 border-dashed">
                                    {derivedStats.hp_increase > 0 && (<p>❤️ Aumento de HP Máximo: <span className="text-white">+{(derivedStats.hp_increase * 100).toFixed(0)}%</span></p>)}
                                    {derivedStats.mana_increase > 0 && (<p>✨ Aumento de Mana Máxima: <span className="text-white">+{(derivedStats.mana_increase * 100).toFixed(0)}%</span></p>)}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};




// NOVO COMPONENTE: Adicione este bloco de código dentro do GameUI
const SmartPopover = ({ children, mapContainerRef }) => {
    const popoverRef = useRef(null);
    // Começa invisível para evitar "piscar" na posição errada
    const [finalClasses, setFinalClasses] = useState('absolute z-50 opacity-0 transition-opacity duration-200');

    useLayoutEffect(() => {
        if (!popoverRef.current || !mapContainerRef.current) return;

        const popover = popoverRef.current;
        const container = mapContainerRef.current;

        const popoverRect = popover.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        let baseClasses = "absolute z-50 ignore-map-click";
        
        // --- LÓGICA DE AJUSTE VERTICAL ---
        // Por padrão, tenta ficar abaixo do pino (top-full)
        // O popoverRect inicial ainda não tem top/left, então verificamos a posição do PAI
        const parentPinRect = popover.parentElement.getBoundingClientRect();
        if (parentPinRect.bottom + popoverRect.height > containerRect.bottom) {
            // Se for estourar embaixo, joga para cima
            baseClasses += " bottom-full mb-2"; 
        } else {
            // Senão, fica embaixo
            baseClasses += " top-full mt-2";
        }

        // --- LÓGICA DE AJUSTE HORIZONTAL ---
        if (parentPinRect.left + popoverRect.width > containerRect.right) {
            // Se estoura à direita, alinha à direita do pino
            baseClasses += " right-0";
        } else if (parentPinRect.right - popoverRect.width < containerRect.left) {
             // Se estoura à esquerda, alinha à esquerda do pino
            baseClasses += " left-0";
        }
        else {
            // Se couber, centraliza
            baseClasses += " left-1/2 -translate-x-1/2";
        }

        // Aplica as classes calculadas e torna o popover visível
        setFinalClasses(`${baseClasses} opacity-100`);

    }, [mapContainerRef, children]);

    return (
        <div ref={popoverRef} className={finalClasses} onClick={(e) => e.stopPropagation()}>
            {children}
        </div>
    );
};



// Linha 2699
const MonsterPin = React.memo(({ monster, onMonsterClick, selectedMonster, mapContainerRef, handleStartBattle, setSelectedMonster, isFullScreen }) => {
    // A lógica de renderização que estava dentro do seu .map() agora fica aqui
    const isPinMap = ['lorencia', 'noria', 'dungeon'].includes('lorencia'); // Simplesmente para o exemplo

    if (isPinMap && monster.x && monster.y) {
        return (
            <div
                // A prop "key" foi removida daqui e será usada no loop .map()
                className={`absolute rounded-full border-4 border-red-600 cursor-pointer monster-pin shadow-lg ignore-map-click hover:z-40 ${isFullScreen ? 'w-20 h-20' : 'w-14 h-14'}`}
                style={{
                    top: monster.y,
                    left: monster.x,
                    transform: 'translate(-50%, -50%)',
                    zIndex: selectedMonster?.id === monster.id ? 45 : undefined
                }}
                onClick={(e) => onMonsterClick(monster, e)}
            >
                {monster.isMapBoss && <div className="boss-indicator">!</div>}
                <img
                    src={`/images/monster/${monster.name.replace(/ /g, '')}.png`}
                    alt={monster.name}
                    className="w-full h-full object-cover rounded-full"
                    onError={(e) => { e.target.onerror = null; e.target.src = '/images/monster/default-monster.png'; }}
                />
                <div className="monster-name-tooltip">{monster.name}{monster.isMapBoss ? ' (Boss)' : ''}</div>

                {selectedMonster?.id === monster.id && (
                    <SmartPopover mapContainerRef={mapContainerRef}>
                        <MonsterTooltip
                            monster={selectedMonster}
                            onBattle={(evt) => {
                                evt.stopPropagation();
                                handleStartBattle(selectedMonster);
                                setSelectedMonster(null);
                            }}
                        />
                    </SmartPopover>
                )}
            </div>
        );
    }
    return null;
});




const GameUI = ({ characterData, setCharacterData, userId, createFloatingText, showTooltip, hideTooltip, addMessage, saveData, notifications, onRemove, onFullScreenChange, openConfirmationModal, confirmationModal, setConfirmationModal, tooltip }) => {    const [messageLog, setMessageLog] = useState([]);
    const [activeTab, setActiveTab] = useState('inventory');
    const [isUpgrading, setIsUpgrading] = useState(false);
    const [isUpgradingWithSoul, setIsUpgradingWithSoul] = useState(false); 
    const [isCraftingModalOpen, setCraftingModalOpen] = useState(false);
    const [isSkillsModalOpen, setSkillsModalOpen] = useState(false); 
    const [activeMap, setActiveMap] = useState('lorencia');
    const [battleState, setBattleState] = useState({ active: false, monster: null, battleLog: [], isBattleOver: false, skillCooldowns: {}, activeEffects: [] });
    const [draggedItem, setDraggedItem] = useState(null);
    const [hoveredDropZone, setHoveredDropZone] = useState(null);
    const [dragPreviewStyle, setDragPreviewStyle] = useState(null);
    const [nextShopRefresh, setNextShopRefresh] = useState(0);
    const [shopCountdown, setShopCountdown] = useState('');
    const [chatMessages, setChatMessages] = useState([]);
    const [chatInput, setChatInput] = useState('');
    const [pendingStats, setPendingStats] = useState({ strength: 0, agility: 0, health: 0, mana: 0 });
    const [shopJustUpdated, setShopJustUpdated] = useState(false);
    const hasCalculatedOfflineRegen = useRef(false);
    const [isFullScreen, setIsFullScreen] = useState(false); // NOVO: Estado para controlar o modo de tela cheia
    const mapContainerRef = useRef(null); // NOVO: Referência para o elemento do contêiner do mapa
    const [selectedMonster, setSelectedMonster] = useState(null);
    const [isFullScreenInventoryOpen, setFullScreenInventoryOpen] = useState(false);
    const [isFullScreenCharacterOpen, setFullScreenCharacterOpen] = useState(false);
    const [isFullScreenMarketOpen, setFullScreenMarketOpen] = useState(false);
    const [isIframeLoading, setIframeLoading] = useState(true); // <-- ADICIONE ESTA LINHA
    const [fullScreenTab, setFullScreenTab] = useState('inventory');


    // --- OTIMIZAÇÃO 1: Referência para o Auto-Save ---
    // Criamos uma referência para os dados do personagem. Isso permite que o
    // intervalo do auto-save acesse a versão mais recente dos dados sem
    // precisar ser recriado toda vez que `characterData` muda.
    const characterDataRef = useRef(characterData);
    useEffect(() => {
        characterDataRef.current = characterData;
    }, [characterData]);



    // NOVO: Função para alternar o modo de tela cheia
    const toggleFullScreen = () => {
        const elem = mapContainerRef.current;
        if (!elem) return;

        if (!document.fullscreenElement) {
            elem.requestFullscreen().catch(err => {
                alert(`Erro ao tentar entrar em tela cheia: ${err.message} (${err.name})`);
            });
        } else {
            document.exitFullscreen();
        }
    };

    // NOVO: Efeito para sincronizar o estado com o status real da tela cheia do navegador
	useEffect(() => {
    const handleFullScreenChange = () => {
        const isFull = !!document.fullscreenElement;
        setIsFullScreen(isFull);
        onFullScreenChange(isFull); // <-- ADICIONE ESTA LINHA PARA AVISAR O PAI
        if (!isFull) { // <-- ADICIONE ESTE IF BLOCK
            setFullScreenInventoryOpen(false);
            setFullScreenCharacterOpen(false);
            setFullScreenMarketOpen(false); // <-- ADICIONE ESTA LINHA

        }
    };

    document.addEventListener('fullscreenchange', handleFullScreenChange);

    return () => {
        document.removeEventListener('fullscreenchange', handleFullScreenChange);
    };
}, [onFullScreenChange]); 




// COLE O NOVO BLOCO DE CÓDIGO AQUI
// Este useEffect controla o estado de carregamento do iframe.
useEffect(() => {
    // Se o modal do menu/mercado for aberto...
    if (isFullScreenMarketOpen) {
        // ...garante que o estado de loading comece como 'true'.
        setIframeLoading(true); 

        // Define a função que vai lidar com as mensagens recebidas.
        const handleIframeMessage = (event) => {
            // Se a mensagem for a que esperamos ('iframeContentLoaded')...
            if (event.data === 'iframeContentLoaded') {
                // ...desativa a tela de carregamento.
                setIframeLoading(false);
            }
        };

        // Começa a ouvir por mensagens.
        window.addEventListener('message', handleIframeMessage);

        // Função de limpeza: para de ouvir quando o modal for fechado.
        return () => {
            window.removeEventListener('message', handleIframeMessage);
        };
    }
}, [isFullScreenMarketOpen]); // Este efeito depende do modal estar aberto ou fechado.
// FIM DO NOVO BLOCO



// CÓDIGO NOVO E SIMPLIFICADO
const handleMapClick = (e) => {
    // A verificação 'ignore-map-click' continua essencial para não fechar
    // o popover ao clicar dentro dele.
    if (e.target.closest('.ignore-map-click')) {
        return;
    }
    // Se o clique foi fora, simplesmente limpa o monstro selecionado.
    setSelectedMonster(null);
};



// CÓDIGO NOVO E SIMPLIFICADO
const handleMonsterClick = (monster, e) => {
    // Impede que o clique no monstro acione o handleMapClick
    e.stopPropagation();
    // Define o monstro clicado como o selecionado, ou remove a seleção
    // se o mesmo monstro for clicado novamente.
    setSelectedMonster(prev => (prev?.id === monster.id ? null : monster));
};

    // Adicione esta lógica para obter a imagem correta
    const characterImages = {
        'Guerreiro': '/images/character-warrior.jpg',
        'Mago': '/images/character-mage.jpg',
        'Elfo': '/images/character-elf.jpg' // Corrigi o nome do arquivo para consistência
    };
    const characterImageSrc = characterImages[characterData.class] || '/images/default-character.jpg'; // Adicione uma imagem padrão por segurança

    const eventLogRef = useRef(null);

    const handleItemMouseEnter = (item, e) => {
        if(draggedItem) return;
        const qualityTextColor = { 'Comum': 'text-white', 'Raro': 'text-blue-400', 'Épico': 'text-purple-400', 'Lendário': 'text-yellow-400' };
        const finalStats = item.quantity ? {} : getUpgradedStats(item);
        const displayName = item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '');
        const itemTypeDetails = ITEM_TYPES[item.type];

        const content = (
            <div>
                <p className={`font-bold ${qualityTextColor[item.quality] || 'text-white'}`}>{displayName}</p>
                {itemTypeDetails?.class && <p className="text-yellow-300">Classe: {itemTypeDetails.class}</p>}
                {item.level && <p className="text-stone-400">Nível: {item.level}</p>}
                {finalStats.attack > 0 && <p className="text-green-400">Ataque: +{finalStats.attack}</p>}
                {finalStats.defense > 0 && <p className="text-blue-400">Defesa: +{finalStats.defense}</p>}
                {item.options && item.options.length > 0 && (
                    <div className="mt-2 pt-2 border-t border-stone-500">
                        {item.options.map((opt, index) => (
                            <p key={index} className="text-cyan-300 text-xs italic">{opt.text}</p>
                        ))}
                    </div>
                )}
                {item.description && <p className="italic text-stone-300 mt-2">{item.description}</p>}
                {(item.level || item.skillId || item.recipeId) && !item.quantity && <p className="text-yellow-400 mt-2">Valor de Venda: {calculateSellPrice(item)} ouro</p>}
            </div>
        );
        showTooltip(content, e);
    };
    
    // --- OTIMIZAÇÃO 2: Implementação do Auto-Save ---
    // Este `useEffect` configura um intervalo que salva os dados do personagem
    // (usando a referência) a cada 30 segundos. Ele é iniciado apenas uma vez.
    useEffect(() => {
        const autoSaveInterval = setInterval(() => {
            if (characterDataRef.current) {
                saveData(characterDataRef.current);
            }
        }, 30000); // Salva a cada 30 segundos

        return () => clearInterval(autoSaveInterval);
    }, [saveData]);


    const addGameMessage = useCallback((message, type) => {
        const colorClass = {
            success: 'text-green-400',
            error: 'text-red-400',
            info: 'text-yellow-400'
        }[type] || 'text-green-400';

        const newMessage = {
            text: message,
            timestamp: new Date(),
            type: 'game',
            color: colorClass,
        };
        setMessageLog(prev => [newMessage, ...prev.slice(0, 99)]);
    }, []);

    const combinedLog = useMemo(() => {
        const formattedChat = chatMessages.map(msg => ({
            ...msg,
            timestamp: msg.createdAt?.toDate() || new Date(),
            text: `${msg.characterName}: ${msg.message}`,
            type: 'chat'
        }));

        const allMessages = [...messageLog, ...formattedChat];
        allMessages.sort((a, b) => b.timestamp - a.timestamp);

        return allMessages.slice(0, 100);
    }, [messageLog, chatMessages]);

    const formatBattleMessage = (message) => {
        const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return `[${timestamp}] ${message}`;
    };



    // --- ATUALIZAÇÃO 1: Função sellItem refatorada ---
const sellItem = useCallback((itemToSell, source) => {
    const sellPrice = calculateSellPrice(itemToSell);
    const newInventory = source === 'inventory' ? characterData.inventory.filter(item => item.id !== itemToSell.id) : characterData.inventory;
    const newChest = source === 'chest' ? (characterData.chest || []).filter(item => item.id !== itemToSell.id) : (characterData.chest || []);

    const newData = { ...characterData, inventory: newInventory, chest: newChest, gold: (characterData.gold || 0) + sellPrice, };
    setCharacterData(newData);
    // REMOVIDO: saveData(newData); A chamada foi removida para ser gerenciada pelo auto-save.
    addGameMessage(`Você vendeu ${itemToSell.name} por ${sellPrice} de ouro.`, 'success');
}, [characterData, setCharacterData, addGameMessage]);


    // --- ATUALIZAÇÃO 2: Função moveItemToChest refatorada ---
const moveItemToChest = useCallback((itemToMove) => {
    // Lista de tipos de itens que devem ser empilhados
    const stackableTypes = ['Blessing', 'Soul', 'Potion', 'ManaPotion', 'StaminaPotion'];

    if (stackableTypes.includes(itemToMove.type)) {
        let chestHasStack = false;
        // Mapeia o baú para encontrar um item do mesmo tipo para empilhar
        const newChest = (characterData.chest || []).map(item => {
            if (item.type === itemToMove.type) {
                chestHasStack = true;
                // Retorna um novo objeto de item com a quantidade somada
                return { ...item, quantity: (item.quantity || 1) + (itemToMove.quantity || 1) };
            }
            return item;
        });

        if (chestHasStack) {
            // Se empilhou, remove o item do inventário e atualiza o baú
            const newInventory = characterData.inventory.filter(i => i.id !== itemToMove.id);
            const newData = { ...characterData, chest: newChest, inventory: newInventory };
            setCharacterData(newData);
            // REMOVIDO: saveData(newData);
            addGameMessage(`${itemToMove.name} foi adicionado ao monte no baú.`, 'success');
        } else {
            // Se não encontrou um monte para empilhar, move o item normalmente
            if ((characterData.chest || []).length >= CHEST_SIZE) {
                addGameMessage("Seu baú está cheio.", 'error');
                return;
            }
            const finalChest = [...(characterData.chest || []), itemToMove];
            const newInventory = characterData.inventory.filter(i => i.id !== itemToMove.id);
            const newData = { ...characterData, chest: finalChest, inventory: newInventory };
            setCharacterData(newData);
            // REMOVIDO: saveData(newData);
            addGameMessage(`${itemToMove.name} foi guardado no baú.`, 'success');
        }
    } else {
        // Lógica original para itens não empilháveis
        if ((characterData.chest || []).length >= CHEST_SIZE) {
            addGameMessage("Seu baú está cheio.", 'error');
            return;
        }
        const newChest = [...(characterData.chest || []), itemToMove];
        const newInventory = characterData.inventory.filter(i => i.id !== itemToMove.id);
        const newData = { ...characterData, chest: newChest, inventory: newInventory };
        setCharacterData(newData);
        // REMOVIDO: saveData(newData);
        addGameMessage(`${itemToMove.name} foi guardado no baú.`, 'success');
    }
}, [characterData, setCharacterData, addGameMessage]);

    const derivedOptionStats = useMemo(() => {
        const initialOptionStats = {
            double_damage: 0,
            critical_chance: 0,
            full_defense: 0,
            hp_increase: 0,
            mana_increase: 0
        };

        if (!characterData || !characterData.equipment) {
            return initialOptionStats;
        }

        return Object.values(characterData.equipment).reduce((acc, item) => {
            if (item && item.options && Array.isArray(item.options)) {
                item.options.forEach(option => {
                    if (acc.hasOwnProperty(option.id)) {
                        acc[option.id] += option.value;
                    }
                });
            }
            return acc;
        }, initialOptionStats);

    }, [characterData]);

    const derivedStats = useMemo(() => {
        if (!characterData?.stats) {
            return {
                attack: 0, defense: 0, maxHealth: 1, maxMana: 1,
                equipmentAttackBonus: 0, equipmentDefenseBonus: 0
            };
        }
    
        const baseMaxHealth = Math.floor(characterData.stats.health / HEALTH_STAT_TO_HP_DIVISOR);
        const baseMaxMana = Math.floor(characterData.stats.mana / MANA_STAT_TO_MP_DIVISOR);

        const maxHealth = Math.floor(baseMaxHealth * (1 + derivedOptionStats.hp_increase));
        const maxMana = Math.floor(baseMaxMana * (1 + derivedOptionStats.mana_increase));

        let equipmentAttackBonus = 0;
        let equipmentDefenseBonus = 0;

        Object.values(characterData.equipment).forEach(item => {
            if (item) {
                const finalStats = getUpgradedStats(item);
                equipmentAttackBonus += finalStats.attack;
                equipmentDefenseBonus += finalStats.defense;
            }
        });

        // --- ATUALIZADO: LÓGICA DE ATAQUE BASEADO NA CLASSE ---
        let baseAttack = 0;
        switch (characterData.class) {
            case 'Guerreiro':
                baseAttack = Math.floor(characterData.stats.strength / STRENGTH_TO_ATTACK_DIVISOR);
                break;
            case 'Elfo':
                baseAttack = Math.floor(characterData.stats.agility / AGILITY_TO_ATTACK_DIVISOR);
                break;
            case 'Mago':
                baseAttack = Math.floor(characterData.stats.mana / MANA_TO_ATTACK_DIVISOR);
                break;
            default: // Fallback para Guerreiro/Força
                baseAttack = Math.floor(characterData.stats.strength / STRENGTH_TO_ATTACK_DIVISOR);
        }

	const stats = {
            attack: baseAttack + equipmentAttackBonus,
            defense: Math.floor(characterData.stats.agility / AGILITY_TO_DEFENSE_DIVISOR) + equipmentDefenseBonus,
            maxHealth: maxHealth,
            maxMana: maxMana,
            equipmentAttackBonus: equipmentAttackBonus,
            equipmentDefenseBonus: equipmentDefenseBonus,
        };

        // AQUI ESTÁ A CORREÇÃO: Mescla os stats de opções (crítico, etc.) no objeto final
        return { ...stats, ...derivedOptionStats };
    }, [characterData?.stats, characterData?.equipment, characterData?.class, derivedOptionStats]);


    const performDropOnEquipment = useCallback((droppedItem, source, targetSlot) => {
    if (characterData?.currentInvasion) { 
        addMessage("Você não pode equipar um item durante a invasão.", "error"); 
        return; 
    } 
        const newEquipment = { ...characterData.equipment };

        if ((source === 'leftHand' || source === 'rightHand') && (targetSlot === 'leftHand' || targetSlot === 'rightHand') && source !== targetSlot) {
            const temp = newEquipment[targetSlot];
            newEquipment[targetSlot] = newEquipment[source];
            newEquipment[source] = temp;

            const newData = { ...characterData, equipment: newEquipment };
            setCharacterData(newData);
            // REMOVIDO: saveData(newData);
            return;
        }

        if (source === 'inventory') {
            const itemTypeDetails = ITEM_TYPES[droppedItem.type];
            if (!itemTypeDetails) return;

            if (itemTypeDetails.class && itemTypeDetails.class !== characterData.class) {
                addGameMessage(`Sua classe (${characterData.class}) não pode usar este item.`, 'error');
                return;
            }

            if (droppedItem.type === 'Shield') {
                const otherHandSlot = targetSlot === 'leftHand' ? 'rightHand' : 'leftHand';
                if (characterData.equipment[otherHandSlot]?.type === 'Shield') {
                    addGameMessage("Você só pode equipar um escudo por vez.", 'error');
                    return;
                }
            }

            const itemTypeForSlot = itemTypeDetails.slot;
            const isValidDrop = (itemTypeForSlot === 'hand' && (targetSlot === 'leftHand' || targetSlot === 'rightHand')) || (itemTypeForSlot === targetSlot);

            if (isValidDrop) {
                let newInventory = [...characterData.inventory];
                const itemBeingReplaced = newEquipment[targetSlot];

                if (itemBeingReplaced && newInventory.filter(i => i.id !== droppedItem.id).length >= INVENTORY_LIMIT) {
                    addGameMessage("Inventário cheio! Não é possível trocar o item.", 'error');
                    return;
                }

                newInventory = newInventory.filter(i => i.id !== droppedItem.id);
                if (itemBeingReplaced) {
                    newInventory.push(itemBeingReplaced);
                }

                newEquipment[targetSlot] = droppedItem;

                const newData = { ...characterData, equipment: newEquipment, inventory: newInventory };
                setCharacterData(newData);
                // REMOVIDO: saveData(newData);
            } else {
                addGameMessage("Este item não pode ser equipado neste espaço.", 'error');
            }
        }
    }, [characterData, setCharacterData, addGameMessage, addMessage]);

    const handleTouchMove = useCallback((e) => { if (!draggedItem) return; e.preventDefault(); const touch = e.touches[0]; setDragPreviewStyle({ left: touch.clientX, top: touch.clientY }); const elementUnderTouch = document.elementFromPoint(touch.clientX, touch.clientY); const dropZone = elementUnderTouch?.closest('[data-dropzone-id]'); if (dropZone) { setHoveredDropZone(dropZone.dataset.dropzoneId); } else { setHoveredDropZone(null); } }, [draggedItem]);
    const handleTouchEnd = useCallback(() => {
        if (!draggedItem) return;
        const targetZone = hoveredDropZone;

        if (targetZone === 'sell') {
            if (window.confirm(`Deseja vender ${draggedItem.item.name}?`)) {
                sellItem(draggedItem.item, draggedItem.source);
            }
        } else if (targetZone === 'chest' && draggedItem.source === 'inventory') {
            moveItemToChest(draggedItem.item);
        } else if (Object.keys(EQUIPMENT_ORDER).includes(targetZone)) {
            performDropOnEquipment(draggedItem.item, draggedItem.source, targetZone);
        }

        setDraggedItem(null);
        setHoveredDropZone(null);
        setDragPreviewStyle(null);
    }, [draggedItem, hoveredDropZone, sellItem, moveItemToChest, performDropOnEquipment]);

const inventoryWithConsumables = useMemo(() => {
    return [...(characterData.inventory || [])];
}, [characterData.inventory]);

const handleDropOnItem = useCallback((e, droppedOnItem, container) => {
    e.preventDefault();
    e.stopPropagation();
    hideTooltip();
    setHoveredDropZone(null);

    const dataString = e.dataTransfer.getData("application/json");
    if (!dataString) {
        setDraggedItem(null);
        return;
    }

    const draggedData = JSON.parse(dataString);
    const { item: draggedItem, source: draggedSource } = draggedData;

    if (draggedSource !== container) {
        setDraggedItem(null);
        return;
    }

    let newData = { ...characterData };
    let dataArray;
    let dataKey;

    if (container === 'inventory') {
        dataArray = [...newData.inventory];
        dataKey = 'inventory';
    } else if (container === 'chest') {
        dataArray = [...(newData.chest || [])];
        dataKey = 'chest';
    } else {
        setDraggedItem(null);
        return;
    }

    const draggedIndex = dataArray.findIndex(i => i.id === draggedItem.id);
    const droppedIndex = dataArray.findIndex(i => i.id === droppedOnItem.id);

    if (draggedIndex !== -1 && droppedIndex !== -1 && draggedIndex !== droppedIndex) {
        [dataArray[draggedIndex], dataArray[droppedIndex]] = [dataArray[droppedIndex], dataArray[draggedIndex]];
        newData[dataKey] = dataArray;
        setCharacterData(newData);
        // REMOVIDO: saveData(newData);
    }
    setDraggedItem(null);

}, [characterData, setCharacterData, hideTooltip]);

    useEffect(() => {
        const twelveHoursAgo = new Date(Date.now() - 12 * 60 * 60 * 1000);
        const chatQuery = query(
            collection(db, "chat"),
            where("createdAt", ">", twelveHoursAgo),
            orderBy("createdAt", "asc")
        );

        const unsubscribe = onSnapshot(chatQuery, (querySnapshot) => {
            const messages = [];
            querySnapshot.forEach((doc) => {
                messages.push({ id: doc.id, ...doc.data() });
            });
            setChatMessages(messages);
        });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        // CORREÇÃO: Este efeito agora calcula a regeneração offline na montagem do componente.
        if (characterData && derivedStats.maxHealth > 1 && !hasCalculatedOfflineRegen.current) {
            const lastUpdate = characterData.lastUpdateTimestamp?.toDate();
            if (lastUpdate) {
                const now = new Date();
                const secondsElapsed = Math.floor((now.getTime() - lastUpdate.getTime()) / 1000);

                if (secondsElapsed > 5) { // Apenas calcula se esteve offline por mais de 5 segundos.
                    const hpToRegen = Math.floor(secondsElapsed / (HP_REGEN_RATE / 1000)) * HP_REGEN_AMOUNT * HP_REGEN_MULTIPLIER;
                    const manaToRegen = Math.floor(secondsElapsed / (MANA_REGEN_RATE / 1000)) * MANA_REGEN_AMOUNT * MANA_REGEN_MULTIPLIER;
                    const staminaToRegen = Math.floor(secondsElapsed / (STAMINA_REGEN_RATE / 1000)) * STAMINA_REGEN_AMOUNT * STAMINA_REGEN_MULTIPLIER;

                    if (hpToRegen > 0 || manaToRegen > 0 || staminaToRegen > 0) {
                        const newHp = Math.min(derivedStats.maxHealth, characterData.currentHp + hpToRegen);
                        const newMana = Math.min(derivedStats.maxMana, (characterData.currentMana || 0) + manaToRegen);
                        const newStamina = Math.min(MAX_STAMINA, (characterData.stamina || 0) + staminaToRegen);
                        
                        // Verifica se uma atualização é realmente necessária para evitar escritas desnecessárias.
                        if (newHp !== characterData.currentHp || newMana !== characterData.currentMana || newStamina !== characterData.stamina) {
                             const newData = {
                                ...characterData,
                                currentHp: newHp,
                                currentMana: newMana,
                                stamina: newStamina,
                            };
                            setCharacterData(newData);
                            // REMOVIDO: saveData(newData); A primeira chamada do auto-save cuidará disso.
                            
                            let messages = [];
                            if (hpToRegen > 0 && newHp > characterData.currentHp) messages.push(`${hpToRegen} HP`);
                            if (manaToRegen > 0 && newMana > characterData.currentMana) messages.push(`${manaToRegen} Mana`);
                            if (staminaToRegen > 0 && newStamina > characterData.stamina) messages.push(`${staminaToRegen} Stamina`);
                            if (messages.length > 0) {
                                addGameMessage(`Recuperado enquanto offline: ${messages.join(', ')}.`, 'info');
                            }
                        }
                    }
                }
            }
            hasCalculatedOfflineRegen.current = true;
        }
    }, [characterData, derivedStats, setCharacterData, addGameMessage]);

    // --- OTIMIZAÇÃO 3: Centralização da Regeneração ---
    // Removemos os três `useEffect` separados para HP, Mana e Stamina e os
    // combinamos em um único `useEffect` com um único intervalo. Isso é mais
    // eficiente para o navegador. A chamada `saveData` foi removida, pois
    // o auto-save já está cuidando disso.
    useEffect(() => {
        const regenerationInterval = setInterval(() => {
            setCharacterData(prev => {
                if (!prev || !derivedStats) return prev;

                let needsUpdate = false;
                const newData = { ...prev };
                const maxHp = derivedStats.maxHealth;
                const maxMana = derivedStats.maxMana;

                if (newData.stamina < MAX_STAMINA) {
                    newData.stamina = Math.min(MAX_STAMINA, newData.stamina + STAMINA_REGEN_AMOUNT);
                    needsUpdate = true;
                }
                if (newData.currentHp < maxHp) {
                    newData.currentHp = Math.min(maxHp, newData.currentHp + HP_REGEN_AMOUNT);
                    needsUpdate = true;
                }
                if (newData.currentMana < maxMana) {
                    newData.currentMana = Math.min(maxMana, newData.currentMana + MANA_REGEN_AMOUNT);
                    needsUpdate = true;
                }

                return needsUpdate ? newData : prev;
            });
        }, Math.min(HP_REGEN_RATE, MANA_REGEN_RATE, STAMINA_REGEN_RATE)); // Roda no ritmo do mais rápido

        return () => clearInterval(regenerationInterval);
    }, [setCharacterData, derivedStats]);


    useEffect(() => {
        window.addEventListener('touchmove', handleTouchMove, { passive: false });
        window.addEventListener('touchend', handleTouchEnd);

        return () => {
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
        };
    }, [draggedItem, handleTouchMove, handleTouchEnd]);

    useEffect(() => { const handleVisibilityChange = () => { if (document.visibilityState === 'hidden' && characterData && userId) { saveData(characterData); } }; document.addEventListener('visibilitychange', handleVisibilityChange); return () => { document.removeEventListener('visibilitychange', handleVisibilityChange); }; }, [characterData, saveData, userId]);

    useEffect(() => { if (!characterData) return; if (nextShopRefresh === 0 && characterData.nextShopRefresh) { setNextShopRefresh(characterData.nextShopRefresh); } else if (nextShopRefresh === 0) { const initialNextRefresh = Date.now() + SHOP_REFRESH_INTERVAL; setNextShopRefresh(initialNextRefresh); saveData({ ...characterData, nextShopRefresh: initialNextRefresh }); } const shopTimer = setInterval(() => { const now = Date.now(); if (nextShopRefresh > 0 && now >= nextShopRefresh) { addMessage("A loja foi atualizada com novos itens!", 'info'); setShopJustUpdated(true); setTimeout(() => setShopJustUpdated(false), 30000); const newShopItems = generateNewShop(characterData.level); const newNextShopRefresh = now + SHOP_REFRESH_INTERVAL; setCharacterData(prev => ({ ...prev, shopItems: newShopItems, nextShopRefresh: newNextShopRefresh })); setNextShopRefresh(newNextShopRefresh); saveData({ ...characterData, shopItems: newShopItems, nextShopRefresh: newNextShopRefresh }); } else if (nextShopRefresh > 0) { const timeLeft = nextShopRefresh - now; const hours = Math.floor(timeLeft / (1000 * 60 * 60)); const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60)); const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000); setShopCountdown(`${String(hours).padStart(2, '0')}h${String(minutes).padStart(2, '0')}m${String(seconds).padStart(2, '0')}s`); } }, 1000); return () => clearInterval(shopTimer); }, [characterData, nextShopRefresh, saveData, addMessage, setCharacterData]);

    useEffect(() => {
        if (!characterData || !derivedStats) return;

        const maxHp = derivedStats.maxHealth;
        const maxMana = derivedStats.maxMana;
        let needsUpdate = false;
        let newData = { ...characterData };

        if (newData.currentHp > maxHp) {
            newData.currentHp = maxHp;
            needsUpdate = true;
        }
        if (newData.currentMana > maxMana) {
            newData.currentMana = maxMana;
            needsUpdate = true;
        }

        if (needsUpdate) {
            setCharacterData(newData);
        }
    }, [characterData, derivedStats, setCharacterData]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (characterData.level < CHAT_MIN_LEVEL) {
            addGameMessage(`Você precisa atingir o nível ${CHAT_MIN_LEVEL} para usar o chat.`, 'error');
            return;
        }
        const messageText = chatInput.trim();
        if (messageText === '' || !characterData) return;

        try {
            await addDoc(collection(db, "chat"), {
                characterName: characterData.name,
                message: messageText,
                createdAt: serverTimestamp()
            });
            setChatInput('');
        } catch (error) {
            console.error("Erro ao enviar mensagem: ", error);
            addGameMessage("Não foi possível enviar a sua mensagem.", 'error');
        }
    };



const handleRefreshMonsters = (e) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode realizar esta ação enquanto estiver em uma invasão.", "error");
        return;
    }
    const refreshCost = 1;
    if ((characterData.stamina || 0) < refreshCost) {
        addMessage("Stamina insuficiente para atualizar os monstros.", 'error');
        showTooltip(<div><p className="text-red-400">Stamina insuficiente</p></div>, e);
        setTimeout(hideTooltip, 2000);
        return;
    }
    addGameMessage("Você atualizou a lista de monstros!", 'success');

    let newMonstersForMap;

    // LÓGICA CORRIGIDA: Usa a nova função genérica para os mapas corretos
    if (MAP_SPAWN_BOUNDS[activeMap]) {
        newMonstersForMap = generateRandomMonsters(activeMap);
    } else {
        // Mantém o comportamento antigo para outros mapas que não usam o sistema de pinos
        newMonstersForMap = MAPS[activeMap].monsters.map((m, index) => ({
            ...m,
            id: `${activeMap}-${index}-${Date.now()}`,
            currentHp: m.hp
        }));
    }

    const newData = {
        ...characterData,
        mapState: { ...characterData.mapState, [activeMap]: newMonstersForMap },
        stamina: characterData.stamina - refreshCost
    };
    setCharacterData(newData);
    saveData(newData);
};


    const handleStartBattle = (monster) => {
        if (characterData?.currentInvasion) {
            addMessage("Você não pode iniciar uma batalha enquanto estiver em uma invasão.", "error");
            return; // Impede a execução do resto da função
        }
        const initialCooldowns = {};
        if (characterData.learnedSkills) {
            characterData.learnedSkills.forEach(skillId => {
                initialCooldowns[skillId] = 0;
            });
        }
        setBattleState({ active: true, monster: { ...monster }, battleLog: [formatBattleMessage(`A batalha contra ${monster.name} começou!`)], isBattleOver: false, skillCooldowns: initialCooldowns, activeEffects: [] });
    };

    const handleEndBattle = () => { setBattleState({ active: false, monster: null, battleLog: [], isBattleOver: false }); };
    
    const triggerMonsterAttack = (currentMonster, currentPlayer, currentLog) => {
        let monster = { ...currentMonster };
        let player = { ...currentPlayer };
        let newBattleLog = [...currentLog];

        if (Math.random() < derivedOptionStats.full_defense) {
            newBattleLog.unshift(formatBattleMessage(`Você se defendeu com sucesso! O ataque de ${monster.name} falhou.`));
            setBattleState(prev => ({ ...prev, monster, battleLog: newBattleLog }));
            // REMOVIDO: saveData(player);
            return;
        }

        if (Math.random() < MONSTER_MISS_CHANCE) {
            newBattleLog.unshift(formatBattleMessage(`${monster.name} tentou atacar, mas errou!`));
            setBattleState(prev => ({ ...prev, monster, battleLog: newBattleLog }));
            // REMOVIDO: saveData(player);
            return;
        }

        const monsterAttack = monster.attack;
        const monsterDamageMultiplier = calculateMonsterDamageMultiplier(player.level);
        let finalMonsterAttack = Math.floor(monsterAttack * monsterDamageMultiplier);

        const isCritical = Math.random() < MONSTER_CRITICAL_CHANCE;
        if (isCritical) {
            finalMonsterAttack = Math.floor(finalMonsterAttack * CRITICAL_DAMAGE_MULTIPLIER);
        }

        const playerDefense = derivedStats.defense;
        
        // --- Lógica de Balanceamento de Batalha (NOVO) ---
        const levelDifference = monster.level - player.level;
        let finalAdjustedAttack = finalMonsterAttack;

        // Aumenta o dano se o monstro tiver um nível maior
        if (levelDifference > 0) {
            const levelBonus = 1.0 + (levelDifference * BATTLE_BALANCE_LEVEL_DIFFERENCE_FACTOR);
            finalAdjustedAttack *= levelBonus;
        }

        // Calcula o dano mitigado pela defesa do jogador
        const mitigatedDamage = finalAdjustedAttack - (playerDefense * BATTLE_BALANCE_DEFENSE_EFFECTIVENESS);

        // Calcula o dano mínimo garantido
        const minDamage = finalAdjustedAttack * BATTLE_BALANCE_MIN_DAMAGE_PERCENT;

        // O dano final é o maior entre o dano mitigado e o dano mínimo, mas nunca menos que 1.
        const damageToPlayer = Math.max(1, Math.floor(Math.max(mitigatedDamage, minDamage)));
        // --- Fim da Lógica de Balanceamento ---

        const newPlayerHp = Math.max(0, player.currentHp - damageToPlayer);

        let damageMessage = `${monster.name} te acertou causando ${damageToPlayer} de dano.`;
        if (isCritical) {
            damageMessage = `${monster.name} te acertou com um ATAQUE CRÍTICO causando ${damageToPlayer} de dano.`;
        }
        newBattleLog.unshift(formatBattleMessage(damageMessage));

        player.currentHp = newPlayerHp;

        if (newPlayerHp <= 0) {
            addMessage("Você foi derrotado! Renascendo...", 'error');
            player.deaths = (player.deaths || 0) + 1;
            player.currentHp = derivedStats.maxHealth;
            player.stamina = 0;
            setCharacterData(player);
            saveData(player); // Salva imediatamente em caso de morte
            handleEndBattle();
            return;
        }

        setCharacterData(player);
        setBattleState(prev => ({ ...prev, active: true, monster, battleLog: newBattleLog, isBattleOver: false }));
        // REMOVIDO: saveData(player);
    };

    const advanceTurn = (player, monster, battleLog, skillCooldowns, activeEffects) => {
        let newLog = [...battleLog];
        let newMonster = { ...monster };
        let newEffects = [...activeEffects];
        
        // Decrement Cooldowns
        const newCooldowns = { ...skillCooldowns };
        Object.keys(newCooldowns).forEach(skillId => {
            if (newCooldowns[skillId] > 0) {
                newCooldowns[skillId]--;
            }
        });

        // Process Monster Effects (e.g., burn)
        const burnEffectIndex = newEffects.findIndex(eff => eff.id === 'burn');
        if (burnEffectIndex > -1) {
            const burnEffect = newEffects[burnEffectIndex];
            const burnDamage = Math.floor(newMonster.hp * burnEffect.damagePercent);
            newMonster.currentHp = Math.max(0, newMonster.currentHp - burnDamage);
            newLog.unshift(formatBattleMessage(`${newMonster.name} sofreu ${burnDamage} de dano de queimadura.`));

            newEffects[burnEffectIndex].duration--;
            if (newEffects[burnEffectIndex].duration <= 0) {
                newLog.unshift(formatBattleMessage(`A queimadura em ${newMonster.name} se apagou.`));
                newEffects.splice(burnEffectIndex, 1);
            }
        }
        
        return { player, monster: newMonster, battleLog: newLog, skillCooldowns: newCooldowns, activeEffects: newEffects };
    };

const processMonsterDefeat = (monster, player, battleLog) => {
        addGameMessage(`Você derrotou ${monster.name}!`, 'success');
        const baseExp = Math.max(1, Math.floor(monster.exp * (1 - (player.level - monster.level) * 0.1)));
        const expGained = Math.floor(baseExp * EXP_MULTIPLIER);
        const goldDropped = Math.floor(((Math.random() * monster.gold) + (monster.gold / 2)) * GOLD_MULTIPLIER);
        let newLog = [...battleLog];
        newLog.unshift(formatBattleMessage(`Você ganhou ${expGained} de experiência e ${goldDropped} de ouro.`));
        // CÓDIGO ATUALIZADO (Correto)
let newExp = player.experience + expGained;
let oldLevel = player.level;
let levelUp = false;

newLog.unshift(formatBattleMessage(`Você ganhou ${expGained} de experiência e ${goldDropped} de ouro.`));
addGameMessage(`Você ganhou ${expGained} de experiência e ${goldDropped} de ouro.`, 'info');
addMessage(`Você ganhou ${goldDropped} de ouro.`, 'info', 'Gold');

// CÓDIGO ATUALIZADO (Corrigido e mais eficiente)

let expToNextLevel = player.level * 100;

// Loop para lidar com múltiplos leveis
while (newExp >= expToNextLevel) {
    newExp -= expToNextLevel;
    player.level += 1;
    player.skillPoints += 5;
    levelUp = true;

    const levelUpMessage = `Parabéns! Você alcançou o nível ${player.level}!`;
    addMessage(levelUpMessage, 'success');
    newLog.unshift(formatBattleMessage(levelUpMessage));

    expToNextLevel = player.level * 100; // Apenas atualiza o custo para o próximo nível
}
player.experience = newExp; // Define o XP restante

// Se o jogador subiu de nível, checa os mapas desbloqueados APENAS UMA VEZ
if (levelUp) {
    Object.keys(MAPS).forEach(mapId => {
        // Compara o nível final (player.level) com o nível inicial (oldLevel)
        if (player.level >= MAPS[mapId].minLevel && oldLevel < MAPS[mapId].minLevel) {
            addMessage(`Novo mapa desbloqueado: ${MAPS[mapId].name}!`, 'info');
        }
    });
}




        if (Math.random() < 0.15) {
    // A lógica de adicionar ao 'player' será feita fora, junto com outros drops
    const dropMsg = `O ${monster.name} deixou cair uma Poção de Vida!`;
    addGameMessage(dropMsg, 'info');
    addMessage(dropMsg, 'success', 'Potion');
    newLog.unshift(formatBattleMessage(dropMsg));
    // Adiciona o item à lista de recompensas para ser processado depois
    if(!player.rewards) player.rewards = [];
    player.rewards.push({ type: 'Potion', quantity: 1, data: { id: 'potions_stack', name: 'Poção de Vida', type: 'Potion', description: 'Recupera 15 de HP.' } });
}


if (Math.random() < 0.10) {
    const dropMsg = `O ${monster.name} deixou cair uma Poção de Mana!`;
    addGameMessage(dropMsg, 'info');
    addMessage(dropMsg, 'success', 'ManaPotion');
    newLog.unshift(formatBattleMessage(dropMsg));
    if(!player.rewards) player.rewards = [];
    player.rewards.push({ type: 'ManaPotion', quantity: 1, data: { id: 'mana_potions_stack', name: 'Poção de Mana', type: 'ManaPotion', description: 'Recupera 20 de Mana.' } });
}

        
// --- ATUALIZAÇÃO PARA DROPS DE JOIAS E ITENS ESPECIAIS ---
if (monster.isMapBoss && monster.specialDrops) {
    monster.specialDrops.forEach(drop => {
        if (Math.random() < (drop.chance / 100)) {
            const itemTypeData = drop.type ? ITEM_TYPES[drop.type] : null;

            // Verifica se o item é um pergaminho de habilidade
            if (itemTypeData && itemTypeData.skillId) {
                if (player.inventory.length < INVENTORY_LIMIT) {
                    const skillId = itemTypeData.skillId;
                    const scrollItem = {
                        id: Date.now() + Math.random(),
                        name: drop.name,
                        type: drop.type,
                        quality: 'Épico',
                        qualityColor: 'border-purple-500',
                        description: `Ensina a habilidade: ${SKILLS[skillId].name}. Requer Nível ${SKILLS[skillId].requiredLevel}.`,
                        skillId: skillId,
                        isConsumable: true,
                    };
                    player.inventory.push(scrollItem);
                    const dropMsg = `O ${monster.name} deixou cair um item: ${scrollItem.name}!`;

                    // Como é um item especial, exibe no log e na notificação
                    addGameMessage(dropMsg, 'info');
                    addMessage(dropMsg, 'info', scrollItem.type); // Passa o tipo do item para o ícone
                    newLog.unshift(formatBattleMessage(dropMsg));
                } else {
                    // Se o inventário estiver cheio, mostra apenas a notificação de erro
                    addMessage(`O ${monster.name} deixou cair um ${drop.name}, mas seu inventário está cheio!`, 'error');
                }
            }
            // Verifica se o item é uma receita de craft
            else if (itemTypeData && itemTypeData.recipeId) {
                 if (player.inventory.length < INVENTORY_LIMIT) {
                    const recipeId = itemTypeData.recipeId;
                    const recipeData = CRAFTING_RECIPES[recipeId];
                    const jewelMaterial = recipeData.materials.find(mat => mat.type === 'Blessing');
                    const jewelQuantity = jewelMaterial ? jewelMaterial.quantity : 0;

                    const recipeItem = {
                        id: Date.now() + Math.random(),
                        name: drop.name,
                        type: drop.type,
                        description: `Uma antiga receita de forja. Requer ${jewelQuantity}x Joia da Benção e ${formatGold(recipeData.goldCost)} de ouro.`,
                        recipeId: recipeId,
                        isConsumable: true,
                    };
                    player.inventory.push(recipeItem);
                    const dropMsg = `O ${monster.name} deixou cair um item: ${recipeItem.name}!`;

                    // Como é um item especial, exibe no log e na notificação
                    addGameMessage(dropMsg, 'info');
                    addMessage(dropMsg, 'info', recipeItem.type); // Passa o tipo do item para o ícone
                    newLog.unshift(formatBattleMessage(dropMsg));
                } else {
                    // Se o inventário estiver cheio, mostra apenas a notificação de erro
                    addMessage(`O ${monster.name} deixou cair um ${drop.name}, mas seu inventário está cheio!`, 'error');
                }
            }
            // Trata como joia ou outro item simples
            else {
                let itemTypeForIcon = null; // Variável para o ícone da notificação

if (drop.name.includes('Benção')) {
     if(!player.rewards) player.rewards = [];
     player.rewards.push({ type: 'Blessing', quantity: 1, data: { id: 'blessings_stack', name: 'Joia da Benção', type: 'Blessing', description: 'Aumenta o nível de um item em +1, até +6.' } });
     itemTypeForIcon = 'Blessing';
}
if (drop.name.includes('Alma')) {
     if(!player.rewards) player.rewards = [];
     player.rewards.push({ type: 'Soul', quantity: 1, data: { id: 'souls_stack', name: 'Joia da Alma', type: 'Soul', description: 'Tem 70% de chance de elevar um item de +6 a +9.' } });
     itemTypeForIcon = 'Soul';
}
                // Adicione outras joias aqui (ex: if (drop.name.includes('Vida')))

                const dropMsg = `O ${monster.name} deixou cair uma ${drop.name}!`;

                // Como joias são itens especiais, mostramos em ambos os locais
                addGameMessage(dropMsg, 'info');
                addMessage(dropMsg, 'info', itemTypeForIcon); // Passa o tipo correto para o ícone
                newLog.unshift(formatBattleMessage(dropMsg));
            }
        }
    });
}
// --- FIM DA ATUALIZAÇÃO ---


const shouldDropItem = monster.isMapBoss || Math.random() < 0.3;
if (shouldDropItem) {
    if (player.inventory.length < INVENTORY_LIMIT) {
        const legendaryDropChance = monster.legendaryDropChance ? monster.legendaryDropChance / 100 : 0;
        const newItem = generateRandomItem(player.level, monster.isMapBoss, legendaryDropChance);
        player.inventory.push(newItem);
        
        // --- LÓGICA DE NOTIFICAÇÃO DE DROP ATUALIZADA ---
        const dropMsg = `O ${monster.name} deixou cair um item: ${newItem.name}!`;
        const specialQualities = ['Raro', 'Épico', 'Lendário'];
        const isSpecialQuality = specialQualities.includes(newItem.quality);

        // Adiciona ao log principal (chat) apenas se a qualidade for especial.
        // Este comportamento foi mantido.
        if (isSpecialQuality) {
            addGameMessage(dropMsg, 'info');
        }

        // A notificação pop-up (addMessage) é exibida para TODOS os itens de equipamento
        // com o ícone genérico de 'sucesso', conforme solicitado.
        addMessage(dropMsg, 'success');

        newLog.unshift(formatBattleMessage(dropMsg));
        // --- FIM DA ATUALIZAÇÃO ---
        
	} else {
   	 addGameMessage(`O ${monster.name} deixou cair um item, mas seu inventário está cheio!`, 'error');
   	 addMessage(`O ${monster.name} deixou cair um item, mas seu inventário está cheio!`, 'error'); // <<< Adicione esta linha
	}
}

        let newMapState = { ...player.mapState };
        newMapState[activeMap] = newMapState[activeMap].filter(m => m.id !== monster.id);
if (newMapState[activeMap].length === 0) {
    addMessage(`Todos os monstros de ${MAPS[activeMap].name} foram derrotados! Novos monstros apareceram.`, 'info');
    
    // LÓGICA CORRIGIDA: Verifica se o mapa usa o sistema de spawn aleatório
    if (MAP_SPAWN_BOUNDS[activeMap]) {
        newMapState[activeMap] = generateRandomMonsters(activeMap);
    } else {
        // Mantém o comportamento antigo para outros mapas
        newMapState[activeMap] = MAPS[activeMap].monsters.map((m, index) => ({ ...m, id: `${activeMap}-${index}-${Date.now()}`, currentHp: m.hp }));
    }
}
        player.mapState = newMapState;
        player.gold = (player.gold || 0) + goldDropped;

        if (levelUp) {
            const maxHpAfterLevelUp = Math.floor((player.stats.health / HEALTH_STAT_TO_HP_DIVISOR) * (1 + derivedOptionStats.hp_increase));
            const maxManaAfterLevelUp = Math.floor((player.stats.mana / MANA_STAT_TO_MP_DIVISOR) * (1 + derivedOptionStats.mana_increase));
            player.currentHp = maxHpAfterLevelUp;
            player.currentMana = maxManaAfterLevelUp;
            player.stamina = MAX_STAMINA;
        }

// processe a lista de recompensas.
if (player.rewards && player.rewards.length > 0) {
    player.rewards.forEach(reward => {
        let inventory = player.inventory || [];
        let itemFound = false;
        // Tenta empilhar
        inventory = inventory.map(item => {
            if (item.type === reward.type) {
                item.quantity = (item.quantity || 1) + reward.quantity;
                itemFound = true;
            }
            return item;
        });
        // Se não encontrou para empilhar, adiciona novo
        if (!itemFound && inventory.length < INVENTORY_LIMIT) {
            inventory.push({ ...reward.data, quantity: reward.quantity });
        } else if (!itemFound) {
             addMessage(`Inventário cheio, ${reward.data.name} foi perdido!`, 'error');
        }
        player.inventory = inventory;
    });
}
	delete player.rewards; // Limpa a lista temporária

// --- ATUALIZAÇÃO DE MISSÕES: KILL_MONSTER ---
const killMission = player.missions?.find(m =>
    m.status === 'active' &&
    MISSIONS[m.id]?.type === MISSION_TYPES.KILL_MONSTER &&
    MISSIONS[m.id]?.objective.monsterName === monster.name
);

if (killMission) {
    player.missions = player.missions.map(m => {
        if (m.id === killMission.id) {
            const newProgress = (m.progress || 0) + 1;
            const missionInfo = MISSIONS[m.id];
            let newStatus = m.status;

            if (newProgress >= missionInfo.objective.targetCount) {
                newStatus = 'completed';
                addMessage(`Missão Concluída: ${missionInfo.name}!`, 'success');
            }
            return { ...m, progress: newProgress, status: newStatus };
        }
        return m;
    });
}


        setCharacterData(player);
        saveData(player); // Salva imediatamente após a batalha para garantir as recompensas

        setBattleState(prev => ({ ...prev, monster, battleLog: newLog, isBattleOver: true }));
    };

    const handlePlayerAttack = (attackType) => {
        let { monster, battleLog, skillCooldowns, activeEffects } = battleState;
        let player = { ...characterData };
        let newBattleLog = [...battleLog];
        let playerAttack = derivedStats.attack;

        if (attackType === 'physical') {
            const staminaCost = Math.floor(monster.level / 10) + 1;
            if (player.stamina < staminaCost) {
                newBattleLog.unshift(formatBattleMessage("Stamina esgotada! Não é possível atacar, aguarde ou encerre a batalha."));
                setBattleState(prev => ({ ...prev, battleLog: newBattleLog }));
                return;
            }
            player.stamina -= staminaCost;
        }

        setCharacterData(player);

        if (Math.random() < PLAYER_MISS_CHANCE) {
            newBattleLog.unshift(formatBattleMessage("Você atacou, mas errou!"));
            const stateAfterPlayerTurn = advanceTurn(player, monster, newBattleLog, skillCooldowns, activeEffects);
            setBattleState(prev => ({ ...prev, ...stateAfterPlayerTurn }));
            triggerMonsterAttack(stateAfterPlayerTurn.monster, stateAfterPlayerTurn.player, stateAfterPlayerTurn.battleLog);
            return;
        }

        let finalDamage = Math.max(1, playerAttack - monster.defense);
        const isDoubleDamage = Math.random() < derivedOptionStats.double_damage;
        if (isDoubleDamage) finalDamage *= 2;

        const totalCriticalChance = PLAYER_CRITICAL_CHANCE + derivedOptionStats.critical_chance;
        const isCritical = Math.random() < totalCriticalChance;
        if (isCritical) finalDamage = Math.floor(finalDamage * CRITICAL_DAMAGE_MULTIPLIER);
        
        let damageMessage = `Você acertou ${monster.name} causando ${finalDamage} de dano.`;
        if (isDoubleDamage) damageMessage = `DANO DUPLO! Você acertou ${monster.name} causando ${finalDamage} de dano.`;
        if (isCritical) damageMessage = `ATAQUE CRÍTICO! Você acertou ${monster.name} causando ${finalDamage} de dano.`;

        newBattleLog.unshift(formatBattleMessage(damageMessage));
        let newMonsterHp = Math.max(0, monster.currentHp - finalDamage);
        monster.currentHp = newMonsterHp;

        if (newMonsterHp <= 0) {
            processMonsterDefeat(monster, player, newBattleLog);
        } else {
            const stateAfterPlayerTurn = advanceTurn(player, monster, newBattleLog, skillCooldowns, activeEffects);
            setBattleState(prev => ({ ...prev, ...stateAfterPlayerTurn }));
            triggerMonsterAttack(stateAfterPlayerTurn.monster, stateAfterPlayerTurn.player, stateAfterPlayerTurn.battleLog);
        }
    };
    
    const handleUseSkill = (skillId) => {
        if (!skillId) return;

        let { monster, battleLog, skillCooldowns, activeEffects } = battleState;
        let player = { ...characterData };
        let newBattleLog = [...battleLog];
        const skill = SKILLS[skillId];

        if (player.currentMana < skill.manaCost) {
            newBattleLog.unshift(formatBattleMessage("Mana insuficiente para usar a habilidade."));
            setBattleState(prev => ({ ...prev, battleLog: newBattleLog }));
            return;
        }
        if (skillCooldowns[skillId] > 0) {
            newBattleLog.unshift(formatBattleMessage(`${skill.name} está em tempo de recarga.`));
            setBattleState(prev => ({ ...prev, battleLog: newBattleLog }));
            return;
        }

        player.currentMana -= skill.manaCost;
        let newCooldowns = { ...skillCooldowns, [skillId]: skill.cooldown + 1 };
        let newActiveEffects = [...activeEffects];

        newBattleLog.unshift(formatBattleMessage(`Você usou ${skill.name}!`));

        let finalDamage = 0;
        let playerAttack = derivedStats.attack;

        if (skillId === 'ataque_veloz') {
            let damage1 = Math.max(1, playerAttack - monster.defense);
            if (Math.random() < 0.20) { damage1 *= 2; newBattleLog.unshift(formatBattleMessage(`DANO DUPLO no primeiro golpe!`)); }
            
            let damage2 = Math.max(1, playerAttack - monster.defense);
            if (Math.random() < 0.20) { damage2 *= 2; newBattleLog.unshift(formatBattleMessage(`DANO DUPLO no segundo golpe!`)); }

            finalDamage = damage1 + damage2;
            newBattleLog.unshift(formatBattleMessage(`Seu ataque veloz causa ${damage1} + ${damage2} = ${finalDamage} de dano.`));
        
        } else if (skillId === 'explosao_de_fogo') {
            finalDamage = Math.max(1, playerAttack - monster.defense);
            newBattleLog.unshift(formatBattleMessage(`Sua bola de fogo causa ${finalDamage} de dano.`));

            const existingBurnIndex = newActiveEffects.findIndex(eff => eff.id === 'burn');
            if (existingBurnIndex > -1) newActiveEffects.splice(existingBurnIndex, 1);
            newActiveEffects.push({ ...skill.effect, duration: skill.effect.duration + 1 });
            newBattleLog.unshift(formatBattleMessage(`${monster.name} está queimando!`));
        
        } else if (skillId === 'tiro_mistico') {
            finalDamage = Math.max(1, playerAttack - monster.defense);
            const totalCriticalChance = PLAYER_CRITICAL_CHANCE + derivedOptionStats.critical_chance + skill.effect.chance;
            if (Math.random() < totalCriticalChance) {
                finalDamage = Math.floor(finalDamage * CRITICAL_DAMAGE_MULTIPLIER);
                newBattleLog.unshift(formatBattleMessage(`ATAQUE CRÍTICO! Seu tiro preciso causa ${finalDamage} de dano.`));
            } else {
                newBattleLog.unshift(formatBattleMessage(`Seu tiro místico causa ${finalDamage} de dano.`));
            }
        }
        
        monster.currentHp = Math.max(0, monster.currentHp - finalDamage);

        if (monster.currentHp <= 0) {
            processMonsterDefeat(monster, player, newBattleLog);
        } else {
            const stateAfterPlayerTurn = advanceTurn(player, monster, newBattleLog, newCooldowns, newActiveEffects);
            setBattleState(prev => ({ ...prev, ...stateAfterPlayerTurn }));
            triggerMonsterAttack(stateAfterPlayerTurn.monster, stateAfterPlayerTurn.player, stateAfterPlayerTurn.battleLog);
        }
    };

const handleUsePotionInBattle = (potionType) => {
    const { monster, battleLog, skillCooldowns, activeEffects } = battleState;
    let player = { ...characterData };
    let potionUsed = false;
    let message = '';
    let itemType = '';
    let healAmount = 0;
    
    const newInventory = [...player.inventory];
    let potionStackIndex = -1;
    let potionStack = null;

    if (potionType === 'health') {
        const maxHp = derivedStats.maxHealth;
        potionStackIndex = newInventory.findIndex(item => item.type === 'Potion');
        if (potionStackIndex !== -1 && player.currentHp < maxHp) {
            potionStack = { ...newInventory[potionStackIndex] };
            const healthBefore = player.currentHp;
            player.currentHp = Math.min(maxHp, player.currentHp + 15);
            healAmount = player.currentHp - healthBefore;
            itemType = 'Poção de Vida';
            potionUsed = true;
        }
    } else if (potionType === 'mana') {
        const maxMana = derivedStats.maxMana;
        potionStackIndex = newInventory.findIndex(item => item.type === 'ManaPotion');
        if (potionStackIndex !== -1 && player.currentMana < maxMana) {
            potionStack = { ...newInventory[potionStackIndex] };
            const manaBefore = player.currentMana;
            player.currentMana = Math.min(maxMana, player.currentMana + 20);
            healAmount = player.currentMana - manaBefore;
            itemType = 'Poção de Mana';
            potionUsed = true;
        }
    } else if (potionType === 'stamina') {
        potionStackIndex = newInventory.findIndex(item => item.type === 'StaminaPotion');
        if (potionStackIndex !== -1 && player.stamina < MAX_STAMINA) {
            potionStack = { ...newInventory[potionStackIndex] };
            const staminaBefore = player.stamina;
            player.stamina = Math.min(MAX_STAMINA, player.stamina + 20);
            healAmount = player.stamina - staminaBefore;
            itemType = 'Poção de Stamina';
            potionUsed = true;
        }
    }

    if (potionUsed && potionStack) {
        message = `Você usou uma ${itemType} e recuperou ${healAmount}.`;
        potionStack.quantity -= 1;
        if (potionStack.quantity > 0) {
            newInventory[potionStackIndex] = potionStack;
        } else {
            newInventory.splice(potionStackIndex, 1);
        }
        player.inventory = newInventory;
    } else {
        message = `Não foi possível usar a poção.`;
    }
    
    const updatedLog = [formatBattleMessage(message), ...battleLog];
    setCharacterData(player);

    if (potionUsed) {
        const stateAfterPlayerTurn = advanceTurn(player, monster, updatedLog, skillCooldowns, activeEffects);
        setBattleState(prev => ({ ...prev, ...stateAfterPlayerTurn }));
        triggerMonsterAttack(stateAfterPlayerTurn.monster, stateAfterPlayerTurn.player, stateAfterPlayerTurn.battleLog);
    } else {
        setBattleState(prev => ({ ...prev, battleLog: updatedLog }));
    }
};

    const totalPendingPoints = useMemo(() => Object.values(pendingStats).reduce((sum, val) => sum + val, 0), [pendingStats]);
    const remainingSkillPoints = (characterData.skillPoints || 0) - totalPendingPoints;

    const handleIncreasePendingStat = (stat) => {
        if (remainingSkillPoints > 0) {
            setPendingStats(prev => ({ ...prev, [stat]: prev[stat] + 1 }));
        }
    };

    const handleDecreasePendingStat = (stat) => {
        if (pendingStats[stat] > 0) {
            setPendingStats(prev => ({ ...prev, [stat]: prev[stat] - 1 }));
        }
    };

    const handleCancelStats = () => {
        setPendingStats({ strength: 0, agility: 0, health: 0, mana: 0 });
    };

    const handleConfirmStats = () => {
        if (characterData?.currentInvasion) {
            addMessage("Você não pode distribuir pontos enquanto estiver em uma invasão.", "error");
            return;
        }
        if (totalPendingPoints <= 0 || totalPendingPoints > characterData.skillPoints) return;

        const oldStats = characterData.stats;
        const newStats = { ...oldStats };
        Object.keys(pendingStats).forEach(stat => {
            newStats[stat] = (newStats[stat] || 0) + pendingStats[stat];
        });

        let newCurrentHp = characterData.currentHp;
        if (pendingStats.health > 0) {
            const oldMaxHp = Math.floor((oldStats.health / HEALTH_STAT_TO_HP_DIVISOR) * (1 + derivedOptionStats.hp_increase));
            const newMaxHp = Math.floor((newStats.health / HEALTH_STAT_TO_HP_DIVISOR) * (1 + derivedOptionStats.hp_increase));
            newCurrentHp += (newMaxHp - oldMaxHp);
        }

        let newCurrentMana = characterData.currentMana;
        if (pendingStats.mana > 0) {
            const oldMaxMp = Math.floor((oldStats.mana / MANA_STAT_TO_MP_DIVISOR) * (1 + derivedOptionStats.mana_increase));
            const newMaxMp = Math.floor((newStats.mana / MANA_STAT_TO_MP_DIVISOR) * (1 + derivedOptionStats.mana_increase));
            newCurrentMana += (newMaxMp - oldMaxMp);
        }

        const newData = {
            ...characterData,
            stats: newStats,
            currentHp: newCurrentHp,
            currentMana: newCurrentMana,
            skillPoints: remainingSkillPoints
        };

        setCharacterData(newData);
        saveData(newData); // Salva imediatamente após confirmar os stats
        handleCancelStats();
    };


    const equipItem = (item) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode equipar ou desequipar um item durante a invasão.", "error");
        return;
    }
        const itemTypeDetails = ITEM_TYPES[item.type];
        if (!itemTypeDetails) return;
    
        if (itemTypeDetails.class && itemTypeDetails.class !== characterData.class) {
            addGameMessage(`Sua classe (${characterData.class}) não pode usar este item.`, 'error');
            hideTooltip();
            return;
        }
    
        const itemSlotType = itemTypeDetails.slot;
        const newEquipment = { ...characterData.equipment };
        let newInventory = characterData.inventory.filter(invItem => invItem.id !== item.id);
        let targetSlot = null;
    
        if (itemSlotType === 'hand') {
            let equippedShieldSlot = null;
            if (characterData.equipment.leftHand?.type === 'Shield') {
                equippedShieldSlot = 'leftHand';
            } else if (characterData.equipment.rightHand?.type === 'Shield') {
                equippedShieldSlot = 'rightHand';
            }
    
            if (item.type === 'Shield' && equippedShieldSlot) {
                targetSlot = equippedShieldSlot;
            } else {
                if (!newEquipment.leftHand) {
                    targetSlot = 'leftHand';
                } else if (!newEquipment.rightHand) {
                    targetSlot = 'rightHand';
                } else {
                    targetSlot = 'leftHand';
                }
            }
        } else {
            targetSlot = itemSlotType;
        }
    
        if (targetSlot) {
            const itemBeingReplaced = newEquipment[targetSlot];
    
            if (itemBeingReplaced) {
                if (newInventory.length >= INVENTORY_LIMIT) {
                    addGameMessage("Inventário cheio! Não é possível trocar o item.", 'error');
                    hideTooltip();
                    return;
                }
                newInventory.push(itemBeingReplaced);
            }
    
            newEquipment[targetSlot] = item;
    
            const newData = { ...characterData, equipment: newEquipment, inventory: newInventory };
            setCharacterData(newData);
            // REMOVIDO: saveData(newData);
        } else {
            addGameMessage("Não foi possível equipar o item.", 'error');
        }
    
        hideTooltip();
        setDraggedItem(null);
        setDragPreviewStyle(null);
    };

    const unequipItem = (slot) => {
    if (characterData?.currentInvasion) { 
        addMessage("Você não pode desequipar um item durante a invasão.", "error");
        return; 
    }
        const item = characterData.equipment[slot];
        if (item) {
            if (characterData.inventory.length >= INVENTORY_LIMIT) {
                addGameMessage("Inventário cheio! Não é possível desequipar o item.", 'error');
                hideTooltip();
                return;
            }
            const newEquipment = { ...characterData.equipment, [slot]: null };
            const newInventory = [...characterData.inventory, item];
            const newData = { ...characterData, equipment: newEquipment, inventory: newInventory };
            setCharacterData(newData);
            // REMOVIDO: saveData(newData);
            hideTooltip();
            setDraggedItem(null);
            setDragPreviewStyle(null);
        }
    };
    
    const learnSkill = (scroll) => {
        const skillId = scroll.skillId;
        if (!skillId || !SKILLS[skillId]) {
            addGameMessage("Este pergaminho é inválido.", "error");
            return;
        }

        const skill = SKILLS[skillId];

        if (characterData.level < skill.requiredLevel) {
            addGameMessage(`Você precisa ser nível ${skill.requiredLevel} para aprender esta habilidade.`, "error");
            return;
        }

        if (characterData.class !== skill.class) {
            addGameMessage(`Sua classe (${characterData.class}) não pode aprender a habilidade ${skill.name}.`, "error");
            return;
        }

        if (characterData.learnedSkills.includes(skillId)) {
            addGameMessage(`Você já conhece a habilidade ${skill.name}.`, "info");
            return;
        }

        // All checks passed, learn the skill
        const newLearnedSkills = [...characterData.learnedSkills, skillId];
        const newInventory = characterData.inventory.filter(i => i.id !== scroll.id);

        const newData = {
            ...characterData,
            learnedSkills: newLearnedSkills,
            inventory: newInventory
        };

        setCharacterData(newData);
        saveData(newData); // Salva imediatamente para não perder a habilidade
        addMessage(`Você aprendeu uma nova habilidade: ${skill.name}!`, 'success');
        hideTooltip();
    };




    const handleDragStart = (e, item, source) => { const dragData = { item, source }; e.dataTransfer.setData("application/json", JSON.stringify(dragData)); setDraggedItem(dragData); };
    const handleDragEnd = () => { setDraggedItem(null); setHoveredDropZone(null); setDragPreviewStyle(null); };
    const handleTouchStart = (e, item, source) => { setDraggedItem({ item, source }); const touch = e.touches[0]; setDragPreviewStyle({ left: touch.clientX, top: touch.clientY }); };
    const handleDragOver = (e) => { e.preventDefault(); const dropZoneId = e.currentTarget.dataset.dropzoneId; setHoveredDropZone(dropZoneId); };
    const handleDragLeave = () => { setHoveredDropZone(null); };

    const handleDropOnEquipment = (e, targetSlot) => {
        e.preventDefault();
        hideTooltip();
        setHoveredDropZone(null);
        const data = JSON.parse(e.dataTransfer.getData("application/json"));
        performDropOnEquipment(data.item, data.source, targetSlot);
        setDraggedItem(null);
        setDragPreviewStyle(null);
    };

    // --- ATUALIZAÇÃO 3: Função handleDrop refatorada e centralizada ---
const handleDrop = (e) => {
    e.preventDefault();
    hideTooltip();
    const dropZoneId = e.currentTarget.dataset.dropzoneId;
    const dataString = e.dataTransfer.getData("application/json");

    if (dataString) {
        const data = JSON.parse(dataString);
        const { item, source: itemSource } = data;

if (dropZoneId === 'sell') {
    const sellPrice = calculateSellPrice(item);
    openConfirmationModal({
        title: 'Confirmar Venda',
        message: `Deseja vender ${item.name} por ${formatGold(sellPrice)} de ouro?`,
        onConfirm: () => sellItem(item, itemSource)
    });
} else if (dropZoneId === 'chest' && itemSource === 'inventory') {
            moveItemToChest(item);
        // --- INÍCIO DA ALTERAÇÃO ---
        } else if (dropZoneId === 'inventory' && itemSource !== 'inventory' && itemSource !== 'chest') {
            // Se a fonte do item NÃO for o inventário ou baú, significa que é um item equipado.
            unequipItem(itemSource); // O itemSource aqui é o "slot" do equipamento
        // --- FIM DA ALTERAÇÃO ---
        }
    }

    setHoveredDropZone(null);
    setDraggedItem(null);
    setDragPreviewStyle(null);
};

    const buyItem = (e, itemToBuy) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode comprar um item durante a invasão.", "error");
        return;
    }
        if (characterData.inventory.length >= INVENTORY_LIMIT) {
            addMessage("Seu inventário está cheio. Venda itens para liberar espaço.", 'error');
            return;
        }
        if ((characterData.gold || 0) >= itemToBuy.price) {
            const rect = e.currentTarget.getBoundingClientRect();
            createFloatingText(`-${itemToBuy.price}`, 'gold', { x: rect.left + rect.width / 2, y: rect.top - 10 });

            setTimeout(() => {
                 const newInventory = [...characterData.inventory, { ...itemToBuy, id: Date.now() + Math.random(), upgradeLevel: 0 }];
                 const newShopItems = characterData.shopItems.filter(shopItem => shopItem.id !== itemToBuy.id);

                 const newData = {
                     ...characterData,
                     inventory: newInventory,
                     gold: (characterData.gold || 0) - itemToBuy.price,
                     shopItems: newShopItems
                 };
                 setCharacterData(newData);
                 saveData(newData);
                 addMessage(`Você comprou ${itemToBuy.name} por ${itemToBuy.price} de ouro.`, 'success');
            }, 500);

        } else {
            addMessage("Ouro insuficiente para comprar este item.", 'error');
        }
    };

const buyStaminaPotion = (e) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode comprar um item durante a invasão.", "error");
        return;
    }
    const cost = calculateStaminaPotionCost(characterData.level);
    if ((characterData.gold || 0) < cost) {
        addMessage(`Ouro insuficiente. Custo: ${cost} de ouro.`, 'error');
        return;
    }
    if (characterData.inventory.length >= INVENTORY_LIMIT && !characterData.inventory.some(i => i.type === 'StaminaPotion')) {
        addMessage("Inventário cheio e sem poções para empilhar.", 'error');
        return;
    }

    setCharacterData(prev => {
        const newData = { ...prev, gold: (prev.gold || 0) - cost };
        let stackFound = false;

        const newInventory = newData.inventory.map(item => {
            if (item.type === 'StaminaPotion') {
                stackFound = true;
                return { ...item, quantity: (item.quantity || 1) + 1 }; // Retorna um novo objeto
            }
            return item;
        });

        if (!stackFound) {
            newInventory.push({ id: 'stamina_potions_stack', name: 'Poção de Stamina', type: 'StaminaPotion', description: 'Restaura 20 de stamina.', quantity: 1, slot: 'consumable' });
        }
        newData.inventory = newInventory;
        return newData;
    });
    addMessage(`Você comprou uma Poção de Stamina por ${cost} de ouro.`, 'success');
};

const buyLifePotion = (e) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode comprar um item durante a invasão.", "error");
        return;
    }
    const cost = calculateLifePotionCost(characterData.level);
    if ((characterData.gold || 0) < cost) {
        addMessage(`Ouro insuficiente. Custo: ${cost} de ouro.`, 'error');
        return;
    }
     if (characterData.inventory.length >= INVENTORY_LIMIT && !characterData.inventory.some(i => i.type === 'Potion')) {
        addMessage("Inventário cheio e sem poções para empilhar.", 'error');
        return;
    }

    setCharacterData(prev => {
        const newData = { ...prev, gold: (prev.gold || 0) - cost };
        let stackFound = false;

        const newInventory = newData.inventory.map(item => {
            if (item.type === 'Potion') {
                stackFound = true;
                return { ...item, quantity: (item.quantity || 1) + 1 }; // Retorna um novo objeto
            }
            return item;
        });

        if (!stackFound) {
            newInventory.push({ id: 'potions_stack', name: 'Poção de Vida', type: 'Potion', description: 'Recupera 15 de HP.', quantity: 1, slot: 'consumable' });
        }
        newData.inventory = newInventory;
        return newData;
    });
    addMessage(`Você comprou uma Poção de Vida por ${cost} de ouro.`, 'success');
};

const buyManaPotion = (e) => {
    if (characterData?.currentInvasion) {
        addMessage("Você não pode comprar um item durante a invasão.", "error");
        return;
    }
    const cost = calculateManaPotionCost(characterData.level);
    if ((characterData.gold || 0) < cost) {
        addMessage(`Ouro insuficiente. Custo: ${cost} de ouro.`, 'error');
        return;
    }
     if (characterData.inventory.length >= INVENTORY_LIMIT && !characterData.inventory.some(i => i.type === 'ManaPotion')) {
        addMessage("Inventário cheio e sem poções para empilhar.", 'error');
        return;
    }

    setCharacterData(prev => {
        const newData = { ...prev, gold: (prev.gold || 0) - cost };
        let stackFound = false;

        const newInventory = newData.inventory.map(item => {
            if (item.type === 'ManaPotion') {
                stackFound = true;
                return { ...item, quantity: (item.quantity || 1) + 1 }; // Retorna um novo objeto
            }
            return item;
        });

        if (!stackFound) {
            newInventory.push({ id: 'mana_potions_stack', name: 'Poção de Mana', type: 'ManaPotion', description: 'Recupera 20 de Mana.', quantity: 1, slot: 'consumable' });
        }
        newData.inventory = newInventory;
        return newData;
    });
    addMessage(`Você comprou uma Poção de Mana por ${cost} de ouro.`, 'success');
};


const handleUseManaPotion = () => {
    const maxMana = derivedStats.maxMana;
    if (characterData.currentMana >= maxMana) {
        addMessage("Sua mana já está no máximo.", 'info');
        return;
    }

    const newInventory = [...characterData.inventory];
    const potionStackIndex = newInventory.findIndex(item => item.type === 'ManaPotion');

    if (potionStackIndex === -1) {
        addMessage("Você não tem Poções de Mana.", 'error');
        return;
    }

    const potionStack = { ...newInventory[potionStackIndex] };
    const manaBefore = characterData.currentMana;
    const newMana = Math.min(maxMana, characterData.currentMana + 20);
    const manaRecovered = newMana - manaBefore;

    potionStack.quantity -= 1;

    if (potionStack.quantity > 0) {
        newInventory[potionStackIndex] = potionStack;
    } else {
        newInventory.splice(potionStackIndex, 1);
    }

    const newData = { ...characterData, inventory: newInventory, currentMana: newMana };
    setCharacterData(newData);
    saveData(newData);
    addMessage(`Você usou uma Poção de Mana e recuperou ${manaRecovered} de mana.`, 'success');
};

const handleUsePotion = () => {
    const maxHp = derivedStats.maxHealth;
    if (characterData.currentHp >= maxHp) {
        addMessage("Sua vida já está no máximo.", 'info');
        return;
    }

    const newInventory = [...characterData.inventory];
    const potionStackIndex = newInventory.findIndex(item => item.type === 'Potion');

    if (potionStackIndex === -1) {
        addMessage("Você não tem Poções de Vida.", 'error');
        return;
    }

    const potionStack = { ...newInventory[potionStackIndex] };
    const healthBefore = characterData.currentHp;
    const newHp = Math.min(maxHp, characterData.currentHp + 15);
    const healthRecovered = newHp - healthBefore;

    potionStack.quantity -= 1;

    if (potionStack.quantity > 0) {
        newInventory[potionStackIndex] = potionStack;
    } else {
        newInventory.splice(potionStackIndex, 1);
    }

    const newData = { ...characterData, inventory: newInventory, currentHp: newHp };
    setCharacterData(newData);
    saveData(newData);
    addMessage(`Você usou uma Poção e recuperou ${healthRecovered} de vida.`, 'success');
};

const handleUseStaminaPotion = () => {
    if (characterData.stamina >= MAX_STAMINA) {
        addMessage("Sua stamina já está no máximo.", 'info');
        return;
    }

    const newInventory = [...characterData.inventory];
    const potionStackIndex = newInventory.findIndex(item => item.type === 'StaminaPotion');

    if (potionStackIndex === -1) {
        addMessage("Você não tem Poções de Stamina.", 'error');
        return;
    }

    const potionStack = { ...newInventory[potionStackIndex] };
    const newStamina = Math.min(MAX_STAMINA, (characterData.stamina || 0) + 20);

    potionStack.quantity -= 1;

    if (potionStack.quantity > 0) {
        newInventory[potionStackIndex] = potionStack;
    } else {
        newInventory.splice(potionStackIndex, 1);
    }

    const newData = { ...characterData, inventory: newInventory, stamina: newStamina };
    setCharacterData(newData);
    saveData(newData);
    addMessage("Você usou uma Poção de Stamina e recuperou 20 de stamina.", 'success');
};    



   const handleItemClick = (item) => {
        if (characterData?.currentInvasion) {
            addMessage("Você não pode usar itens enquanto estiver em uma invasão.", "error");
            return;
        }
        if (draggedItem) return;
    
        // Lógica de upgrade priorizada
        if (isUpgrading) {
            if (!item.quantity && !item.isConsumable) {
                upgradeItem(item);
            } else {
                addMessage("Você não pode melhorar este tipo de item.", 'error');
                setIsUpgrading(false);
            }
            return;
        }
        if (isUpgradingWithSoul) {
            if (!item.quantity && !item.isConsumable) {
                upgradeItemWithSoul(item);
            } else {
                addMessage("Você não pode melhorar este tipo de item.", 'error');
                setIsUpgradingWithSoul(false);
            }
            return;
        }
    
        // Lógica de consumíveis
        if (item.type.includes('Scroll')) {
            learnSkill(item);
            return;
        }
        
        switch (item.type) {
            case 'Potion': handleUsePotion(); break;
            case 'ManaPotion': handleUseManaPotion(); break;
            case 'StaminaPotion': handleUseStaminaPotion(); break;
            case 'Blessing': setIsUpgrading(true); addMessage("Modo de melhoria (Benção) ativado. Clique em um item (até +5) para usar a Joia.", 'info'); break;
            case 'Soul': setIsUpgradingWithSoul(true); addMessage("Modo de melhoria (Alma) ativado. Clique em um item (+6 a +8) para usar a Joia.", 'info'); break;
            default: break;
        }
    };




    // --- FUNÇÃO DE UPGRADE ATUALIZADA (Joia da Benção) ---
const upgradeItem = (itemToUpgrade) => {
    if ((itemToUpgrade.upgradeLevel || 0) >= 6) {
        addMessage("Este item precisa de uma Joia da Alma para ser melhorado.", 'error');
        setIsUpgrading(false);
        return;
    }

    const newInventory = [...characterData.inventory];
    const blessingStackIndex = newInventory.findIndex(item => item.type === 'Blessing');

    if (blessingStackIndex === -1 || newInventory[blessingStackIndex].quantity <= 0) {
        addMessage("Você não tem Joias da Benção para melhorar itens.", 'error');
        setIsUpgrading(false);
        return;
    }

    if ((itemToUpgrade.upgradeLevel || 0) >= MAX_UPGRADE_LEVEL) {
        addMessage("Este item já atingiu o nível máximo.", 'info');
        setIsUpgrading(false);
        return;
    }

    let itemFound = false;
    let newData = { ...characterData };
    const upgrade = (item) => ({ ...item, upgradeLevel: (item.upgradeLevel || 0) + 1 });

    const inventoryWithUpgrade = newInventory.map(item => {
        if (item.id === itemToUpgrade.id) {
            itemFound = true;
            return upgrade(item);
        }
        return item;
    });

    if (itemFound) {
        newData.inventory = inventoryWithUpgrade;
    } else {
        const newEquipment = { ...newData.equipment };
        for (const slot in newEquipment) {
            if (newEquipment[slot] && newEquipment[slot].id === itemToUpgrade.id) {
                itemFound = true;
                newEquipment[slot] = upgrade(newEquipment[slot]);
                newData.equipment = newEquipment;
                break;
            }
        }
    }

    if (itemFound) {
        // Consome a joia
        const blessingStack = { ...newInventory[blessingStackIndex] };
        blessingStack.quantity -= 1;
        if (blessingStack.quantity > 0) {
            newData.inventory[blessingStackIndex] = blessingStack;
        } else {
            newData.inventory.splice(blessingStackIndex, 1);
        }

        setCharacterData(newData);
        saveData(newData);
        addMessage(`Você usou uma Joia da Benção! ${itemToUpgrade.name} agora é +${(itemToUpgrade.upgradeLevel || 0) + 1}.`, 'success');
        setDraggedItem(null);
        setDragPreviewStyle(null);
    } else {
        addMessage("Não foi possível encontrar o item para melhorar.", 'error');
    }
    setIsUpgrading(false);
};


    // --- NOVA FUNÇÃO DE UPGRADE (Joia da Alma) ---
const upgradeItemWithSoul = (itemToUpgrade) => {
    // --- LÓGICA DE VERIFICAÇÃO CORRIGIDA ---
    // Procura pela pilha de Joias da Alma no inventário
    const newInventory = [...characterData.inventory];
    const soulStackIndex = newInventory.findIndex(item => item.type === 'Soul');

    if (soulStackIndex === -1 || newInventory[soulStackIndex].quantity <= 0) {
        addMessage("Você não tem Joias da Alma.", 'error');
        setIsUpgradingWithSoul(false);
        return;
    }

    const currentLevel = itemToUpgrade.upgradeLevel || 0;
    if (currentLevel < 6 || currentLevel >= MAX_UPGRADE_LEVEL) {
        addMessage("A Joia da Alma só pode ser usada em itens de +6 a +8.", 'info');
        setIsUpgradingWithSoul(false);
        return;
    }

    let itemFound = false;
    let newData = { ...characterData };
    const success = Math.random() < 0.70; // 70% de chance de sucesso

    const upgrade = (item) => {
        if (success) {
            return { ...item, upgradeLevel: currentLevel + 1 };
        } else {
            return { ...item, upgradeLevel: 0 };
        }
    };

    // Procura o item no inventário para aplicar o upgrade
    const inventoryWithUpgrade = newInventory.map(item => {
        if (item.id === itemToUpgrade.id) {
            itemFound = true;
            return upgrade(item);
        }
        return item;
    });

    if (itemFound) {
        newData.inventory = inventoryWithUpgrade;
    } else {
        // Procura o item no equipamento se não encontrou no inventário
        const newEquipment = { ...newData.equipment };
        for (const slot in newEquipment) {
            if (newEquipment[slot] && newEquipment[slot].id === itemToUpgrade.id) {
                itemFound = true;
                newEquipment[slot] = upgrade(newEquipment[slot]);
                newData.equipment = newEquipment;
                break;
            }
        }
    }

    if (itemFound) {
        // --- LÓGICA DE CONSUMO CORRIGIDA ---
        // Consome a joia da pilha no inventário
        const soulStack = { ...newData.inventory[soulStackIndex] };
        soulStack.quantity -= 1;
        if (soulStack.quantity > 0) {
            newData.inventory[soulStackIndex] = soulStack;
        } else {
            // Remove a pilha se a quantidade chegar a zero
            newData.inventory.splice(soulStackIndex, 1);
        }

        setCharacterData(newData);
        saveData(newData);
        if (success) {
            addMessage(`Sucesso! ${itemToUpgrade.name} agora é +${currentLevel + 1}!`, 'success');
        } else {
            addMessage(`Falhou! A Joia da Alma quebrou e ${itemToUpgrade.name} voltou para +0.`, 'error');
        }
        setDraggedItem(null);
        setDragPreviewStyle(null);
    } else {
        addMessage("Não foi possível encontrar o item para melhorar.", 'error');
    }
    setIsUpgradingWithSoul(false); // Desativa o modo de upgrade
};

     const handleItemRightClick = (e, item) => {
        e.preventDefault();
        if (isUpgrading) {
            setIsUpgrading(false);
            addMessage("Modo de melhoria (Benção) cancelado.", 'info');
            return;
        }
        if (isUpgradingWithSoul) {
            setIsUpgradingWithSoul(false);
            addMessage("Modo de melhoria (Alma) cancelado.", 'info');
            return;
        }
        if (!item.quantity && !item.isConsumable) {
            equipItem(item);
        }
    };
const handleMoveFromChest = (e, itemToMove) => {
    e.preventDefault();
    const stackableTypes = ['Blessing', 'Soul', 'Potion', 'ManaPotion', 'StaminaPotion'];

    if (stackableTypes.includes(itemToMove.type)) {
        let inventoryHasStack = false;
        const newInventory = characterData.inventory.map(item => {
            if (item.type === itemToMove.type) {
                inventoryHasStack = true;
                return { ...item, quantity: (item.quantity || 1) + (itemToMove.quantity || 1) };
            }
            return item;
        });

        if (inventoryHasStack) {
            const newChest = (characterData.chest || []).filter(i => i.id !== itemToMove.id);
            const newData = { ...characterData, inventory: newInventory, chest: newChest };
            setCharacterData(newData);
            saveData(newData);
            addMessage(`${itemToMove.name} foi adicionado ao monte no inventário.`, 'success');
        } else {
            if (characterData.inventory.length >= INVENTORY_LIMIT) {
                addMessage("Inventário cheio! Não é possível retirar o item do baú.", 'error');
                return;
            }
            const finalInventory = [...characterData.inventory, itemToMove];
            const newChest = (characterData.chest || []).filter(i => i.id !== itemToMove.id);
            const newData = { ...characterData, inventory: finalInventory, chest: newChest };
            setCharacterData(newData);
            saveData(newData);
            addMessage(`${itemToMove.name} foi movido para o inventário.`, 'success');
        }
    } else {
        // Lógica original para itens não empilháveis
        if (characterData.inventory.length >= INVENTORY_LIMIT) {
            addMessage("Inventário cheio! Não é possível retirar o item do baú.", 'error');
            return;
        }
        const newInventory = [...characterData.inventory, itemToMove];
        const newChest = (characterData.chest || []).filter(i => i.id !== itemToMove.id);
        const newData = { ...characterData, inventory: newInventory, chest: newChest };
        setCharacterData(newData);
        saveData(newData);
        addMessage(`${itemToMove.name} foi movido para o inventário.`, 'success');
    }
    setDraggedItem(null);
    setDragPreviewStyle(null);
};
    

const handleSellAllMouseEnter = (e) => {
    const itemsToSell = characterData.inventory.filter(item => !item.quantity);
    const totalValue = itemsToSell.reduce((sum, item) => sum + calculateSellPrice(item), 0);
    const content = (
        <div>
            <p className="font-bold">Valor total da venda:</p>
            <p className="text-yellow-400">{formatGold(totalValue)} ouro</p>
        </div>
    );
    showTooltip(content, e);
};

const handleSellAllFromChestMouseEnter = (e) => {
    const itemsToSell = (characterData.chest || []).filter(item => !item.quantity);
    const totalValue = itemsToSell.reduce((sum, item) => sum + calculateSellPrice(item), 0);
    const content = (
        <div>
            <p className="font-bold">Valor total da venda (Baú):</p>
            <p className="text-yellow-400">{formatGold(totalValue)} ouro</p>
        </div>
    );
    showTooltip(content, e);
};

	const handleSellAllClick = () => {
    const itemsToSell = characterData.inventory.filter(item => !item.quantity);
    if (itemsToSell.length === 0) {
        addMessage("Nenhum item para vender no inventário.", 'info');
        return;
    }
    const totalValue = itemsToSell.reduce((sum, item) => sum + calculateSellPrice(item), 0);
    openConfirmationModal({
        title: 'Vender Todos os Itens',
        message: `Atenção: Você deseja vender todos os ${itemsToSell.length} itens do inventário por ${formatGold(totalValue)} ouro?`,
        onConfirm: () => {
            const remainingItems = characterData.inventory.filter(item => !!item.quantity);
            const newData = { ...characterData, inventory: remainingItems, gold: (characterData.gold || 0) + totalValue };
            setCharacterData(newData);
            saveData(newData);
            addMessage(`Você vendeu ${itemsToSell.length} itens por um total de ${formatGold(totalValue)} de ouro.`, 'success');
        }
    });
}; // <-- A CHAVE E PONTO E VÍRGULA ESTAVAM FALTANDO AQUI


    const handleSellAllFromChestClick = () => { const itemsToSell = (characterData.chest || []).filter(item => !item.quantity); if (itemsToSell.length === 0) { addMessage("Nenhum item para vender no baú.", 'info'); return; } const totalValue = itemsToSell.reduce((sum, item) => sum + calculateSellPrice(item), 0); openConfirmationModal({
    title: 'Vender Itens do Baú',
    message: `Atenção: Você deseja vender todos os ${itemsToSell.length} itens do baú por ${formatGold(totalValue)} ouro?`,
    onConfirm: () => {
        const newChest = (characterData.chest || []).filter(item => !!item.quantity);
        const newData = { ...characterData, chest: newChest, gold: (characterData.gold || 0) + totalValue, };
        setCharacterData(newData);
        saveData(newData);
        addMessage(`Você vendeu ${itemsToSell.length} itens do baú por um total de ${formatGold(totalValue)} de ouro.`, 'success');
        }
    });
};

    const equipmentOrder = useMemo(() => {
        let leftHandIcon = <SwordIcon />;
        const rightHandIcon = <ShieldIcon />; 
        if (characterData.class === 'Mago') {
            leftHandIcon = <StaffIcon />;
        } else if (characterData.class === 'Elfo') {
            leftHandIcon = <BowIcon />;
        }
        return {
            Pet: { name: 'Montaria', icon: <PetIcon /> },
            Helmet: { name: 'Elmo', icon: <HelmetIcon /> },
            Wing: { name: 'Asa', icon: <WingIcon /> },
            leftHand: { name: 'Mão Dir.', icon: leftHandIcon },
            Armor: { name: 'Armadura', icon: <ArmorIcon /> },
            rightHand: { name: 'Mão Esq.', icon: rightHandIcon },
            Gloves: { name: 'Luvas', icon: <GlovesIcon /> },
            Pants: { name: 'Calças', icon: <PantsIcon /> },
            Boots: { name: 'Botas', icon: <BootsIcon /> },
        };
    }, [characterData.class]);

    if (!characterData) { return <div className="min-h-screen bg-stone-900 text-white flex items-center justify-center">Carregando personagem...</div>; }
    const lifePotionForShop = { id: 'life_potion_shop', name: 'Poção de Vida', price: calculateLifePotionCost(characterData.level), description: 'Recupera 15 de HP.', qualityColor: 'border-l-red-500', isConsumable: true, consumableType: 'Potion' };
    const manaPotionForShop = { id: 'mana_potion_shop', name: 'Poção de Mana', price: calculateManaPotionCost(characterData.level), description: 'Recupera 20 de Mana.', qualityColor: 'border-l-blue-500', isConsumable: true, consumableType: 'ManaPotion' };
    const staminaPotionForShop = { id: 'stamina_potion_shop', name: 'Poção de Stamina', price: calculateStaminaPotionCost(characterData.level), description: 'Recupera 20 de stamina.', qualityColor: 'border-l-yellow-500', isConsumable: true, consumableType: 'StaminaPotion' };
    const shopConsumables = [staminaPotionForShop, lifePotionForShop, manaPotionForShop];
    const shopEquipables = (characterData.shopItems || []).filter(item => !item.isConsumable);


const handleKeyPress = (e) => {
  // 1. Verifica se a tecla pressionada foi 'Enter' E se a tecla 'Shift' NÃO estava pressionada
  if (e.key === 'Enter' && !e.shiftKey) {
    // 2. Impede o comportamento padrão (que é criar uma nova linha)
    e.preventDefault(); 
    // 3. Chama a sua função de enviar a mensagem
    handleSendMessage(e); 
  }
  // Se for "Shift + Enter", a função não faz nada e o textarea cria uma nova linha normalmente.
};


return (
    <>
        {/* Renderiza a tela de batalha aqui APENAS se NÃO estiver em tela cheia */}
        {!isFullScreen && 
            <BattleScreen
                battleState={battleState}
                characterData={characterData}
                derivedStats={derivedStats}
                onAttack={handlePlayerAttack}
                onEndBattle={handleEndBattle}
                onUsePotion={handleUsePotionInBattle}
                onUseSkill={handleUseSkill}
            />
        }

        <div className="p-0 md:p-0 select-none relative h-full">
        <CraftingModal 
            isOpen={isCraftingModalOpen} 
            onClose={() => setCraftingModalOpen(false)}
            characterData={characterData}
            addMessage={addMessage}
            saveData={saveData}
            setCharacterData={setCharacterData}
            showTooltip={showTooltip} 
            hideTooltip={hideTooltip}  
        />

	{/* Renderiza o modal de skills aqui APENAS se NÃO estiver em tela cheia */}
        {!isFullScreen &&
            <SkillsModal 
                isOpen={isSkillsModalOpen}
                onClose={() => setSkillsModalOpen(false)}
                characterData={characterData}
            />
        }


        {draggedItem && dragPreviewStyle && ( <div className="fixed z-50 p-2 bg-stone-700 rounded-md flex flex-col items-center justify-center pointer-events-none opacity-70" style={{ left: dragPreviewStyle.left - 25, top: dragPreviewStyle.top - 25, width: '50px', height: '50px', transform: 'translate(-50%, -50%)' }}> {(() => { let icon = null; if (draggedItem.item.type === 'Potion') icon = <PotionIcon />; else if (draggedItem.item.type === 'ManaPotion') icon = <ManaPotionIcon />; else if (draggedItem.item.type === 'Blessing') icon = <JewelIcon />; else if (draggedItem.item.type === 'Soul') icon = <SoulJewelIcon />; else if (draggedItem.item.type === 'StaminaPotion') icon = <StaminaPotionIcon />; else if (draggedItem.item.recipeId) icon = <RecipeIcon />; else if (draggedItem.item.skillId) icon = <ScrollIcon />; else if (ITEM_TYPES[draggedItem.item.type]) icon = ITEM_TYPES[draggedItem.item.type].icon; return icon; })()} </div> )}


        
        <main className="grid grid-cols-1 lg:grid-cols-4 gap-4 p-4">
            {/* Coluna Esquerda - Personagem e Stats */}
            <div className="lg:col-span-1 mu-panel p-4 flex flex-col">
    <CharacterPanel
        characterData={characterData}
        derivedStats={derivedStats}
        characterImageSrc={characterImageSrc}
        remainingSkillPoints={remainingSkillPoints}
        pendingStats={pendingStats}
        totalPendingPoints={totalPendingPoints}
        handleDecreasePendingStat={handleDecreasePendingStat}
        handleIncreasePendingStat={handleIncreasePendingStat}
        handleConfirmStats={handleConfirmStats}
        handleCancelStats={handleCancelStats}
        setSkillsModalOpen={setSkillsModalOpen}
    />
</div>
      
            {/* Coluna Central - Mapa e Chat */}
<div 
    ref={mapContainerRef}
    className={`lg:col-span-2 mu-panel p-4 flex flex-col self-start lg:sticky lg:top-4 ${isFullScreen ? 'fullscreen-map-container' : ''}`} 
    style={!isFullScreen ? {height: 'calc(100vh - 2rem)'} : {}}
    onClick={handleMapClick}
>
    {/* ADICIONE O BLOCO ABAIXO */}
    {isFullScreen && <Tooltip content={tooltip.content} position={tooltip.position} />}
    {/* FIM DO BLOCO ADICIONADO */}


{/* COLE O BLOCO ABAIXO PARA RESTAURAR A BARRA DE MAPAS NO CENTRO */}
{/* --- INÍCIO DA BARRA DE MAPAS CENTRALIZADA --- */}
{isFullScreen && (
    <div className="absolute top-2 left-1/2 -translate-x-1/2 z-40 flex gap-1 bg-stone-900/50 p-1 rounded-lg border border-stone-600">
        {Object.keys(MAPS).map(mapId => {
            const map = MAPS[mapId];
            const isLocked = characterData.level < map.minLevel;
            return (
                <div
                    key={mapId}
                    onMouseEnter={(e) => isLocked && showTooltip(<div><p>Requer Nível {map.minLevel}</p></div>, e)}
                    onMouseLeave={hideTooltip}
                    className="flex-1"
                >
                    <button
                        disabled={isLocked}
                        onClick={() => !isLocked && setActiveMap(mapId)}
                        className={`py-1 px-3 text-center font-bold flex items-center justify-center rounded-md transition-colors ${activeMap === mapId && !isLocked ? 'bg-yellow-700/80 text-white' : 'text-stone-300 hover:bg-stone-700/50'} ${isLocked ? 'text-stone-500 cursor-not-allowed' : ''}`}
                    >
                        {map.name} {isLocked && <LockIcon />}
                    </button>
                </div>
            );
        })}
    </div>
)}
{/* --- FIM DA BARRA DE MAPAS --- */}
{/* FIM DO BLOCO A SER COLADO */}


{isFullScreen &&
    <ConfirmationModal modalState={confirmationModal} setModalState={setConfirmationModal} />
}

{isFullScreen &&
    <BattleScreen
        battleState={battleState}
        characterData={characterData}
        derivedStats={derivedStats}
        onAttack={handlePlayerAttack}
        onEndBattle={handleEndBattle}
        onUsePotion={handleUsePotionInBattle}
        onUseSkill={handleUseSkill}
    />
}

{isFullScreen &&
    <SkillsModal 
        isOpen={isSkillsModalOpen}
        onClose={() => setSkillsModalOpen(false)}
        characterData={characterData}
    />
}


{/* COLE O NOVO BLOCO DE CÓDIGO AQUI */}
{isFullScreen &&
    <NotificationContainer notifications={notifications} onRemove={onRemove} />
}
{/* FIM DO BLOCO ADICIONADO */}




{/* --- INÍCIO DA NOVA JANELA FLUTUANTE DE PERSONAGEM --- */}
{isFullScreen && isFullScreenCharacterOpen && (
    <div className="absolute top-12 left-4 z-[70] w-[380px] h-auto max-h-[calc(100vh-4rem)]">
        <div className="mu-panel p-4 flex flex-col h-full">
            <div className="flex justify-between items-center mb-2 pb-2 border-b-2 border-stone-700">
                <h2 className="text-xl font-bold mu-title">Personagem</h2>
                <button onClick={() => setFullScreenCharacterOpen(false)} className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold">&times;</button>
            </div>
            <div className="overflow-y-auto flex-grow pr-2">
                <CharacterPanel
                    characterData={characterData}
                    derivedStats={derivedStats}
                    characterImageSrc={characterImageSrc}
                    remainingSkillPoints={remainingSkillPoints}
                    pendingStats={pendingStats}
                    totalPendingPoints={totalPendingPoints}
                    handleDecreasePendingStat={handleDecreasePendingStat}
                    handleIncreasePendingStat={handleIncreasePendingStat}
                    handleConfirmStats={handleConfirmStats}
                    handleCancelStats={handleCancelStats}
                    setSkillsModalOpen={setSkillsModalOpen}
                />
            </div>
        </div>
    </div>
)}
{/* --- FIM DA NOVA JANELA FLUTUANTE DE PERSONAGEM --- */}



{/* --- INÍCIO DA NOVA JANELA FLUTUANTE DE MENU --- */}
{isFullScreen && isFullScreenMarketOpen && (
    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[70] w-[95vw] h-[90vh] max-w-[1200px]">
        <div className="mu-panel p-4 flex flex-col h-full relative"> {/* Adicionado 'relative' */}
            <div className="flex justify-between items-center mb-2 pb-2 border-b-2 border-stone-700 flex-shrink-0">
                <h2 className="text-xl font-bold mu-title">Menu</h2>
                <button onClick={() => setFullScreenMarketOpen(false)} className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold">&times;</button>
            </div>
            
            {/* Tela de Carregamento (Paywall) */}
            {isIframeLoading && (
                <div className="absolute inset-0 bg-stone-900 flex items-center justify-center z-10">
                    <p className="text-2xl text-white animate-pulse">Carregando Menu...</p>
                </div>
            )}

            {/* O Iframe carrega invisível e só aparece quando está pronto */}
            <iframe
                src="/mercado?context=modal"
                title="Menu"
                className={`w-full h-full border-0 bg-transparent transition-opacity duration-300 ${isIframeLoading ? 'opacity-0' : 'opacity-100'}`}
            ></iframe>
        </div>
    </div>
)}
{/* --- FIM DA NOVA JANELA FLUTUANTE DE MENU --- */}



        {/* --- INÍCIO DA NOVA JANELA FLUTUANTE --- */}
{isFullScreen && isFullScreenInventoryOpen && (
    <div className="absolute top-12 right-4 z-[70] w-[380px] h-auto max-h-[calc(100vh-4rem)]">
        <div className="mu-panel p-4 flex flex-col h-full">
            <div className="flex justify-between items-center mb-2 pb-2 border-b-2 border-stone-700">
                <h2 className="text-xl font-bold mu-title">Equipamentos</h2>
                <button onClick={() => setFullScreenInventoryOpen(false)} className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold">&times;</button>
            </div>

            {/* Abas para a janela flutuante */}
            <div className="flex border-b border-stone-700 mb-4 flex-shrink-0">
                <button onClick={() => setFullScreenTab('inventory')} className={`mu-tab-button flex-1 ${fullScreenTab === 'inventory' ? 'mu-tab-button-active' : ''}`}>Inventário</button>
                <button onClick={() => setFullScreenTab('chest')} className={`mu-tab-button flex-1 ${fullScreenTab === 'chest' ? 'mu-tab-button-active' : ''}`}>Baú</button>
            </div>

            {/* Conteúdo condicional baseado na aba */}
            <div className="overflow-y-auto flex-grow">
                {fullScreenTab === 'inventory' && (
                    <InventoryPanel
                        characterData={characterData} derivedStats={derivedStats} equipmentOrder={equipmentOrder} handleDrop={handleDrop} handleDropOnEquipment={handleDropOnEquipment}
                        handleDragOver={handleDragOver} handleDragLeave={handleDragLeave} unequipItem={unequipItem} handleDragStart={handleDragStart} handleDragEnd={handleDragEnd}
                        isUpgrading={isUpgrading} isUpgradingWithSoul={isUpgradingWithSoul} upgradeItem={upgradeItem} upgradeItemWithSoul={upgradeItemWithSoul} handleItemMouseEnter={handleItemMouseEnter}
                        hideTooltip={hideTooltip} hoveredDropZone={hoveredDropZone} inventoryWithConsumables={inventoryWithConsumables} handleItemClick={handleItemClick} handleItemRightClick={handleItemRightClick}
                        draggedItem={draggedItem} handleDropOnItem={handleDropOnItem} handleSellAllClick={handleSellAllClick} handleSellAllMouseEnter={handleSellAllMouseEnter}
                        handleTouchStart={handleTouchStart}
                    />
                )}
                {fullScreenTab === 'chest' && (
                    <ChestPanel
                        characterData={characterData} handleMoveFromChest={handleMoveFromChest} handleItemMouseEnter={handleItemMouseEnter} hideTooltip={hideTooltip}
                        handleDragStart={handleDragStart} handleDragEnd={handleDragEnd} draggedItem={draggedItem} handleDropOnItem={handleDropOnItem}
                        handleDrop={handleDrop} handleDragOver={handleDragOver} handleDragLeave={handleDragLeave} hoveredDropZone={hoveredDropZone}
                        handleSellAllFromChestClick={handleSellAllFromChestClick} handleSellAllFromChestMouseEnter={handleSellAllFromChestMouseEnter} handleTouchStart={handleTouchStart}
                    />
                )}
            </div>
        </div>
    </div>
)}
        {/* --- FIM DA NOVA JANELA FLUTUANTE --- */}



{isFullScreen && (
    <>
{/* CONTAINER DOS BOTÕES DO CANTO ESQUERDO */}
        <div className="absolute top-2 left-2 z-40 flex items-center gap-2">

            {/* 2. NOVO Botão Mercado */}
            <button
                className="h-8 px-3 bg-green-800/80 hover:bg-green-700/80 text-white flex items-center justify-center rounded-md cursor-pointer transition-colors duration-200 border border-green-400 font-bold"
                onClick={() => setFullScreenMarketOpen(prev => !prev)}
                title="Abrir/Fechar Menu"
            >
                Menu
            </button>

            {/* 1. Botão Personagem */}
            <button
                className="h-8 px-3 bg-blue-800/80 hover:bg-blue-700/80 text-white flex items-center justify-center rounded-md cursor-pointer transition-colors duration-200 border border-blue-400 font-bold"
                onClick={() => setFullScreenCharacterOpen(prev => !prev)}
                title="Abrir/Fechar Painel do Personagem"
            >
                Personagem
            </button>

        </div>
        
        {/* BOTÕES DO CANTO DIREITO (MANTIDOS COMO ESTAVAM) */}
        <div
            className="absolute top-2 right-2 z-40 w-8 h-8 bg-blue-800/80 hover:bg-blue-700/80 text-white flex items-center justify-center rounded-md cursor-pointer transition-colors duration-200 border border-blue-400"
            onClick={handleRefreshMonsters}
            onMouseEnter={(e) => showTooltip(<div><p>Atualizar monstros</p><p>(custa 1 de Stamina)</p></div>, e)}
            onMouseLeave={hideTooltip}
            title="Atualizar Monstros"
        >
            <RefreshIcon />
        </div>
        <button
            className="absolute top-2 right-12 z-40 h-8 px-3 bg-yellow-800/80 hover:bg-yellow-700/80 text-white flex items-center justify-center rounded-md cursor-pointer transition-colors duration-200 border border-yellow-400 font-bold"
            onClick={() => setFullScreenInventoryOpen(prev => !prev)}
            title="Abrir/Fechar Inventário"
        >
            Equipamentos
        </button>
    </>
)}
    {!isFullScreen && (
        <div className="flex border-b border-stone-700 mb-4">
            {Object.keys(MAPS).map(mapId => {
                const map = MAPS[mapId];
                const isLocked = characterData.level < map.minLevel;
                return (
                    <div
                        key={mapId}
                        onMouseEnter={(e) => !isFullScreen && isLocked && showTooltip(<div><p>Requer Nível {map.minLevel}</p></div>, e)}
                        onTouchStart={(e) => isLocked && showTooltip(<div><p>Requer Nível {map.minLevel}</p></div>, e)}
                        onMouseLeave={hideTooltip}
                        onTouchEnd={hideTooltip}
                        className="flex-1"
                    >
                        <button
                            disabled={isLocked}
                            onClick={() => !isLocked && setActiveMap(mapId)}
                            className={`w-full py-2 text-center font-bold flex items-center justify-center mu-tab-button ${activeMap === mapId && !isLocked ? 'mu-tab-button-active' : ''} ${isLocked ? 'text-stone-500 cursor-not-allowed' : ''}`}
                        >
                            {map.name} {isLocked && <LockIcon />}
                        </button>
                    </div>
                );
            })}
        </div> // <-- CORREÇÃO: O </div> foi movido para cá
    )} 


<div 
    className={`relative border border-stone-600 transform-gpu z-10 ${isFullScreen ? 'map-image-container' : 'h-[62%]'}`} 
    onClick={hideTooltip}
>
        {/* A imagem de fundo agora é nítida, sem blur */}
        <div
            key={activeMap}
            className="absolute inset-0 bg-cover bg-center transition-all duration-500"
            style={{ backgroundImage: `url(${MAPS[activeMap]?.backgroundImage})` }}
        ></div>
        
        {/* Camada de sobreposição escura para legibilidade */}
        <div className="absolute inset-0 bg-black bg-opacity-0"></div>

        {/* --- NOVO LOCAL DO BOTÃO DE ATUALIZAÇÃO --- */}
        {/* Ele só aparece se NÃO estiver em tela cheia */}
        {!isFullScreen && (
            <div
                className="absolute top-2 right-2 z-40 w-8 h-8 bg-blue-800/80 hover:bg-blue-700/80 text-white flex items-center justify-center rounded-full cursor-pointer transition-colors duration-200 border border-blue-400"
                onClick={handleRefreshMonsters}
                onMouseEnter={(e) => !isFullScreen && showTooltip(<div><p>Atualizar monstros</p><p>(custa 1 de Stamina)</p></div>, e)}
                onMouseLeave={hideTooltip}
                title="Atualizar Monstros"
            >
                <RefreshIcon />
            </div>
        )}

        
<div className="relative h-full w-full">
    {(characterData.mapState?.[activeMap] || []).map(monster => (
        <MonsterPin
            key={monster.id}
            monster={monster}
            selectedMonster={selectedMonster}
            onMonsterClick={handleMonsterClick}
            mapContainerRef={mapContainerRef}
            handleStartBattle={handleStartBattle}
            setSelectedMonster={setSelectedMonster}
	    isFullScreen={isFullScreen}
        />
    ))}
</div>

        {/* --- NOVO BOTÃO DE TELA CHEIA --- */}
        <button onClick={toggleFullScreen} className="map-fullscreen-button" title={isFullScreen ? "Sair da Tela Cheia" : "Entrar em Tela Cheia"}>
            {isFullScreen ? (
                // Ícone "Sair da Tela Cheia" (Compress)
                <svg className="map-fullscreen-icon" viewBox="0 0 24 24">
                    <path d="M4 14h5v5M20 10h-5V5M14 4h5v5M10 20H5v-5"></path>
                </svg>
            ) : (
                // Ícone "Entrar em Tela Cheia" (Expand)
                <svg className="map-fullscreen-icon" viewBox="0 0 24 24">
                    <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
                </svg>
            )}
        </button>
    </div>
    {!isFullScreen && (
<div className="mt-4 h-[38%] flex flex-col min-h-0">
        <h3 className="text-xl font-bold text-stone-300 mb-2 flex-shrink-0 mu-title">Chat / Registro de Eventos</h3>
        <div ref={eventLogRef} className="bg-stone-900/80 p-2 rounded-md overflow-y-auto text-sm flex-grow border border-stone-700 h-[2rem]">
            {combinedLog.map((msg, index) => {
                const timestamp = msg.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

                // Se a mensagem for de um jogador no chat
                if (msg.type === 'chat') {
                    return (
                        <p key={index} className="break-words">
                            <span className="text-stone-400">[{timestamp}] </span>
                            <span className="text-cyan-400 font-bold">{msg.characterName}</span>
                            <span className="text-white">: {msg.message}</span>
                        </p>
                    );
                }
                
                // Lógica original para as mensagens de eventos do jogo
                else {
                    const messageText = `[${timestamp}] ${msg.text}`;
                    let textColor = msg.color || '';
                    if (!textColor) {
                        if (msg.text.includes('Joia') || msg.text.includes('aprendeu')) textColor = 'text-yellow-400';
                        else if (msg.text.includes('te acertou') || msg.text.includes('insuficiente') || msg.text.includes('esgotada') || msg.text.includes('cancelado') || msg.text.includes('cheio')) textColor = 'text-red-400';
                        else if (msg.text.includes('derrotou') || msg.text.includes('deixou cair') || msg.text.includes('vendeu') || msg.text.includes('usou') || msg.text.includes('desbloqueado') || msg.text.includes('melhoria ativado') || msg.text.includes('recuperou') || msg.text.includes('alcançou')) textColor = 'text-green-400';
                    }
                    return <p key={index} className={textColor}>{messageText}</p>;
                }
            })}
        </div>
        <div className="mt-2 flex-shrink-0">
            {characterData.level < CHAT_MIN_LEVEL ? (
                <div className="p-3 text-center text-red-400 border border-red-500 bg-red-900/50 rounded-md">
                    Alcance o nível {CHAT_MIN_LEVEL} para usar o chat.
                </div>
            ) : (
                 <form onSubmit={handleSendMessage} className="relative">
                    <textarea
                        value={chatInput}
                        onChange={(e) => setChatInput(e.target.value)}
                        placeholder="Digite sua mensagem aqui..."
                        maxLength="200"
                        className="mu-input w-full p-2 pr-20 text-sm resize-none"
                        rows="2"
                        onKeyDown={handleKeyPress}
                    />
                    <button
                        type="submit"
                        className="absolute right-2 top-1/2 -translate-y-1/2 mu-button-small"
                    >
                        Enviar
                    </button>
                </form>
            )}
        </div>
    </div>
    )}
            </div>

            {/* Coluna Direita - Inventário, Baú e Loja */}
            <div className="lg:col-span-1 mu-panel p-4 flex flex-col">
                 <div className="flex border-b border-stone-700 mb-4 flex-shrink-0">
                    <button onClick={() => setActiveTab('inventory')} className={`mu-tab-button flex-1 ${activeTab === 'inventory' ? 'mu-tab-button-active' : ''}`}>Inventário</button>
                    <button onClick={() => setActiveTab('chest')} className={`mu-tab-button flex-1 ${activeTab === 'chest' ? 'mu-tab-button-active' : ''}`}>Baú</button>


                    <button
                        onClick={() => { setActiveTab('shop'); setShopJustUpdated(false); }}
                        className={`mu-tab-button flex-1 relative ${activeTab === 'shop' ? 'mu-tab-button-active' : ''} ${shopJustUpdated ? 'animated-border' : ''}`}
                    >
                        Loja
                    </button>
                    <button onClick={() => setActiveTab('craft')} className={`mu-tab-button flex-1 ${activeTab === 'craft' ? 'mu-tab-button-active' : ''}`}>Oficina</button>
                 </div>
                <div className={`flex-grow overflow-y-auto ${isUpgrading || isUpgradingWithSoul ? 'cursor-crosshair' : ''}`}>
{activeTab === 'inventory' && (
    <>
        <InventoryPanel
            characterData={characterData}
            derivedStats={derivedStats}
            equipmentOrder={equipmentOrder}
            handleDrop={handleDrop}
            handleDropOnEquipment={handleDropOnEquipment}
            handleDragOver={handleDragOver}
            handleDragLeave={handleDragLeave}
            unequipItem={unequipItem}
            handleDragStart={handleDragStart}
            handleDragEnd={handleDragEnd}
            isUpgrading={isUpgrading}
            isUpgradingWithSoul={isUpgradingWithSoul}
            upgradeItem={upgradeItem}
            upgradeItemWithSoul={upgradeItemWithSoul}
            handleItemMouseEnter={handleItemMouseEnter}
            hideTooltip={hideTooltip}
            hoveredDropZone={hoveredDropZone}
            inventoryWithConsumables={inventoryWithConsumables}
            handleItemClick={handleItemClick}
            handleItemRightClick={handleItemRightClick}
            draggedItem={draggedItem}
            handleDropOnItem={handleDropOnItem}
            handleSellAllClick={handleSellAllClick}
            handleSellAllMouseEnter={handleSellAllMouseEnter}
            handleTouchStart={handleTouchStart} // <-- ADICIONE ESTA LINHA

        />
    </>
)}
		 
		{activeTab === 'chest' && (
    <ChestPanel
        characterData={characterData} handleMoveFromChest={handleMoveFromChest} handleItemMouseEnter={handleItemMouseEnter} hideTooltip={hideTooltip}
        handleDragStart={handleDragStart} handleDragEnd={handleDragEnd} draggedItem={draggedItem} handleDropOnItem={handleDropOnItem}
        handleDrop={handleDrop} handleDragOver={handleDragOver} handleDragLeave={handleDragLeave} hoveredDropZone={hoveredDropZone}
        handleSellAllFromChestClick={handleSellAllFromChestClick} handleSellAllFromChestMouseEnter={handleSellAllFromChestMouseEnter} handleTouchStart={handleTouchStart}
    />
)}

{activeTab === 'craft' && (
                    <div className="text-center p-4">
                        <h3 className="text-lg font-bold mb-2 text-stone-300 mu-title">Oficina de Criação</h3>
                        <p className="text-xs text-stone-400 mb-6">Combine receitas e materiais para criar itens poderosos. Clique no botão abaixo para começar.</p>
                        <img src="/images/npc/01.png" alt="Oficina" className="mx-auto my-8 w-64 opacity-90" />
        <button 
            onClick={() => {
                if (characterData?.currentInvasion) {
                    addMessage("Você não pode abrir a oficina durante uma invasão.", "error");
                    return;
                }
                // Adicione a chamada para salvar os dados aqui
                saveData(characterData); 
                setCraftingModalOpen(true);
            }} 
            className="mu-button w-full"
        >
            Abrir Oficina
        </button>
    </div>
)}


                {/* --- SEÇÃO DA LOJA ATUALIZADA --- */}
                {activeTab === 'shop' && (
                    <div className="space-y-4">
                        <div className="md:hidden text-center text-lg mb-4 p-2 bg-stone-900/50 rounded-md">
                            <p className="flex items-center justify-center gap-2"><CoinIcon /> Seu Ouro: {formatGold(characterData.gold)}</p>
                        </div>
                        
                        <h3 className="text-xl font-bold mb-2 text-stone-300 mu-title border-b border-stone-700 pb-1 h-10">Itens Consumíveis</h3>
                        <div className="space-y-2">
                            {shopConsumables.map(item => (
                                <div key={item.id} className={`bg-stone-900/50 p-3 rounded-md flex items-center justify-between border-l-4 ${item.qualityColor ? item.qualityColor.replace('border-', 'border-l-') : ''}`}>
                                    <div className="flex items-center gap-4">
                                        {/* --- ÍCONE ADICIONADO --- */}
                                        <div className="w-10 h-14 flex-shrink-0">
                                            {item.consumableType === 'Potion' && <PotionIcon />}
                                            {item.consumableType === 'ManaPotion' && <ManaPotionIcon />}
                                            {item.consumableType === 'StaminaPotion' && <StaminaPotionIcon />}
                                        </div>
                                        <div>
                                            <p className="font-bold">{item.name}</p>
                                            <p className="text-sm text-stone-400">{item.description}</p>
                                        </div>
                                    </div>
                                    <button onClick={(e) => {
                                        if (item.consumableType === 'StaminaPotion') buyStaminaPotion(e);
                                        else if (item.consumableType === 'Potion') buyLifePotion(e);
                                        else if (item.consumableType === 'ManaPotion') buyManaPotion(e);
                                    }} className="mu-button-small bg-green-800/80">
                                        <CoinIcon /> {item.price}
                                    </button>
                                </div>
                            ))}
                        </div>

                        <h3 className="text-xl font-bold mt-6 mb-2 text-stone-300 mu-title border-b border-stone-700 pb-1">Itens Equipáveis</h3>
                        <div className="space-y-2">
                            {shopEquipables.map(item => (
                                <div key={item.id} className={`bg-stone-900/50 p-3 rounded-md flex items-center justify-between border-l-4 ${item.qualityColor ? item.qualityColor.replace('border-', 'border-l-') : ''} ${item.quality === 'Lendário' ? 'animated-border-left' : ''}`}>
                                    <div className="flex items-center gap-4">
                                         {/* --- ÍCONE ADICIONADO --- */}
                                        <div className="w-10 h-10 flex-shrink-0">
                                            {ITEM_TYPES[item.type]?.icon || <SwordIcon />}
                                        </div>
                                        <div>
                                            <p className="font-bold">{item.name}</p>
                                            <p className="text-sm text-stone-400">Ataque: {item.stats?.attack || 0} / Defesa: {item.stats?.defense || 0}</p>
                                        </div>
                                    </div>
                                    <button onClick={(e) => buyItem(e, item)} className="mu-button-small bg-green-800/80">
                                        <CoinIcon /> {item.price}
                                    </button>
                                </div>
                            ))}
                        </div>
                        
                        {shopCountdown && (
                            <p className="text-center text-sm text-stone-400 mt-4"> A loja será atualizada em {shopCountdown} </p>
                        )}
                    </div>
                )}
                </div> 

            </div>

        </main>
    </div>
    </>
 ); };


const MarketPage = ({ characterData, userId, setCharacterData, addMessage, createFloatingText, isMapFullScreen }) => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCreateModalOpen, setCreateModalOpen] = useState(false);
    const [tooltip, setTooltip] = useState({ visible: false, content: null, position: { x: 0, y: 0 } });
    const [isReclaiming, setIsReclaiming] = useState(false);
    const [reclaimableItemsCount, setReclaimableItemsCount] = useState(0);
    const [userListings, setUserListings] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const LISTINGS_PER_PAGE = 20;

const STACKABLE_ICONS = {
    Blessing: <JewelIcon />,
    Soul: <SoulJewelIcon />,
};
    const showTooltip = useCallback((content, e) => {
        setTooltip({ visible: true, content, position: { x: e.clientX, y: e.clientY } });
    }, []);

    const hideTooltip = useCallback(() => {
        setTooltip({ visible: false, content: null, position: { x: 0, y: 0 } });
    }, []);

    const handleItemMouseEnter = (item) => (e) => {
        const qualityTextColor = { 'Comum': 'text-white', 'Raro': 'text-blue-400', 'Épico': 'text-purple-400', 'Lendário': 'text-yellow-400' };
        const finalStats = getUpgradedStats(item);
        const displayName = item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '');
        const itemTypeDetails = ITEM_TYPES[item.type];
        const content = (
            <div>
                <p className={`font-bold ${qualityTextColor[item.quality] || 'text-white'}`}>{displayName}</p>
                {itemTypeDetails?.class && <p className="text-yellow-300">Classe: {itemTypeDetails.class}</p>}
                {item.level && <p className="text-stone-400">Nível: {item.level}</p>}
                {finalStats.attack > 0 && <p className="text-green-400">Ataque: +{finalStats.attack}</p>}
                {finalStats.defense > 0 && <p className="text-blue-400">Defesa: +{finalStats.defense}</p>}
                {item.options && item.options.length > 0 && (
                    <div className="mt-2 pt-2 border-t border-stone-500">
                        {item.options.map((opt, index) => (
                            <p key={index} className="text-cyan-300 text-xs italic">{opt.text}</p>
                        ))}
                    </div>
                )}
                 <p className="text-yellow-400 mt-2">Preço: {formatGold(item.price)} ouro</p>
            </div>
        );
        showTooltip(content, e);
    };

    // Listener para todas as listagens ativas e as do usuário
    useEffect(() => {
        const now = Timestamp.now();
        const q = query(collection(db, "market_listings"), where("expiresAt", ">", now));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const listingsData = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(l => l.items && l.items.length > 0);

            const otherUserListings = listingsData.filter(l => l.sellerId !== userId);
            const currentUserListings = listingsData.filter(l => l.sellerId === userId);
            
            setListings(otherUserListings);
            setUserListings(currentUserListings); // Armazena as lojas do usuário logado
            setLoading(false);
        }, (error) => {
            console.error("Error fetching market listings:", error);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [userId]);

    // Listener para as lojas expiradas/vendidas do usuário para o botão de resgate
useEffect(() => {
    if (!userId) return;

    // Listener para lojas que têm itens vendidos ou ouro para resgatar
    const q = query(
        collection(db, "market_listings"),
        where("sellerId", "==", userId)
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
        let itemsCount = 0;
        let hasGoldToReclaim = false;
        const now = new Date();

        snapshot.forEach(doc => {
            const listing = doc.data();
            // Verifica se a loja expirou
            if (listing.expiresAt.toDate() <= now) {
                itemsCount += listing.items?.length || 0;
            }
            // Verifica se há ouro para resgatar
            if (listing.goldToReclaim > 0) {
                hasGoldToReclaim = true;
            }
        });

        // A contagem é o número de itens + 1 se houver ouro (o ouro conta como um "item" a ser resgatado)
        setReclaimableItemsCount(itemsCount + (hasGoldToReclaim ? 1 : 0));

    }, (error) => {
        console.error("Erro ao verificar itens para resgate: ", error);
    });

    return () => unsubscribe(); // Limpa o listener ao desmontar o componente
}, [userId]);



const handleBuyItem = async (e, listingId, itemToBuy) => {
    // A verificação de inventário foi removida daqui, pois todos os itens irão para o baú.
    // A verificação de espaço do baú será feita dentro da transação.

    if (characterData.gold < itemToBuy.price) {
        addMessage("Ouro insuficiente para comprar este item.", 'error');
        return;
    }

    const rect = e.currentTarget.getBoundingClientRect();
    addMessage("Processando sua compra...", 'info');

    const listingRef = doc(db, "market_listings", listingId);
    const buyerRef = doc(db, "characters", userId);

    try {
        await runTransaction(db, async (transaction) => {
            const listingDoc = await transaction.get(listingRef);
            const buyerDoc = await transaction.get(buyerRef);

            if (!listingDoc.exists()) throw new Error("Esta loja não existe mais.");
            if (!buyerDoc.exists()) throw new Error("Comprador não encontrado.");

            const listingData = listingDoc.data();
            const buyerData = buyerDoc.data();
            
            const marketMission = buyerData.missions?.find(m => m.status === 'active' && MISSIONS[m.id]?.type === MISSION_TYPES.BUY_MARKET);
            let missionUpdates = {};
            if (marketMission) {
                const missionInfo = MISSIONS[marketMission.id];
                const newProgress = (marketMission.progress || 0) + 1;
                let newStatus = marketMission.status;

                if (newProgress >= missionInfo.objective.targetCount) {
                    newStatus = 'completed';
                }
                
                missionUpdates = {
                    missions: buyerData.missions.map(m => 
                        m.id === marketMission.id ? { ...m, progress: newProgress, status: newStatus } : m
                    )
                };
            }

            const itemIndex = listingData.items.findIndex(item => item.id === itemToBuy.id);
            if (itemIndex === -1) throw new Error("Este item não está mais à venda.");
            if (buyerData.gold < itemToBuy.price) throw new Error("Ouro insuficiente.");

            const boughtItem = listingData.items[itemIndex];

            // Prepara as atualizações para o comprador
            const buyerUpdates = { gold: buyerData.gold - boughtItem.price };
            let updatedChest = [...(buyerData.chest || [])];

            if (boughtItem.isStack) {
                // Lógica para itens empilháveis (joias)
                const existingStackIndex = updatedChest.findIndex(item => item.type === boughtItem.type);

                if (existingStackIndex > -1) {
                    updatedChest[existingStackIndex].quantity += boughtItem.quantity;
                } else {
                    if (updatedChest.length >= CHEST_SIZE) {
                        throw new Error("Seu baú está cheio para adicionar este tipo de joia.");
                    }
                    const { price, ...itemForChest } = boughtItem;
                    updatedChest.push(itemForChest);
                }
            } else {
                // --- LÓGICA ALTERADA PARA EQUIPAMENTOS ---
                // Agora, eles também vão para o baú.
                if (updatedChest.length >= CHEST_SIZE) {
                    throw new Error("Seu baú está cheio.");
                }
                const { price, ...itemForChest } = boughtItem;
                updatedChest.push(itemForChest);
            }

            // Define o baú atualizado como a alteração a ser feita
            buyerUpdates.chest = updatedChest;

            // Atualiza a listagem do vendedor
            const updatedItems = listingData.items.filter((_, index) => index !== itemIndex);
            transaction.update(listingRef, { 
                items: updatedItems,
                goldToReclaim: (listingData.goldToReclaim || 0) + boughtItem.price,
                soldItemCount: (listingData.soldItemCount || 0) + 1
            });

            // Atualiza os dados do comprador
            transaction.update(buyerRef, { ...buyerUpdates, ...missionUpdates });
        });

        createFloatingText(`-${itemToBuy.price}`, 'gold', { x: rect.left + rect.width / 2, y: rect.top - 10 });
        addMessage("Compra realizada com sucesso! Verifique seu baú.", 'success');

        const marketMission = characterData.missions?.find(m => m.status === 'active' && MISSIONS[m.id]?.type === MISSION_TYPES.BUY_MARKET);
        if(marketMission && (marketMission.progress || 0) + 1 >= MISSIONS[marketMission.id]?.objective.targetCount) {
             addMessage(`Missão Concluída: ${MISSIONS[marketMission.id].name}!`, 'success');
        }
    } catch (error) {
        console.error("Erro na transação de compra: ", error);
        addMessage(`Falha na compra: ${error.message}`, 'error');
    }
};



    
    const reclaimItemsAndGold = async () => {
        setIsReclaiming(true);
        addMessage("Resgatando itens e ouro pendentes...", 'info');

        const expiredQuery = query(
            collection(db, "market_listings"),
            where("sellerId", "==", userId),
            where("expiresAt", "<=", Timestamp.now())
        );
        const allUserListingsQuery = query(
            collection(db, "market_listings"),
            where("sellerId", "==", userId)
        );

        try {
            const { totalItemsReclaimed, totalGoldReclaimed } = await runTransaction(db, async (transaction) => {
                const userCharRef = doc(db, "characters", userId);
                const userCharDoc = await transaction.get(userCharRef);
                if (!userCharDoc.exists()) throw new Error("Seu personagem não foi encontrado.");

                let characterUpdates = { gold: userCharDoc.data().gold, chest: userCharDoc.data().chest || [] };
                let totalItemsReclaimed = 0;
                let totalGoldReclaimed = 0;

                // Processa todas as lojas do usuário para pegar ouro pendente
                const allUserListingsSnapshot = await getDocs(allUserListingsQuery);
                for (const listingDoc of allUserListingsSnapshot.docs) {
                    const listingData = listingDoc.data();
                    if (listingData.goldToReclaim > 0 || listingData.soldItemCount > 0) {
                        totalGoldReclaimed += (listingData.goldToReclaim || 0);
                        transaction.update(listingDoc.ref, { goldToReclaim: 0, soldItemCount: 0 }); // Reseta ouro e contador
                    }
                }
                characterUpdates.gold += totalGoldReclaimed;


// Processa lojas expiradas para devolver itens
const expiredSnapshot = await getDocs(expiredQuery);
for (const listingDoc of expiredSnapshot.docs) {
    const listingData = listingDoc.data();
    const itemsToReturn = listingData.items || [];
    const stackableTypes = ['Blessing', 'Soul']; // Define quais itens são empilháveis

    // Itera sobre cada item a ser devolvido
    for (const item of itemsToReturn) {
        // Verifica se o item é do tipo empilhável
        if (stackableTypes.includes(item.type)) {
            const existingStackIndex = characterUpdates.chest.findIndex(chestItem => chestItem.type === item.type);

            // Se já existe um monte dessa joia no baú...
            if (existingStackIndex > -1) {
                // ...soma a quantidade
                characterUpdates.chest[existingStackIndex].quantity += (item.quantity || 1);
            } else {
                // Se não existe, verifica se há espaço para um novo monte
                if (characterUpdates.chest.length >= CHEST_SIZE) {
                    throw new Error(`Baú cheio! Não foi possível resgatar ${item.name}.`);
                }
                // Adiciona o novo monte ao baú.
                characterUpdates.chest.push(item);
            }
        } else {
            // Para itens não empilháveis (equipamentos)
            if (characterUpdates.chest.length >= CHEST_SIZE) {
                throw new Error(`Baú cheio! Libere espaço para resgatar ${item.name}.`);
            }
            // Adiciona o item não empilhável
            characterUpdates.chest.push(item);
        }
    }

    totalItemsReclaimed += itemsToReturn.length;
    transaction.delete(listingDoc.ref); // Deleta a loja expirada
}
                
                // Aplica as atualizações no personagem
                transaction.update(userCharRef, {
                    gold: characterUpdates.gold,
                    chest: characterUpdates.chest
                });
                
                return { totalItemsReclaimed, totalGoldReclaimed };
            });
            
            if (totalItemsReclaimed > 0 && totalGoldReclaimed > 0) {
                addMessage(`Resgate completo! Itens no baú e ${formatGold(totalGoldReclaimed)} de ouro recebido.`, 'success');
            } else if (totalItemsReclaimed > 0) {
                addMessage(`Itens resgatados com sucesso! Verifique seu baú.`, 'success');
            } else if (totalGoldReclaimed > 0) {
                addMessage(`Ouro resgatado com sucesso! Você recebeu ${formatGold(totalGoldReclaimed)} de ouro.`, 'success');
            } else {
                 addMessage("Nenhum item ou ouro para resgatar.", 'info');
            }

        } catch (error) {
            console.error("Erro ao resgatar itens/ouro:", error);
            addMessage(`Falha ao resgatar: ${error.message}`, 'error');
        } finally {
            setIsReclaiming(false);
            setReclaimableItemsCount(0);
        }
    };

    const handleCancelListing = async (listingId) => {
        if (!window.confirm("Tem certeza que deseja cancelar sua loja? Seus itens serão devolvidos ao seu baú.")) {
            return;
        }
        addMessage("Cancelando sua loja...", 'info');
        const listingRef = doc(db, "market_listings", listingId);
        const userCharRef = doc(db, "characters", userId);

        try {
            await runTransaction(db, async (transaction) => {
                const listingDoc = await transaction.get(listingRef);
                const userDoc = await transaction.get(userCharRef);

                if (!listingDoc.exists() || listingDoc.data().sellerId !== userId) {
                    throw new Error("Loja não encontrada ou não pertence a você.");
                }
                if (!userDoc.exists()) {
                    throw new Error("Seu personagem não foi encontrado.");
                }

                const listingData = listingDoc.data();
                const userData = userDoc.data();
                const itemsToReturn = listingData.items || [];
const goldFromSales = listingData.goldToReclaim || 0;

// Criamos uma cópia local do baú para podermos modificá-la
let updatedChest = [...(userData.chest || [])];
const stackableTypes = ['Blessing', 'Soul']; // Itens que podem ser empilhados

// Iteramos sobre cada item que será devolvido
for (const item of itemsToReturn) {
    if (stackableTypes.includes(item.type)) {
        const existingStackIndex = updatedChest.findIndex(chestItem => chestItem.type === item.type);

        // Se um monte do mesmo tipo de joia já existe...
        if (existingStackIndex > -1) {
            // ...apenas somamos a quantidade.
            updatedChest[existingStackIndex].quantity += (item.quantity || 1);
        } else {
            // Se não existe, verificamos o espaço e adicionamos um novo monte.
            if (updatedChest.length >= CHEST_SIZE) {
                throw new Error(`Não foi possível cancelar: Baú cheio para adicionar ${item.name}.`);
            }
            updatedChest.push(item);
        }
    } else {
        // Para itens normais, não empilháveis
        if (updatedChest.length >= CHEST_SIZE) {
            throw new Error(`Não foi possível cancelar: Baú cheio para adicionar ${item.name}.`);
        }
        updatedChest.push(item);
    }
}

// Agora, atualizamos o documento do personagem com o baú modificado e o ouro
transaction.update(userCharRef, {
    chest: updatedChest, // Sobrescrevemos o array do baú com nossa versão atualizada
    gold: userData.gold + goldFromSales
});

transaction.delete(listingRef);

                transaction.delete(listingRef);
            });

            addMessage("Sua loja foi cancelada com sucesso.", 'success');
        } catch (error) {
            console.error("Erro ao cancelar a loja:", error);
            addMessage(`Falha ao cancelar: ${error.message}`, 'error');
        }
    };


    if (loading) {
        return <div className="text-white text-center p-10">Carregando Mercado...</div>;
    }

    const allListings = [...userListings, ...listings];
    
    // Lógica de Paginação
    const indexOfLastListing = currentPage * LISTINGS_PER_PAGE;
    const indexOfFirstListing = indexOfLastListing - LISTINGS_PER_PAGE;
    const currentListings = allListings.slice(indexOfFirstListing, indexOfLastListing);
    const totalPages = Math.ceil(allListings.length / LISTINGS_PER_PAGE);

    const paginate = (pageNumber) => {
        if (pageNumber < 1 || pageNumber > totalPages) return;
        setCurrentPage(pageNumber);
    };

    return (
        <div className="text-white p-4 md:p-8">
{!isMapFullScreen && <Tooltip content={tooltip.content} position={tooltip.position} />}
            {isCreateModalOpen && <CreateListingModal 
                characterData={characterData} 
                userId={userId} 
                closeModal={() => setCreateModalOpen(false)} 
                addMessage={addMessage}
                showTooltip={showTooltip}
                hideTooltip={hideTooltip}
            />}
            
            {/* Título Centralizado */}
<h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow flex items-center justify-center">
    <MarketIcon className="w-14 h-14" />
    <span className="ml-3">Mercado de Itens</span>
</h1>

{/* Controles Alinhados à Direita */}
<div className="flex justify-end items-center gap-4 mb-6">
    <div className="flex items-center gap-2 text-yellow-400 font-bold">
        <CoinIcon />
        <span>Seu Ouro: {formatGold(characterData.gold)}</span>
    </div>
    <div className="flex gap-2">
        <button onClick={reclaimItemsAndGold} disabled={isReclaiming || reclaimableItemsCount === 0} className="relative mu-button bg-yellow-700/80 hover:bg-yellow-600/80">
            {isReclaiming ? 'Resgatando...' : 'Resgatar Itens'}
            {reclaimableItemsCount > 0 && (
                <span className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 text-white text-xs rounded-full flex items-center justify-center border-2 border-stone-800">
                    {reclaimableItemsCount}
                </span>
            )}
        </button>
        <button 
            onClick={() => setCreateModalOpen(true)} 
            disabled={userListings.length >= MAX_PLAYER_SHOPS} 
            className="mu-button bg-green-800/80 hover:bg-green-700/80"
        >
            {userListings.length >= MAX_PLAYER_SHOPS ? 'Limite de Lojas' : 'Criar Loja'}
        </button>
    </div>
</div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {currentListings.length > 0 ? currentListings.map(listing => {
                    const expiresDate = new Date(listing.expiresAt.toDate());
                    const formattedExpires = `${String(expiresDate.getDate()).padStart(2, '0')}/${String(expiresDate.getMonth() + 1).padStart(2, '0')} às ${String(expiresDate.getHours()).padStart(2, '0')}:${String(expiresDate.getMinutes()).padStart(2, '0')}`;

                    return (
                        <div key={listing.id} className="relative mu-panel-shop p-4 flex flex-col h-full">
                            <div className="flex-grow">
                                {listing.sellerId === userId && (
                                    <button
                                        onClick={() => handleCancelListing(listing.id)}
                                        className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full w-7 h-7 flex items-center justify-center text-lg font-bold z-10"
                                        title="Cancelar Loja"
                                    >
                                        &times;
                                    </button>
                                )}
                                <h3 className="text-xl font-bold text-stone-300 border-b border-stone-700 pb-2 mb-3">
                                     {listing.shopName ? <><span className="text-yellow-300">{listing.shopName}</span></> : <>Loja de: <span className="text-cyan-400">{listing.sellerName}</span></>}
                                </h3>
                                {listing.shopName && <p className="text-sm text-stone-400 -mt-2 mb-3">Vendedor: <span className="text-cyan-400">{listing.sellerName}</span></p>}

                                 <div className="grid grid-cols-3 gap-2">
                                    {listing.items.map(item => (
<div
    key={item.id}
    onMouseEnter={handleItemMouseEnter(item)}
    onMouseLeave={hideTooltip}
    className={`relative mu-inventory-slot h-24 ${item.isStack ? 'border-purple-500' : (item.qualityColor || 'border-stone-700')} ${item.quality === 'Lendário' ? 'animated-border' : ''}`}
>
    {item.isStack ? STACKABLE_ICONS[item.type] : ITEM_TYPES[item.type]?.icon}
    <span className="text-xs mt-1 text-center">{item.name.split(' ')[0]} { (item.upgradeLevel || 0) > 0 ? `+${item.upgradeLevel}` : ''}</span>

    {item.quantity && (
        <span className="absolute top-1 right-1 bg-stone-900 bg-opacity-80 text-white text-xs font-semibold rounded-full h-5 w-5 flex items-center justify-center border border-stone-600">
            {item.quantity}
        </span>
    )}

     {listing.sellerId !== userId && (
        <button onClick={(e) => handleBuyItem(e, listing.id, item)} className="absolute bottom-1 right-1 bg-green-600 hover:bg-green-700 text-white text-xs px-1 py-0.5 rounded">
            Comprar
        </button>
     )}
</div>
                                    ))}
                                </div>
                            </div>
                             <p className="text-xs text-stone-500 mt-auto pt-2 text-right">
                               Expira em: {formattedExpires}
                            </p>
                        </div>
                    )
                }) : <p className="col-span-full text-center text-stone-500">Nenhum item à venda no momento.</p>}
            </div>
             {totalPages > 1 && (
                <div className="flex justify-center items-center mt-8 space-x-4">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="mu-button"
                    >
                        Anterior
                    </button>
                    <span className="text-lg">
                        Página {currentPage} de {totalPages}
                    </span>
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="mu-button"
                    >
                        Próxima
                    </button>
                </div>
            )}
        </div>
    );
};

const CreateListingModal = ({ characterData, userId, closeModal, addMessage, showTooltip, hideTooltip }) => {
    const [selectedItems, setSelectedItems] = useState([]);
    const [prices, setPrices] = useState({});
    const [shopName, setShopName] = useState('');
    const [step, setStep] = useState(1);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [quantities, setQuantities] = useState({});

const STACKABLE_ICONS = {
    Blessing: <JewelIcon />,
    Soul: <SoulJewelIcon />,
};

const handleSetQuantity = (itemId, qty, maxQty) => {
    const numericQty = qty === '' ? '' : Math.max(1, Math.min(Number(qty), maxQty));
    setQuantities(prev => ({ ...prev, [itemId]: numericQty }));
};

    const availableItems = useMemo(() => {
        const allPhysicalItems = [...(characterData.inventory || []), ...(characterData.chest || [])];
        const nonStackableItems = allPhysicalItems.filter(item => !item.quantity);
        const stackableTotals = new Map();

        // 1. AQUI ESTÁ A CORREÇÃO PRINCIPAL:
        // Criamos uma lista que define EXATAMENTE quais itens empilháveis podem ser vendidos.
        const sellableStackableTypes = ['Blessing', 'Soul'];
        
        allPhysicalItems.forEach(item => {
            // 2. A CONDIÇÃO FOI ATUALIZADA:
            // Agora, a lógica só processa um item se ele tiver quantidade E se o seu tipo
            // estiver na nossa lista de itens vendáveis. Poções serão ignoradas aqui.
            if (item.quantity && sellableStackableTypes.includes(item.type)) {
                if (stackableTotals.has(item.type)) {
                    const existingItem = stackableTotals.get(item.type);
                    existingItem.quantity += item.quantity;
                } else {
                    stackableTotals.set(item.type, { ...item, isStack: true });
                }
            }
        });

        return [...nonStackableItems, ...Array.from(stackableTotals.values())];

    }, [characterData.inventory, characterData.chest]);

    const handleItemMouseEnter = (item, e) => {
        if (!showTooltip) return;
        const qualityTextColor = { 'Comum': 'text-white', 'Raro': 'text-blue-400', 'Épico': 'text-purple-400', 'Lendário': 'text-yellow-400' };
        const finalStats = getUpgradedStats(item);
        const displayName = item.name + ((item.upgradeLevel || 0) > 0 ? ` +${item.upgradeLevel}` : '');
        const itemTypeDetails = ITEM_TYPES[item.type];

        const content = (
            <div>
                <p className={`font-bold ${qualityTextColor[item.quality] || 'text-white'}`}>{displayName}</p>
                {itemTypeDetails?.class && <p className="text-yellow-300">Classe: {itemTypeDetails.class}</p>}
                {item.level && <p className="text-stone-400">Nível: {item.level}</p>}
                {finalStats.attack > 0 && <p className="text-green-400">Ataque: +{finalStats.attack}</p>}
                {finalStats.defense > 0 && <p className="text-blue-400">Defesa: +{finalStats.defense}</p>}
                {item.options && item.options.length > 0 && (
                    <div className="mt-2 pt-2 border-t border-stone-500">
                        {item.options.map((opt, index) => (
                            <p key={index} className="text-cyan-300 text-xs italic">{opt.text}</p>
                        ))}
                    </div>
                )}
                 {item.description && <p className="italic text-stone-300 mt-2">{item.description}</p>}
            </div>
        );
        showTooltip(content, e);
    };

    const handleToggleItem = (item) => {
        setSelectedItems(prev => {
            const isSelected = prev.find(i => i.id === item.id);
            if (isSelected) {
                const newPrices = { ...prices };
                delete newPrices[item.id];
                setPrices(newPrices);
                return prev.filter(i => i.id !== item.id);
            } else {
                if (prev.length < 6) {
                    return [...prev, item];
                }
                addMessage("Você pode listar no máximo 6 itens.", 'error');
                return prev;
            }
        });
    };
    
    const handleSetPrice = (itemId, price) => {
        let numericPrice = price === '' ? '' : Math.max(0, Number(price));
        if (numericPrice > MARKET_MAX_ITEM_PRICE) {
            numericPrice = MARKET_MAX_ITEM_PRICE;
            addMessage(`O preço máximo por item é de ${formatGold(MARKET_MAX_ITEM_PRICE)} de ouro.`, 'info');
        }
        setPrices(prev => ({...prev, [itemId]: numericPrice }));
    };
    
const handleConfirmListing = async () => {
    if (selectedItems.some(item => !prices[item.id] || prices[item.id] <= 0)) {
        addMessage("Por favor, defina um preço válido para todos os itens selecionados.", 'error');
        return;
    }
    if (selectedItems.some(item => item.isStack && (!quantities[item.id] || quantities[item.id] <= 0))) {
        addMessage("Por favor, defina uma quantidade válida para as joias.", 'error');
        return;
    }

    setIsSubmitting(true);
    addMessage("Criando sua loja...", 'info');

    const userCharRef = doc(db, "characters", userId);
    const newListingRef = doc(collection(db, "market_listings")); 

try {
    await runTransaction(db, async (transaction) => {
        const userDoc = await transaction.get(userCharRef);
        if (!userDoc.exists()) throw new Error("Seu personagem não foi encontrado.");

        const userData = userDoc.data();
        let updatedInventory = [...(userData.inventory || [])];
        let updatedChest = [...(userData.chest || [])];

        const itemsToSell = selectedItems.map(item => {
            if (item.isStack) {
                return {
                    ...item,
                    price: prices[item.id],
                    quantity: quantities[item.id],
                };
            }
            return { ...item, price: prices[item.id] };
        });

        // NOVA LÓGICA PARA REMOVER ITENS (INCLUINDO JOIAS)
        for (const itemToSell of itemsToSell) {
            if (itemToSell.isStack) {
                let quantityToDeduct = itemToSell.quantity;

                // Deduz do inventário primeiro
                for (let i = updatedInventory.length - 1; i >= 0; i--) {
                    if (updatedInventory[i].type === itemToSell.type && quantityToDeduct > 0) {
                        const stack = updatedInventory[i];
                        if (stack.quantity > quantityToDeduct) {
                            stack.quantity -= quantityToDeduct;
                            quantityToDeduct = 0;
                        } else {
                            quantityToDeduct -= stack.quantity;
                            updatedInventory.splice(i, 1);
                        }
                    }
                }

                // Se ainda for preciso, deduz do baú
                if (quantityToDeduct > 0) {
                    for (let i = updatedChest.length - 1; i >= 0; i--) {
                         if (updatedChest[i].type === itemToSell.type && quantityToDeduct > 0) {
                            const stack = updatedChest[i];
                            if (stack.quantity > quantityToDeduct) {
                                stack.quantity -= quantityToDeduct;
                                quantityToDeduct = 0;
                            } else {
                                quantityToDeduct -= stack.quantity;
                                updatedChest.splice(i, 1);
                            }
                        }
                    }
                }

                if (quantityToDeduct > 0) {
                    throw new Error(`Quantidade insuficiente de ${itemToSell.name}.`);
                }

            } else {
                // Lógica original para itens não empilháveis
                let itemFoundAndRemoved = false;
                const invIndex = updatedInventory.findIndex(i => i.id === itemToSell.id);
                if (invIndex > -1) {
                    updatedInventory.splice(invIndex, 1);
                    itemFoundAndRemoved = true;
                } else {
                    const chestIndex = updatedChest.findIndex(c => c.id === itemToSell.id);
                    if (chestIndex > -1) {
                        updatedChest.splice(chestIndex, 1);
                        itemFoundAndRemoved = true;
                    }
                }
                if (!itemFoundAndRemoved) throw new Error(`Item ${itemToSell.name} não foi encontrado.`);
            }
        }

        const expirationDate = new Date();
        expirationDate.setHours(expirationDate.getHours() + SHOP_LISTING_DURATION_HOURS);

        const newListingData = {
            sellerId: userId,
            sellerName: userData.name,
            shopName: shopName.trim(),
            items: itemsToSell,
            createdAt: serverTimestamp(),
            expiresAt: Timestamp.fromDate(expirationDate),
            goldToReclaim: 0,
            soldItemCount: 0,
        };

        transaction.set(newListingRef, newListingData);
        // ATUALIZAÇÃO FINAL: Remove os campos 'blessings' e 'souls' que são do sistema antigo
        transaction.update(userCharRef, { 
            inventory: updatedInventory, 
            chest: updatedChest,
        });
    });

    addMessage("Sua loja foi criada com sucesso!", 'success');
    closeModal();

} catch (error) {
    console.error("Erro ao criar loja:", error);
    addMessage(`Falha ao criar loja: ${error.message}`, 'error');
} finally {
    setIsSubmitting(false);
}
};

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
            <div className="mu-panel p-6 w-full max-w-4xl text-white">
                <h2 className="text-2xl font-bold mb-4 mu-title">Criar Loja Pessoal - {step === 1 ? "Selecione os Itens (até 6)" : "Defina os Preços"}</h2>
                
                {step === 1 && (
                    <>
                        <div className="bg-stone-900/80 p-4 rounded-md h-96 overflow-y-auto grid grid-cols-4 sm:grid-cols-6 gap-4 border border-stone-700">
                            {availableItems.length > 0 ? availableItems.map(item => (
                                <div
                                    key={item.id}
                                    onClick={() => handleToggleItem(item)}
                                    onMouseEnter={(e) => handleItemMouseEnter(item, e)}
                                    onMouseLeave={hideTooltip}
                                    className={`relative mu-inventory-slot h-24 ${selectedItems.find(i => i.id === item.id) ? 'border-green-500' : item.qualityColor || 'border-stone-700'}`}
                                >
                                    {item.isStack ? STACKABLE_ICONS[item.type] : ITEM_TYPES[item.type]?.icon}
<span className="text-xs mt-1 text-center">
    {item.isStack ? item.name : item.name.split(' ')[0]}
</span>
                                    {selectedItems.find(i => i.id === item.id) && <div className="absolute inset-0 bg-green-500 opacity-40"></div>}
                                </div>
                            )) : <p className="col-span-full text-center text-stone-500">Nenhum item vendável no seu inventário ou baú.</p>}
                        </div>
                        <div className="mt-4 flex justify-end gap-4">
                            <button onClick={closeModal} className="mu-button bg-red-800/80 hover:bg-red-700/80">Cancelar</button>
                             <button onClick={() => selectedItems.length > 0 && setStep(2)} disabled={selectedItems.length === 0} className="mu-button bg-blue-800/80 hover:bg-blue-700/80">Próximo</button>
                        </div>
                    </>
                )}

                {step === 2 && (
                     <>
                        <input
                            type="text"
                            value={shopName}
                            onChange={(e) => setShopName(e.target.value)}
                            placeholder="Nome da Loja (Opcional)"
                            maxLength="100"
                            className="mu-input w-full p-2 mb-4 text-center"
                        />
                        <div className="bg-stone-900/80 p-4 rounded-md h-80 overflow-y-auto grid grid-cols-2 sm:grid-cols-3 gap-4 border border-stone-700">
                           {selectedItems.map(item => (
<div 
    key={item.id}
    onMouseEnter={(e) => handleItemMouseEnter(item, e)}
    onMouseLeave={hideTooltip}
    className={`mu-inventory-slot h-auto p-2 border-2 ${item.qualityColor || 'border-stone-700'}`}
>
    {item.isStack ? STACKABLE_ICONS[item.type] : ITEM_TYPES[item.type]?.icon}
    <span className="text-xs mt-1 text-center">
    {item.isStack ? item.name : item.name.split(' ')[0]}
</span>

    {item.isStack && (
        <input
            type="number"
            placeholder={`Qtde. (Máx: ${item.quantity})`}
            value={quantities[item.id] || ''}
            onChange={(e) => handleSetQuantity(item.id, e.target.value, item.quantity)}
            className="mu-input w-full p-1 mt-2 text-center"
        />
    )}

    <input
        type="number"
        placeholder="Preço em ouro"
        value={prices[item.id] || ''}
        onChange={(e) => handleSetPrice(item.id, e.target.value)}
        className="mu-input w-full p-1 mt-1 text-center"
    />
</div>
                            ))}
                        </div>
                        <div className="mt-4 flex justify-between gap-4">
                            <button onClick={() => setStep(1)} className="mu-button">Voltar</button>
                            <div className="flex gap-4">
                                <button onClick={closeModal} className="mu-button bg-red-800/80 hover:bg-red-700/80">Cancelar</button>
                                <button onClick={handleConfirmListing} disabled={isSubmitting} className="mu-button bg-green-800/80 hover:bg-green-700/80">
                                    {isSubmitting ? 'Listando...' : 'Confirmar e Listar'}
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
const PrivateChat = ({ friend, userId, characterName, onBack }) => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const chatId = getPrivateChatId(userId, friend.uid);
    const messagesEndRef = useRef(null);

    useEffect(() => {
        if (!chatId) return;
        const chatCollRef = collection(db, 'private_chats', chatId, 'messages');
        const q = query(chatCollRef, orderBy('createdAt', 'asc'));

        const unsubscribe = onSnapshot(q, async (snapshot) => {
            const msgs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setMessages(msgs);

            const batch = writeBatch(db);
            let hasUnread = false;
            snapshot.docs.forEach(doc => {
                if (doc.data().to === userId && !doc.data().read) {
                    batch.update(doc.ref, { read: true });
                    hasUnread = true;
                }
            });
            if (hasUnread) {
                try {
                    await batch.commit();
                } catch(error) {
                    console.error("Erro ao marcar mensagens como lidas:", error);
                }
            }
        }, (error) => {
            console.error("Erro no listener do chat privado:", error);
        });

        return () => unsubscribe();
    }, [chatId, userId]);
    
    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [messages]);

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!newMessage.trim() || !chatId) return;

        const chatCollRef = collection(db, 'private_chats', chatId, 'messages');
        try {
            await addDoc(chatCollRef, {
                text: newMessage,
                from: userId,
                to: friend.uid,
                senderName: characterName,
                createdAt: serverTimestamp(),
                read: false
            });
            setNewMessage('');
        } catch (error) {
            console.error("Erro ao enviar mensagem privada:", error);
            alert("Não foi possível enviar a mensagem. Você não tem permissão.");
        }
    };

    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center mb-4 p-2 bg-stone-900/50 rounded-md">
                <button onClick={onBack} className="mu-button-small mr-4">← Voltar</button>
                <h3 className="text-xl font-bold text-cyan-300">Chat com {friend.name}</h3>
            </div>
            <div className="chatFriend flex-grow bg-stone-900/80 p-3 rounded-md overflow-y-auto mb-4 border border-stone-700">
                {messages.map(msg => (
                    <div key={msg.id} className={`mb-2 flex ${msg.from === userId ? 'justify-end' : 'justify-start'}`}>
                        <div className={`rounded-lg px-3 py-2 max-w-xs lg:max-w-md ${msg.from === userId ? 'bg-blue-600' : 'bg-stone-600'}`}>
                            <p className="text-sm">{msg.text}</p>
                            <p className="text-xs text-stone-400 text-right mt-1">
                                {msg.createdAt ? new Date(msg.createdAt.toDate()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '...'}
                            </p>
                        </div>
                    </div>
                ))}
                <div ref={messagesEndRef} />
            </div>
            <form onSubmit={handleSendMessage} className="flex gap-2">
                <input
                    type="text"
                    value={newMessage}
                    onChange={(e) => setNewMessage(e.target.value)}
                    placeholder="Digite sua mensagem..."
                    className="mu-input w-full"
                />
                <button type="submit" className="mu-button">Enviar</button>
            </form>
        </div>
    );
};

const FriendsModal = ({ isOpen, closeModal, characterData, userId, unreadMessages, friendRequestCount, addMessage }) => {
    const [activeTab, setActiveTab] = useState('list');
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [chattingWith, setChattingWith] = useState(null);
    const [onlineStatuses, setOnlineStatuses] = useState({});
    const [loadingStatuses, setLoadingStatuses] = useState(false);
    const [receivedRequests, setReceivedRequests] = useState([]);
    const [sentRequests, setSentRequests] = useState([]);
    
    // Listener para status online dos amigos
    useEffect(() => {
        if (!isOpen || activeTab !== 'list' || !characterData?.friends?.length) {
            return;
        }

        const fetchStatuses = async () => {
            setLoadingStatuses(true);
            const fiveMinutesAgo = Timestamp.fromDate(new Date(Date.now() - 5 * 60 * 1000));
            const friendUids = characterData.friends.map(f => f.uid);
            if (friendUids.length === 0) {
                setOnlineStatuses({});
                setLoadingStatuses(false);
                return;
            }
            const statuses = {};
            try {
                 const q = query(collection(db, "characters"), where(documentId(), "in", friendUids));
                 const snapshot = await getDocs(q);
                 snapshot.docs.forEach(doc => {
                     const data = doc.data();
                     const lastUpdate = data.lastUpdateTimestamp; // CORREÇÃO: Usa o novo campo de timestamp
                     statuses[doc.id] = lastUpdate && lastUpdate > fiveMinutesAgo;
                 });
            } catch (error) {
                console.error("Erro ao buscar status de amigos:", error);
            }
            setOnlineStatuses(statuses);
            setLoadingStatuses(false);
        };
        fetchStatuses();
    }, [isOpen, activeTab, characterData?.friends]);

    // Listener para solicitações recebidas e enviadas
    useEffect(() => {
        if (!isOpen || !userId) return;

        // Solicitações recebidas
        const receivedQuery = query(collection(db, "friendRequests"), where("to", "==", userId), where("status", "==", "pending"));
        const unsubReceived = onSnapshot(receivedQuery, (snapshot) => {
            setReceivedRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        // Solicitações enviadas
        const sentQuery = query(collection(db, "friendRequests"), where("from", "==", userId), where("status", "==", "pending"));
        const unsubSent = onSnapshot(sentQuery, (snapshot) => {
            setSentRequests(snapshot.docs.map(doc => doc.data().to));
        });

        return () => {
            unsubReceived();
            unsubSent();
        };
    }, [isOpen, userId]);

    const handleOpenChat = (friend) => {
        setChattingWith(friend);
    };

    const handleCloseChat = () => {
        setChattingWith(null);
    };

    const handleSearch = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;
        setLoadingSearch(true);
        try {
            const q = query(collection(db, "characters"), where("name", "==", searchTerm.trim()));
            const querySnapshot = await getDocs(q);
            const results = querySnapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .filter(p => p.id !== userId); 
            setSearchResults(results);
        } catch (error) {
            console.error("Erro ao pesquisar jogadores:", error);
        }
        setLoadingSearch(false);
    };

    const sendFriendRequest = async (targetPlayer) => {
        if (!targetPlayer || !targetPlayer.id) return;
        if (characterData.friends?.some(f => f.uid === targetPlayer.id)) {
            addMessage("Você já é amigo deste jogador.", 'info');
            return;
        }

        const requestsRef = collection(db, "friendRequests");
        const q1 = query(requestsRef, where("from", "==", userId), where("to", "==", targetPlayer.id));
        const q2 = query(requestsRef, where("from", "==", targetPlayer.id), where("to", "==", userId));

        try {
            const [sentSnapshot, receivedSnapshot] = await Promise.all([getDocs(q1), getDocs(q2)]);
            if (!sentSnapshot.empty || !receivedSnapshot.empty) {
                addMessage("Já existe um pedido de amizade entre vocês.", 'info');
                return;
            }

            await addDoc(requestsRef, {
                from: userId,
                fromName: characterData.name,
                to: targetPlayer.id,
                toName: targetPlayer.name,
                status: 'pending',
                createdAt: serverTimestamp()
            });
            addMessage(`Pedido de amizade enviado para ${targetPlayer.name}.`, 'success');
        } catch (error) {
            console.error("Erro ao enviar pedido de amizade:", error);
            addMessage("Não foi possível enviar o pedido. Verifique as permissões do Firestore.", 'error');
        }
    };
    
    const handleRemoveFriend = async (friendToRemove) => {
        if (!window.confirm(`Você realmente deseja remover ${friendToRemove.name} da sua lista de amigos? A amizade será desfeita apenas para você.`)) {
            return;
        }
        const currentUserRef = doc(db, "characters", userId);
        const friendPayloadForCurrentUser = { uid: friendToRemove.uid, name: friendToRemove.name };
        try {
            await updateDoc(currentUserRef, {
                friends: arrayRemove(friendPayloadForCurrentUser)
            });
            addMessage(`${friendToRemove.name} foi removido da sua lista de amigos.`, 'success');
        } catch (error) {
            console.error("Erro ao remover amigo:", error);
            addMessage("Não foi possível remover o amigo.", 'error');
        }
    };

    const handleFriendAction = async (request, action) => {
        const requestRef = doc(db, "friendRequests", request.id);

        if (action === 'accept') {
            const currentUserRef = doc(db, "characters", userId);
            const batch = writeBatch(db);
            batch.update(requestRef, { status: 'accepted' });
            batch.update(currentUserRef, {
                friends: arrayUnion({ uid: request.from, name: request.fromName })
            });
            try {
                await batch.commit();
                addMessage(`Você e ${request.fromName} agora são amigos.`, 'success');

        // --- ATUALIZAÇÃO DE MISSÕES: ADD_FRIEND ---
        const friendMission = characterData.missions?.find(m =>
            m.status === 'active' &&
            MISSIONS[m.id]?.type === MISSION_TYPES.ADD_FRIEND
        );

        if (friendMission) {
            const userDocRef = doc(db, "characters", userId);
            const missionInfo = MISSIONS[friendMission.id];
            const newProgress = (friendMission.progress || 0) + 1;
            let newStatus = friendMission.status;

            if (newProgress >= missionInfo.objective.targetCount) {
                newStatus = 'completed';
                addMessage(`Missão Concluída: ${missionInfo.name}!`, 'success');
            }
            
            // Atualiza a missão diretamente no banco, pois não temos acesso ao setCharacterData aqui
            const updatedMissions = characterData.missions.map(m => 
                m.id === friendMission.id ? { ...m, progress: newProgress, status: newStatus } : m
            );
            await updateDoc(userDocRef, { missions: updatedMissions });
        }
        // --- FIM DA ATUALIZAÇÃO DE MISSÕES ---

            } catch (error) {
                console.error("Erro ao aceitar pedido:", error);
                addMessage("Falha ao aceitar o pedido.", 'error');
            }
        } else { // 'decline'
            try {
                await deleteDoc(requestRef);
                addMessage("Pedido recusado.", 'info');
            } catch (error) {
                console.error("Erro ao recusar pedido:", error);
                addMessage("Falha ao recusar o pedido.", 'error');
            }
        }
    };

    const handleCloseModal = () => {
        setChattingWith(null);
        setActiveTab('list');
        closeModal();
    }

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4">
            <div className="mu-panel p-6 w-full max-w-2xl max-h-[80vh] flex flex-col">
                {chattingWith ? (
                    <PrivateChat
                        friend={chattingWith}
                        userId={userId}
                        characterName={characterData.name}
                        onBack={handleCloseChat}
                    />
                ) : (
                    <>
                        <div className="flex justify-between items-start">
                            <h2 className="text-2xl font-bold mb-4 text-stone-300 mu-title">Amigos</h2>
                            <button onClick={handleCloseModal} className="text-white bg-red-600 hover:bg-red-700 rounded-md w-8 h-8 flex items-center justify-center text-2xl font-bold">&times;</button>
                        </div>
                        <div className="flex border-b border-stone-700 mb-4">
                            <button onClick={() => setActiveTab('list')} className={`mu-tab-button flex-1 ${activeTab === 'list' ? 'mu-tab-button-active' : ''}`}>Lista</button>
                            <button onClick={() => setActiveTab('requests')} className={`mu-tab-button relative flex-1 ${activeTab === 'requests' ? 'mu-tab-button-active' : ''}`}>
                                Solicitações
                                {friendRequestCount > 0 && (
                                    <span className="absolute top-1 right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                                        {friendRequestCount}
                                    </span>
                                )}
                            </button>
                            <button onClick={() => setActiveTab('search')} className={`mu-tab-button flex-1 ${activeTab === 'search' ? 'mu-tab-button-active' : ''}`}>Adicionar</button>
                        </div>

                        <div className="flex-grow overflow-y-auto">
                            {activeTab === 'list' && (
                                <div>
                                    {loadingStatuses && <p className="text-stone-400 text-center">Carregando status...</p>}
                                    {(characterData.friends || []).length > 0 ? (
                                        (characterData.friends || []).map(friend => (
                                            <div key={friend.uid} className="bg-stone-900/50 p-3 rounded-md mb-2 flex justify-between items-center">
                                               <div className="flex items-center gap-2">
                                                    <span className={`w-3 h-3 rounded-full ${onlineStatuses[friend.uid] ? 'bg-green-500' : 'bg-red-500'}`}></span>
                                                    <span className="text-cyan-300">{friend.name}</span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <button onClick={() => handleOpenChat(friend)} className="relative mu-button-small bg-blue-800/80">
                                                        <ChatIcon />
                                                        {unreadMessages[friend.uid] > 0 && (
                                                            <span className="w-3 h-3 bg-red-500 rounded-full flex items-center justify-center border-2 border-stone-700"></span>
                                                        )}
                                                    </button>
                                                    <button onClick={() => handleRemoveFriend(friend)} className="mu-button-small bg-red-800/80 font-bold">
                                                        X
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : <p className="text-stone-500 text-center">Sua lista de amigos está vazia.</p>}
                                </div>
                            )}
                            {activeTab === 'requests' && (
                                <div>
                                    {receivedRequests.length > 0 ? (
                                        receivedRequests.map(req => (
                                            <div key={req.id} className="bg-stone-900/50 p-3 rounded-md mb-2 flex justify-between items-center">
                                                <span>{req.fromName}</span>
                                                <div className="flex gap-2">
                                                    <button onClick={() => handleFriendAction(req, 'accept')} className="mu-button-small bg-green-800/80">Aceitar</button>
                                                    <button onClick={() => handleFriendAction(req, 'decline')} className="mu-button-small bg-red-800/80">Recusar</button>
                                                </div>
                                            </div>
                                        ))
                                    ) : <p className="text-stone-500 text-center">Nenhuma solicitação de amizade pendente.</p>}
                                </div>
                            )}
                            {activeTab === 'search' && (
                                <div>
                                    <form onSubmit={handleSearch} className="flex gap-2 mb-4">
                                        <input
                                            type="text"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                            placeholder="Digite o nome do personagem"
                                            className="mu-input w-full"
                                        />
                                        <button type="submit" disabled={loadingSearch} className="mu-button">
                                            {loadingSearch ? '...' : 'Buscar'}
                                        </button>
                                    </form>
                                    <div>
                                        {searchResults.map(player => (
                                            <div key={player.id} className="bg-stone-900/50 p-3 rounded-md mb-2 flex justify-between items-center">
                                                <span>{player.name} (Nível {player.level})</span>
                                                <button
                                                    onClick={() => sendFriendRequest(player)}
                                                    disabled={sentRequests.includes(player.id) || characterData.friends?.some(f => f.uid === player.id)}
                                                    className="mu-button-small bg-green-800/80"
                                                >
                                                    {sentRequests.includes(player.id) ? 'Enviado' : characterData.friends?.some(f => f.uid === player.id) ? 'Amigo' : 'Adicionar'}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};



// --- NOVO COMPONENTE: PÁGINA DE INVASÕES ---
const InvasionPage = ({ characterData, userId, saveData, addMessage }) => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const handleStartInvasion = async (invasionId, durationOption) => { // <-- MUDANÇA: Recebe o objeto de duração completo
        if (characterData.currentInvasion) {
            addMessage("Você já está participando de uma invasão.", "error");
            return;
        }

        const invasion = INVASIONS[invasionId];
        if (characterData.level < invasion.requiredLevel) {
            addMessage("Você não tem o nível necessário para esta invasão.", "error");
            return;
        }

        // --- NOVA LÓGICA: Verificação e Custo de Stamina ---
        if ((characterData.stamina || 0) < durationOption.staminaCost) {
            addMessage(`Stamina insuficiente. Necessário: ${durationOption.staminaCost}.`, "error");
            return;
        }
        // --- FIM DA NOVA LÓGICA ---

        const startTime = new Date();
        const endTime = new Date(startTime.getTime() + durationOption.time * 60000);

        const newInvasionStatus = {
            id: invasionId,
            duration: durationOption.time,
            endTime: Timestamp.fromDate(endTime),
        };

        try {
            const userDocRef = doc(db, "characters", userId);
            // --- ATUALIZAÇÃO: Deduz a stamina ao iniciar a invasão ---
            await updateDoc(userDocRef, { 
                currentInvasion: newInvasionStatus
            });
            addMessage(`Você entrou na ${invasion.name} por ${durationOption.label}!`, "success");
        } catch (error) {
            console.error("Erro ao iniciar invasão:", error);
            addMessage("Não foi possível iniciar a invasão.", "error");
        }
    };


const handleClaimRewards = async () => {
    if (!characterData.currentInvasion) return;

    const invasionId = characterData.currentInvasion.id;
    const duration = characterData.currentInvasion.duration;
    const invasion = INVASIONS[invasionId];
    const durationInfo = invasion.durations.find(d => d.time === duration);

    if (!durationInfo) {
        addMessage("Erro ao encontrar informações da recompensa.", "error");
        const userDocRef = doc(db, "characters", userId);
        await updateDoc(userDocRef, { currentInvasion: null });
        return;
    }

    const rewards = durationInfo.rewards;
    let newData = { ...characterData };

    // --- REQUISITO 2: VERIFICAÇÃO DE ESPAÇO NO INVENTÁRIO E BAÚ ---
    const itemsToReceiveCount = rewards.items;
    const inventorySpace = INVENTORY_LIMIT - (newData.inventory || []).length;
    const chestSpace = CHEST_SIZE - (newData.chest || []).length;
    const totalSpace = inventorySpace + chestSpace;

    if (itemsToReceiveCount > totalSpace) {
        addMessage(`Espaço insuficiente para resgatar. Libere ${itemsToReceiveCount - totalSpace} espaços no inventário ou baú.`, "error");
        return; // Bloqueia o resgate
    }
    // --- FIM DA VERIFICAÇÃO ---

    if ((newData.stamina || 0) < durationInfo.staminaCost) {
        addMessage(`Stamina insuficiente para resgatar. Necessário: ${durationInfo.staminaCost}.`, "error");
        return;
    }

    newData.stamina = (newData.stamina || 0) - durationInfo.staminaCost;
    
    const expGained = rewards.exp;
    newData.experience += expGained;
    addMessage(`Você ganhou ${expGained.toLocaleString()} de experiência!`, 'success');

    // --- REQUISITO 2: LÓGICA DE DISTRIBUIÇÃO DE ITENS (INVENTÁRIO > BAÚ) ---
    let itemsForInventory = [];
    let itemsForChest = [];
    for (let i = 0; i < rewards.items; i++) {
        const newItem = generateRandomItem(newData.level, true, 0, rewards.itemQualityChances);
        if (itemsForInventory.length < inventorySpace) {
            itemsForInventory.push(newItem);
        } else {
            itemsForChest.push(newItem);
        }
    }
    if (itemsForInventory.length > 0) {
         newData.inventory = [...newData.inventory, ...itemsForInventory];
    }
    if (itemsForChest.length > 0) {
        newData.chest = [...(newData.chest || []), ...itemsForChest];
    }
    if (itemsForInventory.length > 0 || itemsForChest.length > 0) {
        addMessage(`Você encontrou ${rewards.items} item(ns) durante a invasão!`, 'info');
    }
    // --- FIM DA LÓGICA DE DISTRIBUIÇÃO ---

    // --- REQUISITO 1: LÓGICA DE RECOMPENSA DE OURO ---
    if (rewards.goldDropChance && Math.random() < rewards.goldDropChance) {
        const [minGold, maxGold] = rewards.goldDropRange;
        const goldGained = Math.floor(Math.random() * (maxGold - minGold + 1)) + minGold;
        newData.gold = (newData.gold || 0) + goldGained;
        addMessage(`Sorte grande! Você encontrou ${formatGold(goldGained)} de ouro!`, 'info', 'Gold');
    }
    // --- FIM DA LÓGICA DE OURO ---

    // --- REQUISITO 3: LÓGICA DE MÚLTIPLAS JOIAS ---
const maxJewels = rewards.maxJewels || 1;
let tempInventory = [...(newData.inventory || [])]; // Usamos um inventário temporário

for (let i = 0; i < maxJewels; i++) {
    if (Math.random() < rewards.jewels) {
        const jewelType = Math.random() < 0.7 ? 'Blessing' : 'Soul';
        const jewelData = {
            Blessing: { id: 'blessings_stack', name: 'Joia da Benção', type: 'Blessing', description: 'Aumenta o nível de um item em +1, até +6.', slot: 'consumable' },
            Soul: { id: 'souls_stack', name: 'Joia da Alma', type: 'Soul', description: 'Tem 70% de chance de elevar um item de +6 a +9.', slot: 'consumable' }
        };

        let stackFound = false;
        // Tenta empilhar a joia
        tempInventory = tempInventory.map(item => {
            if (item.type === jewelType) {
                stackFound = true;
                // Retorna uma cópia do item com a quantidade atualizada
                return { ...item, quantity: (item.quantity || 1) + 1 };
            }
            return item;
        });

        // Se não encontrou uma pilha para adicionar, cria uma nova
        if (!stackFound) {
            tempInventory.push({ ...jewelData[jewelType], quantity: 1 });
        }
        
        // **LÓGICA DE NOTIFICAÇÃO CORRIGIDA**
        // Envia uma notificação específica para cada joia encontrada, usando o 'jewelType' correto
        addMessage(`Você encontrou uma ${jewelData[jewelType].name}!`, 'info', jewelType);
    }
}

// Atualiza o inventário principal com todas as joias encontradas no final
newData.inventory = tempInventory;
    // --- FIM DA LÓGICA DE JOIAS ---

    newData.currentInvasion = null;

    const expToNextLevel = newData.level * 100;
    if (newData.experience >= expToNextLevel) {
        newData.level += 1;
        newData.skillPoints += 5;
        newData.experience = newData.experience % expToNextLevel;
        addMessage(`Parabéns! Você alcançou o nível ${newData.level}!`, 'success');
    }

    await saveData(newData);
};
    // --- NOVA FUNÇÃO: Cancelar Invasão ---
    const handleCancelInvasion = async () => {
        if (!characterData.currentInvasion) return;
        
        if (window.confirm("Tem certeza que deseja cancelar a invasão? Você não receberá nenhuma recompensa.")) {
            try {
                const userDocRef = doc(db, "characters", userId);
                await updateDoc(userDocRef, { currentInvasion: null });
                addMessage("Invasão cancelada. Nenhuma recompensa foi recebida.", "info");
            } catch (error) {
                console.error("Erro ao cancelar invasão:", error);
                addMessage("Não foi possível cancelar a invasão.", "error");
            }
        }
    };


    const renderTimeLeft = (endTime) => {
        const totalSeconds = Math.floor((endTime - currentTime) / 1000);
        if (totalSeconds <= 0) {
            return "Concluído!";
        }
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    if (characterData.currentInvasion) {
        const invasion = INVASIONS[characterData.currentInvasion.id];
        const endTime = characterData.currentInvasion.endTime.toDate();
        const isFinished = currentTime >= endTime;

        return (
            <div className="text-white p-4 md:p-8 flex items-center justify-center min-h-[80vh]">
                <div className="mu-panel p-8 text-center w-full max-w-2xl">
                    <h2 className="text-3xl font-bold mb-2 mu-title">Você está em uma Invasão!</h2>
                    <p className="text-xl text-yellow-400 mb-6">{invasion.name}</p>
                    <img src={invasion.image} alt={invasion.name} className="w-full h-90 object-cover rounded-md border-2 border-stone-600 mb-6" />
                    
                    <div className="text-4xl font-bold my-4">
                        {renderTimeLeft(endTime)}
                    </div>

                    {isFinished ? (
                        <button onClick={handleClaimRewards} className="mu-button text-xl w-full py-3 bg-green-800/80 hover:bg-green-700/80">
                            Resgatar Recompensa
                        </button>
) : (
    <div className="space-y-3"> {/* 1. Adicionamos uma div para agrupar */}
        <p className="text-stone-400">Volte quando o tempo acabar para resgatar suas recompensas.</p>
        <button onClick={handleCancelInvasion} className="mu-button text-md w-full py-2 bg-red-800/80 hover:bg-red-700/80">
            Cancelar {/* 2. Adicionamos o texto e o fechamento do botão */}
        </button>
    </div>
)}
                </div>
            </div>
        );
    }

    return (
        <div className="text-white p-4 md:p-8">
<h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow flex items-center justify-center">
    <InvasionIcon className="w-16 h-16" />
    <span className="ml-3">Invasões disponíveis</span>
</h1>
            <div className="space-y-8">
                {Object.values(INVASIONS).map(invasion => {
                    const isLocked = characterData.level < invasion.requiredLevel;
                    return (
                        <div key={invasion.id} className={`mu-panel p-6 grid grid-cols-1 md:grid-cols-3 gap-6 items-center ${isLocked ? 'opacity-50' : ''}`}>
                            <div className="md:col-span-1">
                                <img src={invasion.image} alt={invasion.name} className="w-full h-80 object-cover rounded-md border-2 border-stone-600" />
                            </div>
                            <div className="md:col-span-2">
                                <h2 className="text-2xl font-bold mu-title">{invasion.name}</h2>
                                {isLocked && <p className="text-red-400 font-bold">Requer Nível: {invasion.requiredLevel}</p>}
                                <p className="text-stone-400 mt-2 mb-4">{invasion.description}</p>
<div className="grid grid-cols-2 md:grid-cols-4 gap-3 mt-4">
    {invasion.durations.map(d => (
        <div key={d.time} className="bg-stone-900/60 p-3 rounded-md border border-stone-700 flex flex-col justify-between">
            <div>
                <p className="font-bold text-lg text-center text-yellow-300 border-b border-stone-600 pb-2 mb-2">{d.label}</p>
                <p className="text-sm text-stone-300">⚡ Custo: <span className="font-semibold text-white">{d.staminaCost} Stamina</span></p>
                <p className="text-sm text-stone-300">⭐ EXP: <span className="font-semibold text-white">{d.rewards.exp.toLocaleString()}</span></p>
                <p className="text-sm text-stone-300">⚔️ Itens: <span className="font-semibold text-white">{d.rewards.items}</span></p>
                <p className="text-sm text-stone-300">💎 Joias (Máx): <span className="font-semibold text-white">{d.rewards.jewels * 100}% chance ({d.rewards.maxJewels})</span></p>
                
                <p className="text-sm text-stone-300">💰 Ouro: <span className="font-semibold text-white">{(d.rewards.goldDropChance * 100)}% chance</span></p>
            </div>
            <button
                disabled={isLocked}
                onClick={() => handleStartInvasion(invasion.id, d)}
                className="mu-button w-full mt-3"
            >
                Iniciar
            </button>
        </div>
    ))}
</div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


// --- NOVO COMPONENTE: PÁGINA DE MISSÕES ---
const MissionsPage = ({ characterData, userId, addMessage, saveData }) => {
    const [showCompleted, setShowCompleted] = useState(false);
    
    // Função para iniciar uma missão
    const startMission = async (missionId) => {
        const mission = MISSIONS[missionId];
        if (!mission) return;

        // Verifica se a missão já está no progresso do jogador
        const existingMission = characterData.missions?.find(m => m.id === missionId);
        if (existingMission) {
            addMessage("Você já iniciou esta missão.", "info");
            return;
        }

        const newMissionProgress = {
            id: missionId,
            status: 'active', // 'active', 'completed', 'claimed'
            progress: 0
        };

        const userDocRef = doc(db, "characters", userId);
        try {
            await updateDoc(userDocRef, {
                missions: arrayUnion(newMissionProgress)
            });
            addMessage(`Nova missão iniciada: ${mission.name}!`, "success");
        } catch (error) {
            console.error("Erro ao iniciar missão: ", error);
            addMessage("Não foi possível iniciar a missão.", "error");
        }
    };

 // Função para coletar a recompensa
    const claimReward = async (missionId) => {
        const mission = MISSIONS[missionId];
        const missionProgress = characterData.missions.find(m => m.id === missionId);

        if (!mission || !missionProgress || missionProgress.status !== 'completed') {
            addMessage("Não é possível coletar a recompensa desta missão.", "error");
            return;
        }

        let newData = { ...characterData };
        let finalMessage = "Recompensa coletada: ";
        const rewards = [];

	// CÓDIGO ATUALIZADO (Correto)
	// Adiciona EXP e calcula o level up
	if (mission.rewards.exp) {
    		let expGained = mission.rewards.exp;
    		rewards.push(`${expGained} EXP`);

    		let newExp = (newData.experience || 0) + expGained;
    		let expToNextLevel = newData.level * 100;

    	// Loop para lidar com múltiplos leveis
    	while (newExp >= expToNextLevel) {
        	newExp -= expToNextLevel; // Subtrai o custo do nível atual
        	newData.level += 1;      // Aumenta o nível
        	newData.skillPoints = (newData.skillPoints || 0) + 5; // Adiciona pontos de skill

        // Mensagem de level up
        const levelUpMessage = `Parabéns! Você alcançou o nível ${newData.level}!`;
        addMessage(levelUpMessage, 'success');

        expToNextLevel = newData.level * 100; // Atualiza o custo para o próximo nível
    }
    newData.experience = newExp; // Define o XP restante
}
        // Adiciona Ouro
        if (mission.rewards.gold) {
            newData.gold = (newData.gold || 0) + mission.rewards.gold;
            rewards.push(`${formatGold(mission.rewards.gold)} Ouro`);
        }

        // Prepara para adicionar itens e joias
        let newItems = [];
        if (mission.rewards.items) newItems.push(...mission.rewards.items);
        if (mission.rewards.jewels) newItems.push(...mission.rewards.jewels);

        // Processa a adição de itens/joias
        for (const rewardItem of newItems) {
            let stackFound = false;
            // Tenta empilhar
            newData.inventory = newData.inventory.map(invItem => {
                if (invItem.type === rewardItem.type) {
                    invItem.quantity = (invItem.quantity || 1) + rewardItem.quantity;
                    stackFound = true;
                }
                return invItem;
            });

            // Se não encontrou pilha para adicionar, cria um novo item no inventário
            if (!stackFound) {
                if (newData.inventory.length < INVENTORY_LIMIT) {
                    const itemTemplate = ITEM_TYPES[rewardItem.type];

                    // --- INÍCIO DA CORREÇÃO ---
                    // 1. Verificação de segurança: garante que o tipo do item existe em ITEM_TYPES
                    if (!itemTemplate) {
                        console.error(`Tipo de item inválido na recompensa da missão: ${rewardItem.type}`);
                        addMessage(`Erro ao processar recompensa: item desconhecido.`, "error");
                        continue; // Pula para o próximo item da recompensa para não travar o jogo
                    }

                    // 2. Cria um objeto novo e limpo, contendo apenas os dados necessários e serializáveis
                    const newItemForInventory = {
                        id: `${rewardItem.type}_${Date.now()}_${Math.random()}`,
                        name: itemTemplate.name,
                        type: rewardItem.type,
                        slot: itemTemplate.slot,
                        description: itemTemplate.description || `Recompensa da missão "${mission.name}".`,
                        quantity: rewardItem.quantity
                        // Note que a propriedade 'icon' não é incluída, pois não pode ser salva no banco de dados.
                    };
                    
                    newData.inventory.push(newItemForInventory);
                    // --- FIM DA CORREÇÃO ---

                } else {
                    addMessage(`Inventário cheio! A recompensa ${ITEM_TYPES[rewardItem.type]?.name || 'desconhecida'} foi perdida.`, "error");
                }
            }
            rewards.push(`${rewardItem.quantity}x ${ITEM_TYPES[rewardItem.type]?.name || rewardItem.type}`);
        }

        // Atualiza o status da missão para 'claimed'
        newData.missions = newData.missions.map(m => {
            if (m.id === missionId) {
                return { ...m, status: 'claimed' };
            }
            return m;
        });

        // Salva todos os dados atualizados
        await saveData(newData);
        addMessage(finalMessage + rewards.join(', ') + "!", 'success');
    };


    return (
        <div className="text-white p-4 md:p-8">
<h1 className="text-4xl font-bold text-stone-300 mb-6 text-center border-b-2 border-stone-700 pb-4 mu-text-shadow flex items-center justify-center">
    <MissionsIcon className="w-16 h-16" />
    <span className="ml-3">Central de Missões</span>
</h1>

        <div className="flex justify-end items-center mb-6">
            <label className="flex items-center cursor-pointer">
                <input
                    type="checkbox"
                    className="form-checkbox h-5 w-5 bg-stone-700 border-stone-500 text-yellow-400 focus:ring-yellow-500"
                    checked={showCompleted}
                    onChange={() => setShowCompleted(!showCompleted)}
                />
                <span className="ml-2 text-stone-300">Exibir missões concluídas</span>
            </label>
        </div>

            <div className="space-y-6">
                {Object.values(MISSIONS)
    .filter(mission => {
        // Se o checkbox estiver marcado, sempre mostra a missão.
        if (showCompleted) {
            return true;
        }
        // Se estiver desmarcado, só mostra se a missão NÃO foi concluída (claimed).
        const progress = characterData.missions?.find(m => m.id === mission.id);
        return progress?.status !== 'claimed';
    })
    .map(mission => {
                    const progress = characterData.missions?.find(m => m.id === mission.id);
                    const isLocked = characterData.level < mission.requiredLevel;
                    const isCompleted = progress?.status === 'completed';
                    const isClaimed = progress?.status === 'claimed';
                    const isActive = progress?.status === 'active';

                    let progressText = '';
                    if (isActive || isCompleted) {
                        const current = progress?.progress || 0;
                        const target = mission.objective.targetCount;
                        progressText = `(${Math.min(current, target)} / ${target})`;
                    }

                    return (
                        <div key={mission.id} className={`mu-panel p-6 ${isLocked ? 'opacity-50' : ''}`}>
                            <div className="flex justify-between items-start">
                                <div>
                                    <h2 className="text-2xl font-bold mu-title">{mission.name} {isActive && !isCompleted && progressText}</h2>
                                    {isLocked && <p className="text-red-400 font-bold">Requer Nível: {mission.requiredLevel}</p>}
                                    <p className="text-stone-400 mt-2 max-w-xl">{mission.description}</p>
                                </div>
                                <div className="text-right flex-shrink-0 ml-4">
                                    {!progress && !isLocked && (
                                        <button onClick={() => startMission(mission.id)} className="mu-button">Iniciar Missão</button>
                                    )}
                                    {isCompleted && (
                                        <button onClick={() => claimReward(mission.id)} className="mu-button bg-green-800/80 hover:bg-green-700/80 animated-border border-yellow-400">Coletar Recompensa</button>
                                    )}
                                    {isClaimed && (
                                        <p className="font-bold text-green-500">Concluída!</p>
                                    )}
                                     {isActive && !isCompleted && (
                                        <p className="font-bold text-yellow-500">Em Progresso...</p>
                                    )}
                                </div>
                            </div>
                            <div className="mt-4 pt-4 border-t border-stone-700">
                                <h4 className="font-bold text-stone-300">Recompensas:</h4>
                                <ul className="list-disc list-inside text-yellow-200">
                                    {mission.rewards.exp && <li>{mission.rewards.exp.toLocaleString()} Pontos de Experiência</li>}
                                    {mission.rewards.gold && <li>{formatGold(mission.rewards.gold)} Ouro</li>}
                                    {mission.rewards.items?.map((item, index) => (
                                        <li key={index}>{item.quantity}x {ITEM_TYPES[item.type].name}</li>
                                    ))}
                                    {mission.rewards.jewels?.map((jewel, index) => (
                                        <li key={index}>{jewel.quantity}x {ITEM_TYPES[jewel.type].name}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};


const RedirectWithNotification = ({ to, message, addNotification }) => {
    useEffect(() => {
        if (message && addNotification) {
            addNotification(message, 'error');
        }
    }, [message, addNotification]); // Executa uma vez na montagem

    return <Navigate to={to} replace />;
};


const AdminRoute = ({ characterData, children }) => {
    // Se ainda estiver carregando, não mostre nada ou um loader
    if (!characterData) {
        return <div className="text-white text-center p-10">Verificando permissões...</div>;
    }

    // Se o usuário não for admin, redireciona para a página inicial
    if (!characterData.isAdmin) {
        return <Navigate to="/" replace />;
    }

    // Se for admin, renderiza a página do painel
    return children;
};



const AppContent = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isModalContext = queryParams.get('context') === 'modal';
    const [user, setUser] = useState(null);
    const [characterData, setCharacterData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [onlinePlayers, setOnlinePlayers] = useState(0);
    const [isFriendsModalOpen, setFriendsModalOpen] = useState(false);
    const [isSaveProgressModalOpen, setSaveProgressModalOpen] = useState(false);
    const [unreadMessages, setUnreadMessages] = useState({});
    const [friendRequestCount, setFriendRequestCount] = useState(0);
    const [notifications, setNotifications] = useState([]);
    const [floatingTexts, setFloatingTexts] = useState([]);
    const [tooltip, setTooltip] = useState({ visible: false, content: null, position: { x: 0, y: 0 } });
    const [isSyncing, setIsSyncing] = useState(true);
    const [marketNotificationCount, setMarketNotificationCount] = useState(0);
    const [isMapFullScreen, setMapFullScreen] = useState(false);
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false });

// No componente App(), adicione esta função
const openConfirmationModal = (config) => {
    setConfirmationModal({
        isOpen: true,
        title: config.title,
        message: config.message,
        onConfirm: config.onConfirm,
    });
};


    const totalUnreadMessages = useMemo(() => {
    return Object.values(unreadMessages).reduce((sum, count) => sum + count, 0);
    }, [unreadMessages]);

    const showTooltip = useCallback((content, e) => {
        const position = e.touches ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : { x: e.clientX, y: e.clientY };
        setTooltip({ visible: true, content, position });
    }, []);

    const hideTooltip = useCallback(() => {
        setTooltip({ visible: false, content: null, position: { x: 0, y: 0 } });
    }, []);

    const createFloatingText = (text, type = 'gold', position) => {
        const id = Date.now() + Math.random();
        const startX = position.x;
        const startY = position.y;

        setFloatingTexts(prev => [...prev, { id, text, type, startX, startY }]);
        setTimeout(() => {
            setFloatingTexts(prev => prev.filter(t => t.id !== id));
        }, 2000);
    };

	const addNotification = useCallback((message, type = 'info', itemType = null) => {
    	const id = Date.now() + Math.random();
    	setNotifications(prev => [...prev, { id, message, type, itemType }]); // Adiciona o itemType ao objeto
    	setTimeout(() => {
        	setNotifications(prev => prev.filter(n => n.id !== id));
    	}, 5000);
	}, []);

    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    // PASSO 1: Mova a função saveData para cá
    const saveData = useCallback(async (data) => {
        if (user?.uid && data) {
            try {
                // Usamos o 'user' do estado do App, que está sempre disponível aqui
                const dataToSave = { ...data, lastUpdateTimestamp: serverTimestamp(), nextShopRefresh: data.nextShopRefresh };
                await setDoc(doc(db, "characters", user.uid), dataToSave, { merge: true });
            } catch (error) {
                console.error("Erro ao salvar dados do personagem: ", error);
            }
        }
    }, [user]); // A dependência agora é o 'user' do App
    
    // ATUALIZAÇÃO: Função de logout modificada
    const handleLogout = useCallback(async (isSessionKick = false) => {
        try {
            if (!isSessionKick) {
                sessionStorage.removeItem('gameSessionId');
            }
            await signOut(auth);

            if (isSessionKick) {
                // Adiciona uma pequena espera para garantir que a notificação apareça após a UI ser limpa
                setTimeout(() => {
                    addNotification("Acesso em um novo dispositivo. Esta sessão foi desconectada.", 'error');
                }, 100);
            }
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    }, [addNotification]);


    useEffect(() => {
        const updateOnlineCount = () => {
            const fiveMinutesAgo = Timestamp.fromDate(new Date(Date.now() - 5 * 60 * 1000));
            // CORREÇÃO: Usa o novo campo de timestamp para verificar jogadores online.
            const q = query(collection(db, "characters"), where("lastUpdateTimestamp", ">", fiveMinutesAgo));
            
            getDocs(q).then(snapshot => {
                setOnlinePlayers(snapshot.size);
            }).catch(err => console.error("Erro ao contar jogadores online:", err));
        };
    
        updateOnlineCount();
        const intervalId = setInterval(updateOnlineCount, 30000);
    
        return () => clearInterval(intervalId);
    }, []);

// ATUALIZAÇÃO CRÍTICA DE SESSÃO v2 - LÓGICA REFINADA

useEffect(() => {
    let unsubSnapshot = () => {};
    
    const unsubAuth = onAuthStateChanged(auth, (currentUser) => {
        unsubSnapshot(); // Limpa o listener do usuário anterior
        setUser(currentUser);

        if (currentUser) {
            setIsLoading(true);

            // 1. Gera um ID de sessão único para esta aba/dispositivo
            let localSessionId = sessionStorage.getItem('gameSessionId');
            if (!localSessionId) {
                localSessionId = Date.now().toString() + Math.random();
                sessionStorage.setItem('gameSessionId', localSessionId);
            }

            const docRef = doc(db, "characters", currentUser.uid);

            // 2. AÇÃO: Reivindica a sessão imediatamente.
            // Esta escrita única informa ao banco de dados que esta é a nova sessão ativa.
            setDoc(docRef, { activeSessionId: localSessionId }, { merge: true })
                .catch(err => {
                    console.error("Falha ao definir a sessão ativa. Verifique as regras do Firestore!", err);
                });

            // 3. REAÇÃO: Ouve por qualquer mudança no documento.
            unsubSnapshot = onSnapshot(docRef, (docSnap) => {
                setIsSyncing(docSnap.metadata.hasPendingWrites || docSnap.metadata.fromCache);

                if (!docSnap.exists()) {
                    setCharacterData(null);
                    setIsLoading(false);
                    return;
                }

                const data = docSnap.data();
                const dbSessionId = data.activeSessionId;

                // Se o ID no banco de dados for diferente do meu,
                // significa que outra sessão assumiu o controle.
                if (dbSessionId && dbSessionId !== localSessionId) {
                    handleLogout(true); // Desconecta esta aba.
                    return; // Interrompe a execução para não carregar dados incorretos.
                }
                
                // Se o ID for o mesmo, esta sessão é válida. Carrega os dados.
                setCharacterData(data);
                setIsLoading(false);

            }, (error) => {
                console.error("Erro no listener do personagem:", error);
                handleLogout(true);
            });

        } else {
            // Usuário deslogado, limpa tudo.
            sessionStorage.removeItem('gameSessionId');
            setCharacterData(null);
            setIsLoading(false);
            setIsSyncing(false);
        }
    });

    return () => {
        unsubAuth();
        unsubSnapshot();
    };
}, [handleLogout]);



    // COLE O NOVO BLOCO DE CÓDIGO AQUI
    // Este useEffect observa as variáveis de carregamento e contexto.
    // Quando o carregamento termina (isLoading vira false) E estamos no modal,
    // ele envia uma mensagem para a janela pai.
    useEffect(() => {
        if (isModalContext && !isLoading) {
            window.parent.postMessage('iframeContentLoaded', '*');
        }
    }, [isLoading, isModalContext]);
    // FIM DO NOVO BLOCO


    
    // Listener para mensagens não lidas
    useEffect(() => {
        if (!user || !characterData?.friends?.length) {
            setUnreadMessages({});
            return () => {};
        }
    
        const friendUids = characterData.friends.map(f => f.uid);
        const unsubscribers = friendUids.map(friendUid => {
            const chatId = getPrivateChatId(user.uid, friendUid);
            if (!chatId) return () => {};
    
            const messagesRef = collection(db, 'private_chats', chatId, 'messages');
            const q = query(messagesRef, where('to', '==', user.uid), where('read', '==', false));
            
            return onSnapshot(q, (snapshot) => {
                setUnreadMessages(prev => ({ ...prev, [friendUid]: snapshot.size }));
            }, (error) => {
                console.error(`Erro ao ouvir o chat ${chatId}:`, error);
                setUnreadMessages(prev => ({ ...prev, [friendUid]: 0 }));
            });
        });
    
        return () => {
            unsubscribers.forEach(unsub => unsub());
        };
    }, [user, characterData?.friends]);

    // Listener para contagem de pedidos de amizade
    useEffect(() => {
        if (!user) {
            setFriendRequestCount(0);
            return;
        }
        const q = query(
            collection(db, "friendRequests"),
            where("to", "==", user.uid),
            where("status", "==", "pending")
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setFriendRequestCount(snapshot.size);
        });
        return () => unsubscribe();
    }, [user]);

    // Listener para notificações de itens vendidos no mercado
    useEffect(() => {
        if (!user) {
            setMarketNotificationCount(0);
            return;
        }
        const q = query(
            collection(db, "market_listings"),
            where("sellerId", "==", user.uid)
        );
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const totalSoldCount = snapshot.docs.reduce((sum, doc) => {
                return sum + (doc.data().soldItemCount || 0);
            }, 0);
            setMarketNotificationCount(totalSoldCount);
        });

        return () => unsubscribe();
    }, [user]);


    // Listener para pedidos de amizade aceitos
    useEffect(() => {
        if (!user) return;
        const q = query(
            collection(db, "friendRequests"),
            where("from", "==", user.uid),
            where("status", "==", "accepted")
        );

        const unsubscribe = onSnapshot(q, (snapshot) => {
            if (snapshot.empty) return;

            const batch = writeBatch(db);
            const currentUserRef = doc(db, "characters", user.uid);

            snapshot.docs.forEach(requestDoc => {
                const request = requestDoc.data();
                batch.update(currentUserRef, {
                    friends: arrayUnion({ uid: request.to, name: request.toName })
                });
                batch.delete(requestDoc.ref);
            });

            batch.commit().catch(err => console.error("Erro ao finalizar amizade:", err));
        });

        return () => unsubscribe();
    }, [user]);

    // --- ATUALIZAÇÃO: Função de criação de personagem modificada para incluir a "Joia da Alma" ---
    const handleCharacterCreate = async (name, characterClass) => {
        if (!user) return;
        const nameCheckQuery = query(collection(db, "characters"), where("name", "==", name));
        const nameCheckSnapshot = await getDocs(nameCheckQuery);
        if (!nameCheckSnapshot.empty) {
            addNotification("Este nome de personagem já está em uso.", 'error');
            return;
        }
        
        const currentSessionId = sessionStorage.getItem('gameSessionId');
        const baseStats = CLASS_BASE_STATS[characterClass];
        const initialHp = Math.floor(baseStats.health / HEALTH_STAT_TO_HP_DIVISOR);
        const initialMp = Math.floor(baseStats.mana / MANA_STAT_TO_MP_DIVISOR);

        const newCharacter = {
            name: name,
            class: characterClass,
            level: 1,
            experience: 0,
            skillPoints: 0,
            gold: 100,
            deaths: 0,
            stamina: MAX_STAMINA,
            stats: baseStats,
            currentHp: initialHp,
            currentMana: initialMp,
            inventory: [],
            chest: [],
            equipment: {
                Pet: null,
                Wing: null,
                Helmet: null,
                Armor: null,
                Pants: null,
                Boots: null,
                Gloves: null,
                leftHand: null,
                rightHand: null
            },
            friends: [],
            learnedSkills: [],
            lastUpdateTimestamp: serverTimestamp(),
            shopItems: generateNewShop(1),
            nextShopRefresh: Date.now() + SHOP_REFRESH_INTERVAL,
            mapState: initializeMapState(),
            currentInvasion: null,
            missions: [],
            activeSessionId: currentSessionId,
        };
        try {
            await setDoc(doc(db, "characters", user.uid), newCharacter);
            addNotification(`Bem-vindo, ${name}! Sua aventura como ${characterClass} começa agora.`, 'success');
        } catch (error) {
            console.error("Error creating character: ", error);
            addNotification("Erro ao criar personagem.", 'error');
        }
    };


    if (isLoading) {
        return <div className="min-h-screen bg-stone-900 text-white flex items-center justify-center text-2xl">Carregando...</div>;
    }

    return (
<>
<style>{`
    @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&display=swap');
    
    /* --- ESTILOS GERAIS DA UI --- */
    body {
        color: #FFF;
        font-family: 'Cinzel', serif;
        /* A cor e imagem de fundo agora são controladas pelo vídeo ou pela HomePage */
    }

    #logo {
        margin-top: -50px;
    }

    .mu-text-shadow {
        text-shadow: 1px 1px 3px rgba(0,0,0,0.7);
    }

    .mu-title {
        font-weight: 700;
        color: #d6d3d1; /* stone-300 */
        text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
    }

    .mu-monster-title {
        font-weight: 700;
        color: #d6d3d1; /* stone-300 */
        text-shadow: 2px 2px 4px rgba(0,0,0,0.8);
        margin-bottom: -10px;
    }

/* --- ESTILOS PARA O NOVO TOOLTIP DE MONSTRO ESTILO BESTIÁRIO --- */
.monster-tooltip-container {
    /* Baseado no .mu-panel para consistência */
    background-color: rgba(12, 7, 2, 0.95);
    backdrop-filter: blur(8px);
    border: 2px solid;
    border-image: linear-gradient(to bottom, #a37c3c, #6b4f2c) 1;
    box-shadow: 0 5px 20px rgba(0,0,0,0.7);
    color: #d6d3d1; /* stone-300 */
    width: 240px; /* Um pouco mais largo para acomodar mais infos */
    padding: 0; /* Removemos o padding para ter controle total */
    border-radius: 4px;
    overflow: hidden; /* Garante que os filhos não "vazem" das bordas */
    font-family: 'Cinzel', serif;
    pointer-events: auto; /* Permite clicar no botão dentro do tooltip */
    z-index:99;
}

.monster-tooltip-header {
    background-color: rgba(0, 0, 0, 0.3);
    padding: 0.75rem;
    text-align: center;
    border-bottom: 2px solid #6b4f2c; /* Borda dourada escura */
}

.monster-tooltip-name {
    font-size: 1.25rem; /* 20px */
    font-weight: 700;
    color: #e3d1b1; /* Cor de texto dourado claro */
    text-shadow: 2px 2px 4px #000;
}

.monster-tooltip-boss-indicator {
    font-size: 0.8rem;
    font-weight: bold;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1)); /* text-red-600 */
    display: block;
    margin-top: 0.25rem;
    letter-spacing: 1px;
}

.monster-tooltip-body {
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem; /* Espaço entre as linhas de stats */
}

.monster-tooltip-stat {
    display: flex;
    justify-content: space-between;
    font-size: 0.9rem;
}

.monster-tooltip-stat span:first-child {
    font-weight: bold;
    color: #a8a29e; /* stone-400 */
}

.monster-tooltip-stat span:last-child {
    font-weight: bold;
}

.monster-tooltip-drops {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #44403c; /* stone-700 */
    font-size: 0.75rem; /* 12px */
}

.monster-tooltip-drops p {
    margin: 0;
}

.monster-tooltip-footer {
    padding: 0.75rem;
    background-color: rgba(0, 0, 0, 0.2);
    border-top: 1px solid #44403c; /* stone-700 */
}

    .mu-panel {
        background-color: rgba(28, 25, 23, 0.85); /* stone-900 with opacity */
        backdrop-filter: blur(5px);
        border: 2px solid;
        border-image: linear-gradient(to bottom, #a37c3c, #6b4f2c) 1;
        box-shadow: 0 0 15px rgba(0,0,0,0.5);
        min-height: 450px;
    }

    .confirm-modal {
        min-height: 150px !important;
    }


    .mu-panel-shop {
        background-color: rgba(28, 25, 23, 0.85); /* stone-900 with opacity */
        backdrop-filter: blur(5px);
        border: 2px solid;
        border-image: linear-gradient(to bottom, #a37c3c, #6b4f2c) 1;
        box-shadow: 0 0 15px rgba(0,0,0,0.5);
    }

    .mu-button {
        background-image: linear-gradient(to bottom, #4b371c, #3a2a12);
        border: 1px solid #7a5f31;
        color: #e3d1b1;
        font-weight: bold;
        padding: 0.5rem 1rem;
        border-radius: 2px;
        text-shadow: 1px 1px 1px #000;
        transition: all 0.2s;
        cursor: pointer;
    }
    .mu-button:hover {
        background-image: linear-gradient(to bottom, #6b4f2c, #4b371c);
        border-color: #a37c3c;
        box-shadow: 0 0 5px #a37c3c;
    }
    .mu-button:disabled {
        background-image: linear-gradient(to bottom, #444, #333);
        border-color: #555;
        color: #888;
        cursor: not-allowed;
        box-shadow: none;
    }
    .mu-button-small {
        background-image: linear-gradient(to bottom, #4b371c, #3a2a12);
        border: 1px solid #7a5f31;
        color: #e3d1b1;
        font-weight: bold;
        padding: 0.25rem 0.5rem;
        border-radius: 2px;
        text-shadow: 1px 1px 1px #000;
        transition: all 0.2s;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 0.25rem; /* 4px */
    }
    .mu-button-small:hover {
        background-image: linear-gradient(to bottom, #6b4f2c, #4b371c);
        border-color: #a37c3c;
    }
    .mu-button-small:disabled {
        background-image: linear-gradient(to bottom, #444, #333);
        border-color: #555;
        color: #888;
        cursor: not-allowed;
    }
    .mu-button-nav {
        background-color: rgba(41, 37, 36, 0.5);
        border: 1px solid #57534e;
        color: #d6d3d1;
        font-weight: bold;
        padding: 0.25rem 0.75rem;
        display: flex;
        align-items: center;
        transition: all 0.2s;
        border-radius: 2px;
    }
    .mu-button-nav:hover {
        background-color: rgba(63, 63, 70, 0.7);
        border-color: #a1a1aa;
    }
    .mu-button-nav-active {
        background-color: rgba(82, 82, 91, 0.8);
        border-color: #fef08a;
        color: #fef08a;
    }

    .mu-input {
        background-color: rgba(0,0,0,0.4);
        border: 1px solid #7a5f31;
        color: #e3d1b1;
        border-radius: 2px;
    }
    .mu-input:focus {
         outline: none;
         border-color: #a37c3c;
         box-shadow: 0 0 5px #a37c3c;
    }
    
    .mu-tab-button {
        background-color: rgba(28, 25, 23, 0.8);
        border: 1px solid #57534e;
        border-bottom: none;
        color: #a8a29e;
        padding: 0.5rem 0;
        transition: all 0.2s;
    }
    .mu-tab-button:hover {
        background-color: rgba(41, 37, 36, 0.9);
    }
    .mu-tab-button-active {
         background-color: rgba(67, 51, 30, 0.9);
         color: #fde047;
         border-color: #a27b3b;
    }

    .mu-inventory-slot {
        background-color: rgba(0,0,0,0.5);
        border: 2px solid #44403c;
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
    }
    .mu-inventory-slot:hover {
        border-color: #a37c3c;
        background-color: rgba(40,30,20,0.5);
    }

    .mu-drop-zone {
         border: 2px dashed #57534e;
         border-radius: 8px;
         display: flex;
         align-items: center;
         justify-content: center;
         transition: all 0.2s;
    }
    .mu-drop-zone-hover-purple {
        background-color: rgba(126, 34, 206, 0.3);
        border-color: #c084fc;
    }
    .mu-drop-zone-hover-red {
        background-color: rgba(220, 38, 38, 0.3);
        border-color: #f87171;
    }

    .mu-stat-button {
        background-color: #3a2a12;
        border: 1px solid #7a5f31;
        color: #e3d1b1;
        width: 1.5rem; height: 1.5rem;
        border-radius: 50%;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;
    }
     .mu-stat-button:hover {
        background-color: #6b4f2c;
        border-color: #a37c3c;
     }
     .mu-stat-button:disabled {
         background-color: #333;
         border-color: #555;
         color: #888;
     }

    .mu-notification {
        background-color: rgba(10, 5, 5, 0.85);
        backdrop-filter: blur(4px);
        border: 1px solid #7a5f31;
        border-left-width: 4px;
        border-radius: 4px;
        padding: 1rem;
        color: #e3d1b1;
        display: flex;
        align-items: center;
        text-shadow: 1px 1px 2px #000;
        box-shadow: 0 4px 15px rgba(0,0,0,0.6);
        animation: fade-slide-in 0.5s ease-out forwards;
    }

/* Adicione estas novas classes de botão ao seu bloco <style> */
.mu-button.mu-button-red {
    background-image: linear-gradient(to bottom, #991b1b, #7f1d1d); /* Cores de red-800 e red-900 */
    border-color: #fca5a5; /* red-300 */
}
.mu-button.mu-button-red:hover {
    background-image: linear-gradient(to bottom, #b91c1c, #991b1b); /* Cores de red-700 e red-800 */
    border-color: #fecaca; /* red-200 */
    box-shadow: 0 0 5px #f87171; /* red-400 */
}

.mu-button.mu-button-green {
    background-image: linear-gradient(to bottom, #166534, #14532d); /* Cores de green-800 e green-900 */
    border-color: #86efac; /* green-300 */
}
.mu-button.mu-button-green:hover {
    background-image: linear-gradient(to bottom, #15803d, #166534); /* Cores de green-700 e green-800 */
    border-color: #bbf7d0; /* green-200 */
    box-shadow: 0 0 5px #4ade80; /* green-400 */
}

/* --- ESTILOS PARA O TOOLTIP DE DROP LIST (NOVO) --- */
.drop-list-container {
    position: relative; /* Necessário para posicionar o tooltip filho */
}

.drop-list-container .drop-list-content {
    display: none; /* Esconde o tooltip por padrão */
    position: absolute;
    bottom: 120%; /* Posiciona acima do texto "Drop List" */
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(12, 7, 2, 0.95); /* Fundo escuro */
    border: 1px solid #a37c3c;
    padding: 8px;
    border-radius: 4px;
    width: 300px; /* Largura do tooltip de drop */
    z-index: 10;
    text-align: left; /* Alinha o texto à esquerda */
    pointer-events: none; /* Garante que o tooltip não interfira com outros eventos */
}

/* Mostra o tooltip de drop quando o mouse passa sobre o container */
.drop-list-container:hover .drop-list-content {
    display: block;
}


/* --- ESTILO PARA TOOLTIP DE NOME DO MONSTRO (NOVO) --- */
.monster-pin .monster-name-tooltip {
    display: none; /* Escondido por padrão */
    position: absolute;
    bottom: 100%; /* Posiciona o tooltip acima do pino do monstro */
    left: 50%;
    transform: translateX(-50%) translateY(-5px); /* Centraliza e adiciona um pequeno espaço */
    background-color: rgba(12, 7, 2, 0.9);
    color: #e3d1b1;
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 0.8rem; /* 12.8px */
    font-weight: bold;
    white-space: nowrap; /* Garante que nomes longos não quebrem a linha */
    z-index: 20;
    pointer-events: none; /* Impede que o tooltip interfira com o clique no monstro */
    transition: opacity 0.2s; /* Adiciona uma transição suave */
}

/* Mostra o tooltip quando o mouse passa sobre o pino do monstro */
.monster-pin:hover .monster-name-tooltip {
    display: block;
}



/* --- NOVO: Estilo para o Indicador de Boss --- */
.boss-indicator {
    position: absolute;
    top: -5px;
    right: -5px;
    width: 24px;  /* 1.5rem */
    height: 24px; /* 1.5rem */
    background-color: #ce1b22;
    color: #ffd200; 
    border-radius: 50%; /* Deixa o fundo circular */
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 900; /* Deixa o '!' bem grosso */
    font-size: 1rem;  /* Tamanho do '!' */
    z-index: 10;      /* Garante que fique sobre a imagem do monstro */
    box-shadow: 0 2px 5px rgba(0,0,0,0.5); /* Sombra para dar profundidade */
}


/* --- NOVOS ESTILOS PARA TELA CHEIA --- */
.map-fullscreen-button {
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    background-color: rgba(0, 0, 0, 0.4);
    border: 1px solid #a37c3c;
    border-radius: 4px;
    color: #e3d1b1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;
    z-index: 40; /* Garante que fique acima da imagem do mapa */
}
.map-fullscreen-button:hover {
    background-color: rgba(0, 0, 0, 0.7);
}
.map-fullscreen-icon {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
}

/* Estilos para o mapa em modo de tela cheia */
.fullscreen-map-container {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 50 !important; /* Deve ser maior que o botão e menor que o modal de batalha/tooltip */
    padding: 0 !important;
    border: none !important;
}

/* Ajusta o contêiner interno da imagem do mapa */
.fullscreen-map-container .map-image-container {
    height: 100% !important;
    border: none !important;
}

/* --- FIM DOS NOVOS ESTILOS --- */

    /* --- ANIMAÇÕES --- */


/* Animação de pulsação aprimorada, focada no brilho */
@keyframes pulse-monster-point {
    0%, 100% {
        box-shadow: inset 0 0 8px 3px rgba(0, 0, 0, 0.6), 0 0 8px rgba(239, 68, 68, 0.6);
        border-color: #a37c3c;
    }
    50% {
        box-shadow: inset 0 0 8px 3px rgba(0, 0, 0, 0.5), 0 0 18px rgba(239, 68, 68, 1);
        border-color: #fcd34d; /* Dourado mais brilhante no pico da animação */
    }
}

/* Estilo principal do círculo do monstro */
.monster-pin {
    /* Borda metálica que combina com os painéis do jogo */
    border: 3px solid #a37c3c;
    
    /* Sombra interna para profundidade + Brilho vermelho externo */
    box-shadow: inset 0 0 8px 3px rgba(0, 0, 0, 0.6), 0 0 8px rgba(239, 68, 68, 0.6);
    
    /* Animação de pulsação */
    animation: pulse-monster-point 2.5s infinite ease-in-out;
    
    /* Transição suave para o efeito de hover */
    transition: all 0.3s ease;
}

/* Efeito ao passar o mouse por cima */
.monster-pin:hover {
    /* Aumenta levemente o tamanho */
    transform: translate(-50%, -50%) scale(1.1) !important;
    
    /* Intensifica o brilho e a cor da borda */
    border-color: #fcd34d;
    box-shadow: inset 0 0 8px 3px rgba(0, 0, 0, 0.5), 0 0 20px 3px rgba(239, 68, 68, 1);

}

    @keyframes pulse-text {
        0%, 100% {
            opacity: 0.7;
            text-shadow: 0 0 5px rgba(52, 211, 153, 0.5);
        }
        50% {
            opacity: 1;
            text-shadow: 0 0 15px rgba(52, 211, 153, 1);
        }
    }
    .pulsing-online {
        animation: pulse-text 2.5s infinite ease-in-out;
    }
     @keyframes pulse-border { 0%, 100% { border-color: #fbbf24; box-shadow: 0 0 5px #fbbf24; } 50% { border-color: #fcd34d; box-shadow: 0 0 15px #fcd34d; } }
    @keyframes pulse-border-left { 0%, 100% { border-left-color: #fbbf24; box-shadow: 0 0 5px rgba(251, 191, 36, 0.7); } 50% { border-left-color: #fcd34d; box-shadow: 0 0 15px rgba(252, 211, 77, 0.7); } }


    .animated-border { animation: pulse-border 2s infinite ease-in-out; }
    .animated-border-left { animation: pulse-border-left 2s infinite ease-in-out; }

    @keyframes float-up {
        0% { transform: translateX(-50%) translateY(0); opacity: 1; }
        100% { transform: translateX(-50%) translateY(-60px); opacity: 0; }
    }
    .floating-text {
        position: fixed; z-index: 100; transform: translateX(-50%);
        color: #facc15; font-size: 1.5rem; font-weight: bold;
        pointer-events: none; text-shadow: 1px 1px 2px black;
        animation: float-up 2s ease-out forwards;
    }
    
    @keyframes fade-slide-in {
        from {
            transform: translateX(-100%);
            opacity: 0;
        }
         to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    /* --- ESTILOS PARA A HOME PAGE --- */

.home-background-blurry {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('/images/bg-home.jpg');
    background-size: cover;
    background-position: center;
    filter: blur(2px); /* <-- A MÁGICA ACONTECE AQUI */
    transform: scale(1.05); /* Evita bordas transparentes causadas pelo blur */
    z-index: -2; /* Garante que fique atrás de tudo, até do overlay */
}

.home-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    //background-color: rgba(0,0,0,0.6);
    z-index: -1; /* O z-index do overlay deve ser maior que o do background */
}

    .home-header {
        width: 100%;
        height: 400px;
        background-image: url('/images/home-header-bg.jpg');
        background-size: cover;
        background-position: center;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-bottom: 4px solid #a37c3c;
    }

    .home-nav-bar {
        width: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        border-top: 2px solid #a37c3c;
        padding: 0.25rem 0;
        display: flex;
        justify-content: center;
	z-index: 2;
    }

    .home-nav {
        display: flex;
        gap: 1.5rem;
    }

    .home-nav-link {
        background: none;
        border: none;
        font-family: inherit;
        color: #d6d3d1;
        font-size: 1.25rem;
        font-weight: 700;
        text-shadow: 2px 2px 4px #000;
        transition: all 0.3s;
        padding: 0.5rem 1.5rem;
        border-radius: 4px;
        cursor: pointer;
    }

    .home-nav-link:hover {
        color: #fde047;
        text-shadow: 2px 2px 6px #fde047;
        background-color: rgba(122, 95, 49, 0.3);
    }
    
    .home-main-content {
        max-width: 1200px;
        margin: 2rem auto;
        padding: 0 2rem;
        display: grid;
        grid-template-columns: 300px 1fr 300px;
        gap: 1.5rem;
    }

    .home-panel, .home-panel-center, .home-panel-right {
        background-color: rgba(12, 7, 2, 0.7);
        border: 2px solid #6b4f2c;
        padding: 1rem;
    }

    .home-panel-title {
        background-color: #3a2a12;
        color: #e3d1b1;
        padding: 0.5rem;
        margin: -1rem -1rem 1rem -1rem;
        text-align: center;
        font-weight: bold;
        border-bottom: 2px solid #6b4f2c;
    }

    .home-news-item {
        display: flex;
        gap: 1rem;
        margin-bottom: 1rem;
    }

    .home-news-image {
        width: 80px;
        height: 60px;
        object-fit: cover;
        border: 1px solid #7a5f31;
    }

    .home-news-text h3 {
        font-weight: bold;
        color: #e3d1b1;
    }

    .home-news-text p {
        font-size: 0.8rem;
        color: #a8a29e;
    }

    .read-more {
        display: block;
        text-align: right;
        color: #a37c3c;
        font-weight: bold;
        text-decoration: none;
        /* Reset de botão */
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;
    }
    .read-more:hover {
        text-decoration: underline;
    }

    .play-now-button {
	display: block;
    	background-image: linear-gradient(to bottom, #ff9c00, #411c00);
    	color: #e5e5e5;
   	text-align: center;
    	font-size: 2.5rem;
   	font-weight: bold;
  	padding: 1.5rem 0;
  	border: 2px solid #fd9a00;
  	text-shadow: 2px 2px 4px #000;
  	margin-bottom: 1.5rem;
  	transition: all 0.3s;
    }
    .play-now-button:hover {
        box-shadow: 0 0 20px #fd9700;
        border-color: #fd9700;
    }

    .logo-home {
        margin-top: -10px;
    }

    .home-panel-center {
        margin-bottom: 1.5rem;
    }

    .home-panel-title-center {
        color: #e3d1b1;
        font-weight: bold;
        border-bottom: 1px solid #7a5f31;
        padding-bottom: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .home-panel-center p {
        margin-left: -1.5rem;
        color: #d6d3d1;
    }

    .home-panel-center ul {
        list-style-type: '• ';
        padding-left: 1.5rem;
        color: #d6d3d1;
    }

    .home-panel-right {
        margin-bottom: 1.5rem;
    }

    .home-panel-title-right {
        background-color: #3a2a12;
        color: #e3d1b1;
        padding: 0.5rem;
        margin: -1rem -1rem 1rem -1rem;
        text-align: center;
        font-weight: bold;
        border-bottom: 2px solid #6b4f2c;
    }

    .home-account-button {
        display: block;
        width: 100%;
        text-align: center;
        background-color: #3a2a12;
        border: 1px solid #7a5f31;
        color: #e3d1b1;
        padding: 0.75rem 0;
        margin-bottom: 0.75rem;
        font-weight: bold;
        transition: all 0.2s;
        /* Reset de botão */
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;
    }
    .home-account-button:hover {
        background-color: #4b371c;
        border-color: #a37c3c;
    }

    .top-players-list {
        list-style-type: none;
	font-size: 15px;
        padding: 0;
    }

    .top-players-list li {
        color: #d6d3d1;
        margin-bottom: 0.5rem;
    }

    .top-players-list li span {
        font-weight: bold;
        color: #e3d1b1;
        margin-right: 0.5rem;
    }
    .boxBattle {
	max-height: 90px;
    }
    .chatFriend {
	max-height: 500px;
    }
    .notification {
	padding-left: 20px;
	padding-bottom: 20px;
	min-width: 380px;
    }

/* Estiliza a barra de rolagem */
::-webkit-scrollbar {
  width: 5px; /* Largura da barra */
}

/* Fundo da barra de rolagem */
::-webkit-scrollbar-track {
  background: #030100; /* Cor do fundo */
  border-radius: 5px; /* Bordas arredondadas */
}

/* Cor do "polegar" da barra de rolagem */
::-webkit-scrollbar-thumb {
  background: #7c5d31; /* Cor do polegar */
  border-radius: 5px; /* Bordas arredondadas */
}

/* Cor do polegar ao passar o mouse */
::-webkit-scrollbar-thumb:hover {
  background: #a27b3c; /* Cor ao passar o mouse */
}

`}</style>


{!isMapFullScreen && 
    <ConfirmationModal modalState={confirmationModal} setModalState={setConfirmationModal} />
}

            {!isMapFullScreen && <NotificationContainer notifications={notifications} onRemove={removeNotification} />}

            <div className="min-h-screen">
                {/* --- ATUALIZAÇÃO: VÍDEO DE FUNDO PARA USUÁRIOS LOGADOS --- */}
                {user && characterData && (
                    <>
                        <video
                            autoPlay
                            loop
                            muted
                            poster="/images/bg-home.jpg"
                            className="fixed top-1/2 left-1/2 min-w-full min-h-full -translate-x-1/2 -translate-y-1/2 object-cover z-[-2]"
                        >
                            <source src="/videos/wowo-home-video-bg.mp4" type="video/mp4" />
                            Seu navegador não suporta a tag de vídeo.
                        </video>
                        <div className="fixed top-0 left-0 right-0 bottom-0 bg-black/60 z-[-1]"></div>
                    </>
                )}
                
                <Tooltip content={tooltip.content} position={tooltip.position} />
                {floatingTexts.map(ft => (
                    <div key={ft.id} className="floating-text" style={{ left: `${ft.startX}px`, top: `${ft.startY}px` }}>
                        {ft.text}
                    </div>
                 ))}
                <SaveProgressModal
                    isOpen={isSaveProgressModalOpen}
                    onClose={() => setSaveProgressModalOpen(false)}
                    onSaveSuccess={() => {
                        addNotification("Progresso salvo com sucesso! Sua conta agora é permanente.", "success");
                    }}
                />
                {!user ? (
                 <Routes>
                    <Route path="/login" element={<LoginScreen />} />
                    <Route path="*" element={<HomePage />} />
                </Routes>
            ) : (
                <>
                    <Header
    			 handleLogout={handleLogout}
    			 user={user}
     			 onlinePlayers={onlinePlayers}
    			 setFriendsModalOpen={setFriendsModalOpen}
    			 friendRequestCount={friendRequestCount}
   			 unreadMessageCount={totalUnreadMessages}
   			 setSaveProgressModalOpen={setSaveProgressModalOpen}
   			 characterData={characterData}
   			 showTooltip={showTooltip}
   			 hideTooltip={hideTooltip}
   			 isSyncing={isSyncing} 
            		 marketNotificationCount={marketNotificationCount}
    			 saveData={saveData} 
    			 isModalContext={isModalContext} 
			/>
                    {characterData && characterData.name && !user.isAnonymous && (
                        <FriendsModal
                            isOpen={isFriendsModalOpen}
                            closeModal={() => setFriendsModalOpen(false)}
                            characterData={characterData}
                            userId={user.uid}
                            unreadMessages={unreadMessages}
                            friendRequestCount={friendRequestCount}
                            addMessage={addNotification}
                         />
                    )}
                    {/* --- ATUALIZAÇÃO: Roteamento principal com a nova página de perfil --- */}
                    <Routes>

<Route
        path="/admin"
        element={
            <AdminRoute characterData={characterData}>
                <AdminPanel characterData={characterData} />
            </AdminRoute>
        }
    />

                        <Route path="/ranking" element={<RankingPage />} />

    {/* ADICIONE A NOVA ROTA AQUI */}
    <Route
        path="/missoes"
        element={
            characterData && characterData.name ? (
                <MissionsPage
                    characterData={characterData}
                    userId={user.uid}
                    addMessage={addNotification}
                    saveData={async (data) => {
                        if (user?.uid && data) {
                            try {
                                await setDoc(doc(db, "characters", user.uid), data, { merge: true });
                            } catch (error) { console.error("Erro ao salvar dados:", error); }
                        }
                    }}
                />
            ) : (
                <CharacterCreation onCharacterCreate={handleCharacterCreate} />
            )
        }
    />

                    <Route
                        path="/invasoes"
                        element={
                            characterData && characterData.name ? (
                                <InvasionPage
                                    characterData={characterData}
                                    saveData={async (data) => {
                                        if (user?.uid && data) {
                                            try {
                                                await setDoc(doc(db, "characters", user.uid), data, { merge: true });
                                            } catch (error) {
                                                console.error("Erro ao salvar dados:", error);
                                            }
                                        }
                                    }}
                                    addMessage={addNotification}
                                    userId={user.uid}
                                />
                            ) : (
                                <CharacterCreation onCharacterCreate={handleCharacterCreate} />
                            )
                        }
                    />
                        
                        {/* Nova rota de Perfil */}
                        <Route
                            path="/profile/:userId"
                            element={
                                characterData && characterData.name ? (
                                    <ProfilePage />
                                ) : (
                                    <CharacterCreation onCharacterCreate={handleCharacterCreate} />
                                )
                            }
                        />

                        <Route
                            path="/mercado"
                            element={
                                characterData && characterData.name ? (
                                    characterData.level >= MARKET_MIN_LEVEL ? (
                                        <MarketPage
                                            characterData={characterData}
                                            userId={user.uid}
                                            setCharacterData={setCharacterData}
                                            addMessage={addNotification}
                                            createFloatingText={createFloatingText}
                                            isMapFullScreen={isMapFullScreen} // <-- ADICIONE ESTA LINHA

                                        />
                                    ) : (
                                        <RedirectWithNotification 
                                            to="/" 
                                            message={`Você precisa ser nível ${MARKET_MIN_LEVEL} para acessar o Mercado.`} 
                                            addNotification={addNotification} 
                                        />
                                    )
                                ) : (
                                    <CharacterCreation onCharacterCreate={handleCharacterCreate} />
                                )
                            }
                        />
<Route
    path="/*"
    element={
        isLoading ? (
            // 1. Enquanto estiver carregando, mostre a tela de carregamento.
            // Isso cobre tanto a autenticação quanto a busca inicial de dados.
            <div className="min-h-screen bg-stone-900 text-white flex items-center justify-center text-2xl">Carregando...</div>
        ) : characterData && characterData.name ? (
            // 2. Se o carregamento terminou E temos um personagem válido, mostre o jogo.
            <GameUI
                characterData={characterData}
                setCharacterData={setCharacterData}
                userId={user.uid}
                createFloatingText={createFloatingText}
                showTooltip={showTooltip}
                hideTooltip={hideTooltip}
                addMessage={addNotification}
                saveData={saveData}
                notifications={notifications}
                onRemove={removeNotification}
                onFullScreenChange={setMapFullScreen}
                openConfirmationModal={openConfirmationModal}
                confirmationModal={confirmationModal}
                setConfirmationModal={setConfirmationModal}
                tooltip={tooltip}
            />
        ) : (
            // 3. Se o carregamento terminou, mas não há um personagem válido, mostre a tela de criação.
            <CharacterCreation onCharacterCreate={handleCharacterCreate} />
        )
    }
/>
                    </Routes>
                </>
            )}
</div>
                </>
            );
        };
        
        // 2. O componente App principal agora se torna muito simples:
        export default function App() {
            return (
                <BrowserRouter>
                    <AppContent />
                </BrowserRouter>
            );
        }